/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import $protobuf from "protobufjs/minimal.js";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const breacher = $root.breacher = (() => {

    /**
     * Namespace breacher.
     * @exports breacher
     * @namespace
     */
    const breacher = {};

    breacher.v2 = (function() {

        /**
         * Namespace v2.
         * @memberof breacher
         * @namespace
         */
        const v2 = {};

        v2.WireNull = (function() {

            /**
             * Properties of a WireNull.
             * @memberof breacher.v2
             * @interface IWireNull
             */

            /**
             * Constructs a new WireNull.
             * @memberof breacher.v2
             * @classdesc Represents a WireNull.
             * @implements IWireNull
             * @constructor
             * @param {breacher.v2.IWireNull=} [properties] Properties to set
             */
            function WireNull(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new WireNull instance using the specified properties.
             * @function create
             * @memberof breacher.v2.WireNull
             * @static
             * @param {breacher.v2.IWireNull=} [properties] Properties to set
             * @returns {breacher.v2.WireNull} WireNull instance
             */
            WireNull.create = function create(properties) {
                return new WireNull(properties);
            };

            /**
             * Encodes the specified WireNull message. Does not implicitly {@link breacher.v2.WireNull.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.WireNull
             * @static
             * @param {breacher.v2.IWireNull} message WireNull message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WireNull.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified WireNull message, length delimited. Does not implicitly {@link breacher.v2.WireNull.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.WireNull
             * @static
             * @param {breacher.v2.IWireNull} message WireNull message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WireNull.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a WireNull message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.WireNull
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.WireNull} WireNull
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WireNull.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.WireNull();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a WireNull message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.WireNull
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.WireNull} WireNull
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WireNull.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a WireNull message.
             * @function verify
             * @memberof breacher.v2.WireNull
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            WireNull.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a WireNull message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.WireNull
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.WireNull} WireNull
             */
            WireNull.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.WireNull)
                    return object;
                return new $root.breacher.v2.WireNull();
            };

            /**
             * Creates a plain object from a WireNull message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.WireNull
             * @static
             * @param {breacher.v2.WireNull} message WireNull
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            WireNull.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this WireNull to JSON.
             * @function toJSON
             * @memberof breacher.v2.WireNull
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            WireNull.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for WireNull
             * @function getTypeUrl
             * @memberof breacher.v2.WireNull
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            WireNull.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.WireNull";
            };

            return WireNull;
        })();

        v2.WireList = (function() {

            /**
             * Properties of a WireList.
             * @memberof breacher.v2
             * @interface IWireList
             * @property {Array.<breacher.v2.IWireValue>|null} [values] WireList values
             */

            /**
             * Constructs a new WireList.
             * @memberof breacher.v2
             * @classdesc Represents a WireList.
             * @implements IWireList
             * @constructor
             * @param {breacher.v2.IWireList=} [properties] Properties to set
             */
            function WireList(properties) {
                this.values = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * WireList values.
             * @member {Array.<breacher.v2.IWireValue>} values
             * @memberof breacher.v2.WireList
             * @instance
             */
            WireList.prototype.values = $util.emptyArray;

            /**
             * Creates a new WireList instance using the specified properties.
             * @function create
             * @memberof breacher.v2.WireList
             * @static
             * @param {breacher.v2.IWireList=} [properties] Properties to set
             * @returns {breacher.v2.WireList} WireList instance
             */
            WireList.create = function create(properties) {
                return new WireList(properties);
            };

            /**
             * Encodes the specified WireList message. Does not implicitly {@link breacher.v2.WireList.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.WireList
             * @static
             * @param {breacher.v2.IWireList} message WireList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WireList.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.values != null && message.values.length)
                    for (let i = 0; i < message.values.length; ++i)
                        $root.breacher.v2.WireValue.encode(message.values[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified WireList message, length delimited. Does not implicitly {@link breacher.v2.WireList.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.WireList
             * @static
             * @param {breacher.v2.IWireList} message WireList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WireList.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a WireList message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.WireList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.WireList} WireList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WireList.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.WireList();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.values && message.values.length))
                                message.values = [];
                            message.values.push($root.breacher.v2.WireValue.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a WireList message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.WireList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.WireList} WireList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WireList.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a WireList message.
             * @function verify
             * @memberof breacher.v2.WireList
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            WireList.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.values != null && message.hasOwnProperty("values")) {
                    if (!Array.isArray(message.values))
                        return "values: array expected";
                    for (let i = 0; i < message.values.length; ++i) {
                        let error = $root.breacher.v2.WireValue.verify(message.values[i]);
                        if (error)
                            return "values." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a WireList message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.WireList
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.WireList} WireList
             */
            WireList.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.WireList)
                    return object;
                let message = new $root.breacher.v2.WireList();
                if (object.values) {
                    if (!Array.isArray(object.values))
                        throw TypeError(".breacher.v2.WireList.values: array expected");
                    message.values = [];
                    for (let i = 0; i < object.values.length; ++i) {
                        if (typeof object.values[i] !== "object")
                            throw TypeError(".breacher.v2.WireList.values: object expected");
                        message.values[i] = $root.breacher.v2.WireValue.fromObject(object.values[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a WireList message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.WireList
             * @static
             * @param {breacher.v2.WireList} message WireList
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            WireList.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.values = [];
                if (message.values && message.values.length) {
                    object.values = [];
                    for (let j = 0; j < message.values.length; ++j)
                        object.values[j] = $root.breacher.v2.WireValue.toObject(message.values[j], options);
                }
                return object;
            };

            /**
             * Converts this WireList to JSON.
             * @function toJSON
             * @memberof breacher.v2.WireList
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            WireList.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for WireList
             * @function getTypeUrl
             * @memberof breacher.v2.WireList
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            WireList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.WireList";
            };

            return WireList;
        })();

        v2.WireObject = (function() {

            /**
             * Properties of a WireObject.
             * @memberof breacher.v2
             * @interface IWireObject
             * @property {Object.<string,breacher.v2.IWireValue>|null} [fields] WireObject fields
             */

            /**
             * Constructs a new WireObject.
             * @memberof breacher.v2
             * @classdesc Represents a WireObject.
             * @implements IWireObject
             * @constructor
             * @param {breacher.v2.IWireObject=} [properties] Properties to set
             */
            function WireObject(properties) {
                this.fields = {};
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * WireObject fields.
             * @member {Object.<string,breacher.v2.IWireValue>} fields
             * @memberof breacher.v2.WireObject
             * @instance
             */
            WireObject.prototype.fields = $util.emptyObject;

            /**
             * Creates a new WireObject instance using the specified properties.
             * @function create
             * @memberof breacher.v2.WireObject
             * @static
             * @param {breacher.v2.IWireObject=} [properties] Properties to set
             * @returns {breacher.v2.WireObject} WireObject instance
             */
            WireObject.create = function create(properties) {
                return new WireObject(properties);
            };

            /**
             * Encodes the specified WireObject message. Does not implicitly {@link breacher.v2.WireObject.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.WireObject
             * @static
             * @param {breacher.v2.IWireObject} message WireObject message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WireObject.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.fields != null && Object.hasOwnProperty.call(message, "fields"))
                    for (let keys = Object.keys(message.fields), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.breacher.v2.WireValue.encode(message.fields[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified WireObject message, length delimited. Does not implicitly {@link breacher.v2.WireObject.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.WireObject
             * @static
             * @param {breacher.v2.IWireObject} message WireObject message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WireObject.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a WireObject message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.WireObject
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.WireObject} WireObject
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WireObject.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.WireObject(), key, value;
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (message.fields === $util.emptyObject)
                                message.fields = {};
                            let end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = null;
                            while (reader.pos < end2) {
                                let tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = $root.breacher.v2.WireValue.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.fields[key] = value;
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a WireObject message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.WireObject
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.WireObject} WireObject
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WireObject.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a WireObject message.
             * @function verify
             * @memberof breacher.v2.WireObject
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            WireObject.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.fields != null && message.hasOwnProperty("fields")) {
                    if (!$util.isObject(message.fields))
                        return "fields: object expected";
                    let key = Object.keys(message.fields);
                    for (let i = 0; i < key.length; ++i) {
                        let error = $root.breacher.v2.WireValue.verify(message.fields[key[i]]);
                        if (error)
                            return "fields." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a WireObject message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.WireObject
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.WireObject} WireObject
             */
            WireObject.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.WireObject)
                    return object;
                let message = new $root.breacher.v2.WireObject();
                if (object.fields) {
                    if (typeof object.fields !== "object")
                        throw TypeError(".breacher.v2.WireObject.fields: object expected");
                    message.fields = {};
                    for (let keys = Object.keys(object.fields), i = 0; i < keys.length; ++i) {
                        if (typeof object.fields[keys[i]] !== "object")
                            throw TypeError(".breacher.v2.WireObject.fields: object expected");
                        message.fields[keys[i]] = $root.breacher.v2.WireValue.fromObject(object.fields[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a WireObject message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.WireObject
             * @static
             * @param {breacher.v2.WireObject} message WireObject
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            WireObject.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.objects || options.defaults)
                    object.fields = {};
                let keys2;
                if (message.fields && (keys2 = Object.keys(message.fields)).length) {
                    object.fields = {};
                    for (let j = 0; j < keys2.length; ++j)
                        object.fields[keys2[j]] = $root.breacher.v2.WireValue.toObject(message.fields[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this WireObject to JSON.
             * @function toJSON
             * @memberof breacher.v2.WireObject
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            WireObject.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for WireObject
             * @function getTypeUrl
             * @memberof breacher.v2.WireObject
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            WireObject.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.WireObject";
            };

            return WireObject;
        })();

        v2.WireValue = (function() {

            /**
             * Properties of a WireValue.
             * @memberof breacher.v2
             * @interface IWireValue
             * @property {breacher.v2.IWireNull|null} [nullValue] WireValue nullValue
             * @property {number|Long|null} [intValue] WireValue intValue
             * @property {number|null} [doubleValue] WireValue doubleValue
             * @property {string|null} [stringValue] WireValue stringValue
             * @property {boolean|null} [boolValue] WireValue boolValue
             * @property {Uint8Array|null} [bytesValue] WireValue bytesValue
             * @property {breacher.v2.IWireList|null} [listValue] WireValue listValue
             * @property {breacher.v2.IWireObject|null} [objectValue] WireValue objectValue
             */

            /**
             * Constructs a new WireValue.
             * @memberof breacher.v2
             * @classdesc Represents a WireValue.
             * @implements IWireValue
             * @constructor
             * @param {breacher.v2.IWireValue=} [properties] Properties to set
             */
            function WireValue(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * WireValue nullValue.
             * @member {breacher.v2.IWireNull|null|undefined} nullValue
             * @memberof breacher.v2.WireValue
             * @instance
             */
            WireValue.prototype.nullValue = null;

            /**
             * WireValue intValue.
             * @member {number|Long|null|undefined} intValue
             * @memberof breacher.v2.WireValue
             * @instance
             */
            WireValue.prototype.intValue = null;

            /**
             * WireValue doubleValue.
             * @member {number|null|undefined} doubleValue
             * @memberof breacher.v2.WireValue
             * @instance
             */
            WireValue.prototype.doubleValue = null;

            /**
             * WireValue stringValue.
             * @member {string|null|undefined} stringValue
             * @memberof breacher.v2.WireValue
             * @instance
             */
            WireValue.prototype.stringValue = null;

            /**
             * WireValue boolValue.
             * @member {boolean|null|undefined} boolValue
             * @memberof breacher.v2.WireValue
             * @instance
             */
            WireValue.prototype.boolValue = null;

            /**
             * WireValue bytesValue.
             * @member {Uint8Array|null|undefined} bytesValue
             * @memberof breacher.v2.WireValue
             * @instance
             */
            WireValue.prototype.bytesValue = null;

            /**
             * WireValue listValue.
             * @member {breacher.v2.IWireList|null|undefined} listValue
             * @memberof breacher.v2.WireValue
             * @instance
             */
            WireValue.prototype.listValue = null;

            /**
             * WireValue objectValue.
             * @member {breacher.v2.IWireObject|null|undefined} objectValue
             * @memberof breacher.v2.WireValue
             * @instance
             */
            WireValue.prototype.objectValue = null;

            // OneOf field names bound to virtual getters and setters
            let $oneOfFields;

            /**
             * WireValue kind.
             * @member {"nullValue"|"intValue"|"doubleValue"|"stringValue"|"boolValue"|"bytesValue"|"listValue"|"objectValue"|undefined} kind
             * @memberof breacher.v2.WireValue
             * @instance
             */
            Object.defineProperty(WireValue.prototype, "kind", {
                get: $util.oneOfGetter($oneOfFields = ["nullValue", "intValue", "doubleValue", "stringValue", "boolValue", "bytesValue", "listValue", "objectValue"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new WireValue instance using the specified properties.
             * @function create
             * @memberof breacher.v2.WireValue
             * @static
             * @param {breacher.v2.IWireValue=} [properties] Properties to set
             * @returns {breacher.v2.WireValue} WireValue instance
             */
            WireValue.create = function create(properties) {
                return new WireValue(properties);
            };

            /**
             * Encodes the specified WireValue message. Does not implicitly {@link breacher.v2.WireValue.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.WireValue
             * @static
             * @param {breacher.v2.IWireValue} message WireValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WireValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.nullValue != null && Object.hasOwnProperty.call(message, "nullValue"))
                    $root.breacher.v2.WireNull.encode(message.nullValue, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.intValue != null && Object.hasOwnProperty.call(message, "intValue"))
                    writer.uint32(/* id 2, wireType 0 =*/16).sint64(message.intValue);
                if (message.doubleValue != null && Object.hasOwnProperty.call(message, "doubleValue"))
                    writer.uint32(/* id 3, wireType 1 =*/25).double(message.doubleValue);
                if (message.stringValue != null && Object.hasOwnProperty.call(message, "stringValue"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.stringValue);
                if (message.boolValue != null && Object.hasOwnProperty.call(message, "boolValue"))
                    writer.uint32(/* id 5, wireType 0 =*/40).bool(message.boolValue);
                if (message.bytesValue != null && Object.hasOwnProperty.call(message, "bytesValue"))
                    writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.bytesValue);
                if (message.listValue != null && Object.hasOwnProperty.call(message, "listValue"))
                    $root.breacher.v2.WireList.encode(message.listValue, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.objectValue != null && Object.hasOwnProperty.call(message, "objectValue"))
                    $root.breacher.v2.WireObject.encode(message.objectValue, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified WireValue message, length delimited. Does not implicitly {@link breacher.v2.WireValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.WireValue
             * @static
             * @param {breacher.v2.IWireValue} message WireValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WireValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a WireValue message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.WireValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.WireValue} WireValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WireValue.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.WireValue();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.nullValue = $root.breacher.v2.WireNull.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.intValue = reader.sint64();
                            break;
                        }
                    case 3: {
                            message.doubleValue = reader.double();
                            break;
                        }
                    case 4: {
                            message.stringValue = reader.string();
                            break;
                        }
                    case 5: {
                            message.boolValue = reader.bool();
                            break;
                        }
                    case 6: {
                            message.bytesValue = reader.bytes();
                            break;
                        }
                    case 7: {
                            message.listValue = $root.breacher.v2.WireList.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.objectValue = $root.breacher.v2.WireObject.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a WireValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.WireValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.WireValue} WireValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WireValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a WireValue message.
             * @function verify
             * @memberof breacher.v2.WireValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            WireValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                let properties = {};
                if (message.nullValue != null && message.hasOwnProperty("nullValue")) {
                    properties.kind = 1;
                    {
                        let error = $root.breacher.v2.WireNull.verify(message.nullValue);
                        if (error)
                            return "nullValue." + error;
                    }
                }
                if (message.intValue != null && message.hasOwnProperty("intValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    if (!$util.isInteger(message.intValue) && !(message.intValue && $util.isInteger(message.intValue.low) && $util.isInteger(message.intValue.high)))
                        return "intValue: integer|Long expected";
                }
                if (message.doubleValue != null && message.hasOwnProperty("doubleValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    if (typeof message.doubleValue !== "number")
                        return "doubleValue: number expected";
                }
                if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    if (!$util.isString(message.stringValue))
                        return "stringValue: string expected";
                }
                if (message.boolValue != null && message.hasOwnProperty("boolValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    if (typeof message.boolValue !== "boolean")
                        return "boolValue: boolean expected";
                }
                if (message.bytesValue != null && message.hasOwnProperty("bytesValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    if (!(message.bytesValue && typeof message.bytesValue.length === "number" || $util.isString(message.bytesValue)))
                        return "bytesValue: buffer expected";
                }
                if (message.listValue != null && message.hasOwnProperty("listValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    {
                        let error = $root.breacher.v2.WireList.verify(message.listValue);
                        if (error)
                            return "listValue." + error;
                    }
                }
                if (message.objectValue != null && message.hasOwnProperty("objectValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    {
                        let error = $root.breacher.v2.WireObject.verify(message.objectValue);
                        if (error)
                            return "objectValue." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a WireValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.WireValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.WireValue} WireValue
             */
            WireValue.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.WireValue)
                    return object;
                let message = new $root.breacher.v2.WireValue();
                if (object.nullValue != null) {
                    if (typeof object.nullValue !== "object")
                        throw TypeError(".breacher.v2.WireValue.nullValue: object expected");
                    message.nullValue = $root.breacher.v2.WireNull.fromObject(object.nullValue);
                }
                if (object.intValue != null)
                    if ($util.Long)
                        (message.intValue = $util.Long.fromValue(object.intValue)).unsigned = false;
                    else if (typeof object.intValue === "string")
                        message.intValue = parseInt(object.intValue, 10);
                    else if (typeof object.intValue === "number")
                        message.intValue = object.intValue;
                    else if (typeof object.intValue === "object")
                        message.intValue = new $util.LongBits(object.intValue.low >>> 0, object.intValue.high >>> 0).toNumber();
                if (object.doubleValue != null)
                    message.doubleValue = Number(object.doubleValue);
                if (object.stringValue != null)
                    message.stringValue = String(object.stringValue);
                if (object.boolValue != null)
                    message.boolValue = Boolean(object.boolValue);
                if (object.bytesValue != null)
                    if (typeof object.bytesValue === "string")
                        $util.base64.decode(object.bytesValue, message.bytesValue = $util.newBuffer($util.base64.length(object.bytesValue)), 0);
                    else if (object.bytesValue.length >= 0)
                        message.bytesValue = object.bytesValue;
                if (object.listValue != null) {
                    if (typeof object.listValue !== "object")
                        throw TypeError(".breacher.v2.WireValue.listValue: object expected");
                    message.listValue = $root.breacher.v2.WireList.fromObject(object.listValue);
                }
                if (object.objectValue != null) {
                    if (typeof object.objectValue !== "object")
                        throw TypeError(".breacher.v2.WireValue.objectValue: object expected");
                    message.objectValue = $root.breacher.v2.WireObject.fromObject(object.objectValue);
                }
                return message;
            };

            /**
             * Creates a plain object from a WireValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.WireValue
             * @static
             * @param {breacher.v2.WireValue} message WireValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            WireValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (message.nullValue != null && message.hasOwnProperty("nullValue")) {
                    object.nullValue = $root.breacher.v2.WireNull.toObject(message.nullValue, options);
                    if (options.oneofs)
                        object.kind = "nullValue";
                }
                if (message.intValue != null && message.hasOwnProperty("intValue")) {
                    if (typeof message.intValue === "number")
                        object.intValue = options.longs === String ? String(message.intValue) : message.intValue;
                    else
                        object.intValue = options.longs === String ? $util.Long.prototype.toString.call(message.intValue) : options.longs === Number ? new $util.LongBits(message.intValue.low >>> 0, message.intValue.high >>> 0).toNumber() : message.intValue;
                    if (options.oneofs)
                        object.kind = "intValue";
                }
                if (message.doubleValue != null && message.hasOwnProperty("doubleValue")) {
                    object.doubleValue = options.json && !isFinite(message.doubleValue) ? String(message.doubleValue) : message.doubleValue;
                    if (options.oneofs)
                        object.kind = "doubleValue";
                }
                if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
                    object.stringValue = message.stringValue;
                    if (options.oneofs)
                        object.kind = "stringValue";
                }
                if (message.boolValue != null && message.hasOwnProperty("boolValue")) {
                    object.boolValue = message.boolValue;
                    if (options.oneofs)
                        object.kind = "boolValue";
                }
                if (message.bytesValue != null && message.hasOwnProperty("bytesValue")) {
                    object.bytesValue = options.bytes === String ? $util.base64.encode(message.bytesValue, 0, message.bytesValue.length) : options.bytes === Array ? Array.prototype.slice.call(message.bytesValue) : message.bytesValue;
                    if (options.oneofs)
                        object.kind = "bytesValue";
                }
                if (message.listValue != null && message.hasOwnProperty("listValue")) {
                    object.listValue = $root.breacher.v2.WireList.toObject(message.listValue, options);
                    if (options.oneofs)
                        object.kind = "listValue";
                }
                if (message.objectValue != null && message.hasOwnProperty("objectValue")) {
                    object.objectValue = $root.breacher.v2.WireObject.toObject(message.objectValue, options);
                    if (options.oneofs)
                        object.kind = "objectValue";
                }
                return object;
            };

            /**
             * Converts this WireValue to JSON.
             * @function toJSON
             * @memberof breacher.v2.WireValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            WireValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for WireValue
             * @function getTypeUrl
             * @memberof breacher.v2.WireValue
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            WireValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.WireValue";
            };

            return WireValue;
        })();

        v2.WireError = (function() {

            /**
             * Properties of a WireError.
             * @memberof breacher.v2
             * @interface IWireError
             * @property {string|null} [code] WireError code
             * @property {string|null} [message] WireError message
             * @property {number|null} [status] WireError status
             * @property {boolean|null} [retryable] WireError retryable
             */

            /**
             * Constructs a new WireError.
             * @memberof breacher.v2
             * @classdesc Represents a WireError.
             * @implements IWireError
             * @constructor
             * @param {breacher.v2.IWireError=} [properties] Properties to set
             */
            function WireError(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * WireError code.
             * @member {string} code
             * @memberof breacher.v2.WireError
             * @instance
             */
            WireError.prototype.code = "";

            /**
             * WireError message.
             * @member {string} message
             * @memberof breacher.v2.WireError
             * @instance
             */
            WireError.prototype.message = "";

            /**
             * WireError status.
             * @member {number} status
             * @memberof breacher.v2.WireError
             * @instance
             */
            WireError.prototype.status = 0;

            /**
             * WireError retryable.
             * @member {boolean} retryable
             * @memberof breacher.v2.WireError
             * @instance
             */
            WireError.prototype.retryable = false;

            /**
             * Creates a new WireError instance using the specified properties.
             * @function create
             * @memberof breacher.v2.WireError
             * @static
             * @param {breacher.v2.IWireError=} [properties] Properties to set
             * @returns {breacher.v2.WireError} WireError instance
             */
            WireError.create = function create(properties) {
                return new WireError(properties);
            };

            /**
             * Encodes the specified WireError message. Does not implicitly {@link breacher.v2.WireError.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.WireError
             * @static
             * @param {breacher.v2.IWireError} message WireError message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WireError.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.code);
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.status);
                if (message.retryable != null && Object.hasOwnProperty.call(message, "retryable"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.retryable);
                return writer;
            };

            /**
             * Encodes the specified WireError message, length delimited. Does not implicitly {@link breacher.v2.WireError.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.WireError
             * @static
             * @param {breacher.v2.IWireError} message WireError message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WireError.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a WireError message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.WireError
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.WireError} WireError
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WireError.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.WireError();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.code = reader.string();
                            break;
                        }
                    case 2: {
                            message.message = reader.string();
                            break;
                        }
                    case 3: {
                            message.status = reader.uint32();
                            break;
                        }
                    case 4: {
                            message.retryable = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a WireError message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.WireError
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.WireError} WireError
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WireError.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a WireError message.
             * @function verify
             * @memberof breacher.v2.WireError
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            WireError.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    if (!$util.isInteger(message.status))
                        return "status: integer expected";
                if (message.retryable != null && message.hasOwnProperty("retryable"))
                    if (typeof message.retryable !== "boolean")
                        return "retryable: boolean expected";
                return null;
            };

            /**
             * Creates a WireError message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.WireError
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.WireError} WireError
             */
            WireError.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.WireError)
                    return object;
                let message = new $root.breacher.v2.WireError();
                if (object.code != null)
                    message.code = String(object.code);
                if (object.message != null)
                    message.message = String(object.message);
                if (object.status != null)
                    message.status = object.status >>> 0;
                if (object.retryable != null)
                    message.retryable = Boolean(object.retryable);
                return message;
            };

            /**
             * Creates a plain object from a WireError message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.WireError
             * @static
             * @param {breacher.v2.WireError} message WireError
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            WireError.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.code = "";
                    object.message = "";
                    object.status = 0;
                    object.retryable = false;
                }
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = message.status;
                if (message.retryable != null && message.hasOwnProperty("retryable"))
                    object.retryable = message.retryable;
                return object;
            };

            /**
             * Converts this WireError to JSON.
             * @function toJSON
             * @memberof breacher.v2.WireError
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            WireError.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for WireError
             * @function getTypeUrl
             * @memberof breacher.v2.WireError
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            WireError.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.WireError";
            };

            return WireError;
        })();

        v2.ClientEnvelope = (function() {

            /**
             * Properties of a ClientEnvelope.
             * @memberof breacher.v2
             * @interface IClientEnvelope
             * @property {number|null} [protoVer] ClientEnvelope protoVer
             * @property {string|null} [buildHash] ClientEnvelope buildHash
             * @property {string|null} [requestId] ClientEnvelope requestId
             * @property {string|null} [method] ClientEnvelope method
             * @property {string|null} [opId] ClientEnvelope opId
             * @property {number|null} [decisionMs] ClientEnvelope decisionMs
             * @property {breacher.v2.IWireValue|null} [payload] ClientEnvelope payload
             * @property {number|Long|null} [clientTickMs] ClientEnvelope clientTickMs
             * @property {number|Long|null} [runOpSeq] ClientEnvelope runOpSeq
             * @property {Uint8Array|null} [preStateHash] ClientEnvelope preStateHash
             * @property {string|null} [runId] ClientEnvelope runId
             */

            /**
             * Constructs a new ClientEnvelope.
             * @memberof breacher.v2
             * @classdesc Represents a ClientEnvelope.
             * @implements IClientEnvelope
             * @constructor
             * @param {breacher.v2.IClientEnvelope=} [properties] Properties to set
             */
            function ClientEnvelope(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ClientEnvelope protoVer.
             * @member {number} protoVer
             * @memberof breacher.v2.ClientEnvelope
             * @instance
             */
            ClientEnvelope.prototype.protoVer = 0;

            /**
             * ClientEnvelope buildHash.
             * @member {string} buildHash
             * @memberof breacher.v2.ClientEnvelope
             * @instance
             */
            ClientEnvelope.prototype.buildHash = "";

            /**
             * ClientEnvelope requestId.
             * @member {string} requestId
             * @memberof breacher.v2.ClientEnvelope
             * @instance
             */
            ClientEnvelope.prototype.requestId = "";

            /**
             * ClientEnvelope method.
             * @member {string} method
             * @memberof breacher.v2.ClientEnvelope
             * @instance
             */
            ClientEnvelope.prototype.method = "";

            /**
             * ClientEnvelope opId.
             * @member {string} opId
             * @memberof breacher.v2.ClientEnvelope
             * @instance
             */
            ClientEnvelope.prototype.opId = "";

            /**
             * ClientEnvelope decisionMs.
             * @member {number} decisionMs
             * @memberof breacher.v2.ClientEnvelope
             * @instance
             */
            ClientEnvelope.prototype.decisionMs = 0;

            /**
             * ClientEnvelope payload.
             * @member {breacher.v2.IWireValue|null|undefined} payload
             * @memberof breacher.v2.ClientEnvelope
             * @instance
             */
            ClientEnvelope.prototype.payload = null;

            /**
             * ClientEnvelope clientTickMs.
             * @member {number|Long} clientTickMs
             * @memberof breacher.v2.ClientEnvelope
             * @instance
             */
            ClientEnvelope.prototype.clientTickMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * ClientEnvelope runOpSeq.
             * @member {number|Long} runOpSeq
             * @memberof breacher.v2.ClientEnvelope
             * @instance
             */
            ClientEnvelope.prototype.runOpSeq = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * ClientEnvelope preStateHash.
             * @member {Uint8Array} preStateHash
             * @memberof breacher.v2.ClientEnvelope
             * @instance
             */
            ClientEnvelope.prototype.preStateHash = $util.newBuffer([]);

            /**
             * ClientEnvelope runId.
             * @member {string} runId
             * @memberof breacher.v2.ClientEnvelope
             * @instance
             */
            ClientEnvelope.prototype.runId = "";

            /**
             * Creates a new ClientEnvelope instance using the specified properties.
             * @function create
             * @memberof breacher.v2.ClientEnvelope
             * @static
             * @param {breacher.v2.IClientEnvelope=} [properties] Properties to set
             * @returns {breacher.v2.ClientEnvelope} ClientEnvelope instance
             */
            ClientEnvelope.create = function create(properties) {
                return new ClientEnvelope(properties);
            };

            /**
             * Encodes the specified ClientEnvelope message. Does not implicitly {@link breacher.v2.ClientEnvelope.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.ClientEnvelope
             * @static
             * @param {breacher.v2.IClientEnvelope} message ClientEnvelope message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ClientEnvelope.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.protoVer != null && Object.hasOwnProperty.call(message, "protoVer"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.protoVer);
                if (message.buildHash != null && Object.hasOwnProperty.call(message, "buildHash"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.buildHash);
                if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.requestId);
                if (message.method != null && Object.hasOwnProperty.call(message, "method"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.method);
                if (message.opId != null && Object.hasOwnProperty.call(message, "opId"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.opId);
                if (message.decisionMs != null && Object.hasOwnProperty.call(message, "decisionMs"))
                    writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.decisionMs);
                if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
                    $root.breacher.v2.WireValue.encode(message.payload, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.clientTickMs != null && Object.hasOwnProperty.call(message, "clientTickMs"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int64(message.clientTickMs);
                if (message.runOpSeq != null && Object.hasOwnProperty.call(message, "runOpSeq"))
                    writer.uint32(/* id 9, wireType 0 =*/72).uint64(message.runOpSeq);
                if (message.preStateHash != null && Object.hasOwnProperty.call(message, "preStateHash"))
                    writer.uint32(/* id 10, wireType 2 =*/82).bytes(message.preStateHash);
                if (message.runId != null && Object.hasOwnProperty.call(message, "runId"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.runId);
                return writer;
            };

            /**
             * Encodes the specified ClientEnvelope message, length delimited. Does not implicitly {@link breacher.v2.ClientEnvelope.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.ClientEnvelope
             * @static
             * @param {breacher.v2.IClientEnvelope} message ClientEnvelope message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ClientEnvelope.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ClientEnvelope message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.ClientEnvelope
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.ClientEnvelope} ClientEnvelope
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ClientEnvelope.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.ClientEnvelope();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.protoVer = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.buildHash = reader.string();
                            break;
                        }
                    case 3: {
                            message.requestId = reader.string();
                            break;
                        }
                    case 4: {
                            message.method = reader.string();
                            break;
                        }
                    case 5: {
                            message.opId = reader.string();
                            break;
                        }
                    case 6: {
                            message.decisionMs = reader.uint32();
                            break;
                        }
                    case 7: {
                            message.payload = $root.breacher.v2.WireValue.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.clientTickMs = reader.int64();
                            break;
                        }
                    case 9: {
                            message.runOpSeq = reader.uint64();
                            break;
                        }
                    case 10: {
                            message.preStateHash = reader.bytes();
                            break;
                        }
                    case 11: {
                            message.runId = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ClientEnvelope message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.ClientEnvelope
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.ClientEnvelope} ClientEnvelope
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ClientEnvelope.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ClientEnvelope message.
             * @function verify
             * @memberof breacher.v2.ClientEnvelope
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ClientEnvelope.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.protoVer != null && message.hasOwnProperty("protoVer"))
                    if (!$util.isInteger(message.protoVer))
                        return "protoVer: integer expected";
                if (message.buildHash != null && message.hasOwnProperty("buildHash"))
                    if (!$util.isString(message.buildHash))
                        return "buildHash: string expected";
                if (message.requestId != null && message.hasOwnProperty("requestId"))
                    if (!$util.isString(message.requestId))
                        return "requestId: string expected";
                if (message.method != null && message.hasOwnProperty("method"))
                    if (!$util.isString(message.method))
                        return "method: string expected";
                if (message.opId != null && message.hasOwnProperty("opId"))
                    if (!$util.isString(message.opId))
                        return "opId: string expected";
                if (message.decisionMs != null && message.hasOwnProperty("decisionMs"))
                    if (!$util.isInteger(message.decisionMs))
                        return "decisionMs: integer expected";
                if (message.payload != null && message.hasOwnProperty("payload")) {
                    let error = $root.breacher.v2.WireValue.verify(message.payload);
                    if (error)
                        return "payload." + error;
                }
                if (message.clientTickMs != null && message.hasOwnProperty("clientTickMs"))
                    if (!$util.isInteger(message.clientTickMs) && !(message.clientTickMs && $util.isInteger(message.clientTickMs.low) && $util.isInteger(message.clientTickMs.high)))
                        return "clientTickMs: integer|Long expected";
                if (message.runOpSeq != null && message.hasOwnProperty("runOpSeq"))
                    if (!$util.isInteger(message.runOpSeq) && !(message.runOpSeq && $util.isInteger(message.runOpSeq.low) && $util.isInteger(message.runOpSeq.high)))
                        return "runOpSeq: integer|Long expected";
                if (message.preStateHash != null && message.hasOwnProperty("preStateHash"))
                    if (!(message.preStateHash && typeof message.preStateHash.length === "number" || $util.isString(message.preStateHash)))
                        return "preStateHash: buffer expected";
                if (message.runId != null && message.hasOwnProperty("runId"))
                    if (!$util.isString(message.runId))
                        return "runId: string expected";
                return null;
            };

            /**
             * Creates a ClientEnvelope message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.ClientEnvelope
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.ClientEnvelope} ClientEnvelope
             */
            ClientEnvelope.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.ClientEnvelope)
                    return object;
                let message = new $root.breacher.v2.ClientEnvelope();
                if (object.protoVer != null)
                    message.protoVer = object.protoVer >>> 0;
                if (object.buildHash != null)
                    message.buildHash = String(object.buildHash);
                if (object.requestId != null)
                    message.requestId = String(object.requestId);
                if (object.method != null)
                    message.method = String(object.method);
                if (object.opId != null)
                    message.opId = String(object.opId);
                if (object.decisionMs != null)
                    message.decisionMs = object.decisionMs >>> 0;
                if (object.payload != null) {
                    if (typeof object.payload !== "object")
                        throw TypeError(".breacher.v2.ClientEnvelope.payload: object expected");
                    message.payload = $root.breacher.v2.WireValue.fromObject(object.payload);
                }
                if (object.clientTickMs != null)
                    if ($util.Long)
                        (message.clientTickMs = $util.Long.fromValue(object.clientTickMs)).unsigned = false;
                    else if (typeof object.clientTickMs === "string")
                        message.clientTickMs = parseInt(object.clientTickMs, 10);
                    else if (typeof object.clientTickMs === "number")
                        message.clientTickMs = object.clientTickMs;
                    else if (typeof object.clientTickMs === "object")
                        message.clientTickMs = new $util.LongBits(object.clientTickMs.low >>> 0, object.clientTickMs.high >>> 0).toNumber();
                if (object.runOpSeq != null)
                    if ($util.Long)
                        (message.runOpSeq = $util.Long.fromValue(object.runOpSeq)).unsigned = true;
                    else if (typeof object.runOpSeq === "string")
                        message.runOpSeq = parseInt(object.runOpSeq, 10);
                    else if (typeof object.runOpSeq === "number")
                        message.runOpSeq = object.runOpSeq;
                    else if (typeof object.runOpSeq === "object")
                        message.runOpSeq = new $util.LongBits(object.runOpSeq.low >>> 0, object.runOpSeq.high >>> 0).toNumber(true);
                if (object.preStateHash != null)
                    if (typeof object.preStateHash === "string")
                        $util.base64.decode(object.preStateHash, message.preStateHash = $util.newBuffer($util.base64.length(object.preStateHash)), 0);
                    else if (object.preStateHash.length >= 0)
                        message.preStateHash = object.preStateHash;
                if (object.runId != null)
                    message.runId = String(object.runId);
                return message;
            };

            /**
             * Creates a plain object from a ClientEnvelope message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.ClientEnvelope
             * @static
             * @param {breacher.v2.ClientEnvelope} message ClientEnvelope
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ClientEnvelope.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.protoVer = 0;
                    object.buildHash = "";
                    object.requestId = "";
                    object.method = "";
                    object.opId = "";
                    object.decisionMs = 0;
                    object.payload = null;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.clientTickMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.clientTickMs = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.runOpSeq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.runOpSeq = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.preStateHash = "";
                    else {
                        object.preStateHash = [];
                        if (options.bytes !== Array)
                            object.preStateHash = $util.newBuffer(object.preStateHash);
                    }
                    object.runId = "";
                }
                if (message.protoVer != null && message.hasOwnProperty("protoVer"))
                    object.protoVer = message.protoVer;
                if (message.buildHash != null && message.hasOwnProperty("buildHash"))
                    object.buildHash = message.buildHash;
                if (message.requestId != null && message.hasOwnProperty("requestId"))
                    object.requestId = message.requestId;
                if (message.method != null && message.hasOwnProperty("method"))
                    object.method = message.method;
                if (message.opId != null && message.hasOwnProperty("opId"))
                    object.opId = message.opId;
                if (message.decisionMs != null && message.hasOwnProperty("decisionMs"))
                    object.decisionMs = message.decisionMs;
                if (message.payload != null && message.hasOwnProperty("payload"))
                    object.payload = $root.breacher.v2.WireValue.toObject(message.payload, options);
                if (message.clientTickMs != null && message.hasOwnProperty("clientTickMs"))
                    if (typeof message.clientTickMs === "number")
                        object.clientTickMs = options.longs === String ? String(message.clientTickMs) : message.clientTickMs;
                    else
                        object.clientTickMs = options.longs === String ? $util.Long.prototype.toString.call(message.clientTickMs) : options.longs === Number ? new $util.LongBits(message.clientTickMs.low >>> 0, message.clientTickMs.high >>> 0).toNumber() : message.clientTickMs;
                if (message.runOpSeq != null && message.hasOwnProperty("runOpSeq"))
                    if (typeof message.runOpSeq === "number")
                        object.runOpSeq = options.longs === String ? String(message.runOpSeq) : message.runOpSeq;
                    else
                        object.runOpSeq = options.longs === String ? $util.Long.prototype.toString.call(message.runOpSeq) : options.longs === Number ? new $util.LongBits(message.runOpSeq.low >>> 0, message.runOpSeq.high >>> 0).toNumber(true) : message.runOpSeq;
                if (message.preStateHash != null && message.hasOwnProperty("preStateHash"))
                    object.preStateHash = options.bytes === String ? $util.base64.encode(message.preStateHash, 0, message.preStateHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.preStateHash) : message.preStateHash;
                if (message.runId != null && message.hasOwnProperty("runId"))
                    object.runId = message.runId;
                return object;
            };

            /**
             * Converts this ClientEnvelope to JSON.
             * @function toJSON
             * @memberof breacher.v2.ClientEnvelope
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ClientEnvelope.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ClientEnvelope
             * @function getTypeUrl
             * @memberof breacher.v2.ClientEnvelope
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ClientEnvelope.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.ClientEnvelope";
            };

            return ClientEnvelope;
        })();

        v2.ServerEnvelope = (function() {

            /**
             * Properties of a ServerEnvelope.
             * @memberof breacher.v2
             * @interface IServerEnvelope
             * @property {string|null} [requestId] ServerEnvelope requestId
             * @property {string|null} [event] ServerEnvelope event
             * @property {boolean|null} [ok] ServerEnvelope ok
             * @property {number|null} [protoVer] ServerEnvelope protoVer
             * @property {string|null} [buildHash] ServerEnvelope buildHash
             * @property {Uint8Array|null} [resultHash] ServerEnvelope resultHash
             * @property {breacher.v2.IWireValue|null} [payload] ServerEnvelope payload
             * @property {breacher.v2.IWireError|null} [error] ServerEnvelope error
             */

            /**
             * Constructs a new ServerEnvelope.
             * @memberof breacher.v2
             * @classdesc Represents a ServerEnvelope.
             * @implements IServerEnvelope
             * @constructor
             * @param {breacher.v2.IServerEnvelope=} [properties] Properties to set
             */
            function ServerEnvelope(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ServerEnvelope requestId.
             * @member {string} requestId
             * @memberof breacher.v2.ServerEnvelope
             * @instance
             */
            ServerEnvelope.prototype.requestId = "";

            /**
             * ServerEnvelope event.
             * @member {string} event
             * @memberof breacher.v2.ServerEnvelope
             * @instance
             */
            ServerEnvelope.prototype.event = "";

            /**
             * ServerEnvelope ok.
             * @member {boolean} ok
             * @memberof breacher.v2.ServerEnvelope
             * @instance
             */
            ServerEnvelope.prototype.ok = false;

            /**
             * ServerEnvelope protoVer.
             * @member {number} protoVer
             * @memberof breacher.v2.ServerEnvelope
             * @instance
             */
            ServerEnvelope.prototype.protoVer = 0;

            /**
             * ServerEnvelope buildHash.
             * @member {string} buildHash
             * @memberof breacher.v2.ServerEnvelope
             * @instance
             */
            ServerEnvelope.prototype.buildHash = "";

            /**
             * ServerEnvelope resultHash.
             * @member {Uint8Array} resultHash
             * @memberof breacher.v2.ServerEnvelope
             * @instance
             */
            ServerEnvelope.prototype.resultHash = $util.newBuffer([]);

            /**
             * ServerEnvelope payload.
             * @member {breacher.v2.IWireValue|null|undefined} payload
             * @memberof breacher.v2.ServerEnvelope
             * @instance
             */
            ServerEnvelope.prototype.payload = null;

            /**
             * ServerEnvelope error.
             * @member {breacher.v2.IWireError|null|undefined} error
             * @memberof breacher.v2.ServerEnvelope
             * @instance
             */
            ServerEnvelope.prototype.error = null;

            /**
             * Creates a new ServerEnvelope instance using the specified properties.
             * @function create
             * @memberof breacher.v2.ServerEnvelope
             * @static
             * @param {breacher.v2.IServerEnvelope=} [properties] Properties to set
             * @returns {breacher.v2.ServerEnvelope} ServerEnvelope instance
             */
            ServerEnvelope.create = function create(properties) {
                return new ServerEnvelope(properties);
            };

            /**
             * Encodes the specified ServerEnvelope message. Does not implicitly {@link breacher.v2.ServerEnvelope.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.ServerEnvelope
             * @static
             * @param {breacher.v2.IServerEnvelope} message ServerEnvelope message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ServerEnvelope.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
                if (message.event != null && Object.hasOwnProperty.call(message, "event"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.event);
                if (message.ok != null && Object.hasOwnProperty.call(message, "ok"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.ok);
                if (message.protoVer != null && Object.hasOwnProperty.call(message, "protoVer"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.protoVer);
                if (message.buildHash != null && Object.hasOwnProperty.call(message, "buildHash"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.buildHash);
                if (message.resultHash != null && Object.hasOwnProperty.call(message, "resultHash"))
                    writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.resultHash);
                if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
                    $root.breacher.v2.WireValue.encode(message.payload, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                    $root.breacher.v2.WireError.encode(message.error, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ServerEnvelope message, length delimited. Does not implicitly {@link breacher.v2.ServerEnvelope.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.ServerEnvelope
             * @static
             * @param {breacher.v2.IServerEnvelope} message ServerEnvelope message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ServerEnvelope.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ServerEnvelope message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.ServerEnvelope
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.ServerEnvelope} ServerEnvelope
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ServerEnvelope.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.ServerEnvelope();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.requestId = reader.string();
                            break;
                        }
                    case 2: {
                            message.event = reader.string();
                            break;
                        }
                    case 3: {
                            message.ok = reader.bool();
                            break;
                        }
                    case 4: {
                            message.protoVer = reader.uint32();
                            break;
                        }
                    case 5: {
                            message.buildHash = reader.string();
                            break;
                        }
                    case 6: {
                            message.resultHash = reader.bytes();
                            break;
                        }
                    case 7: {
                            message.payload = $root.breacher.v2.WireValue.decode(reader, reader.uint32());
                            break;
                        }
                    case 8: {
                            message.error = $root.breacher.v2.WireError.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ServerEnvelope message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.ServerEnvelope
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.ServerEnvelope} ServerEnvelope
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ServerEnvelope.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ServerEnvelope message.
             * @function verify
             * @memberof breacher.v2.ServerEnvelope
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ServerEnvelope.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.requestId != null && message.hasOwnProperty("requestId"))
                    if (!$util.isString(message.requestId))
                        return "requestId: string expected";
                if (message.event != null && message.hasOwnProperty("event"))
                    if (!$util.isString(message.event))
                        return "event: string expected";
                if (message.ok != null && message.hasOwnProperty("ok"))
                    if (typeof message.ok !== "boolean")
                        return "ok: boolean expected";
                if (message.protoVer != null && message.hasOwnProperty("protoVer"))
                    if (!$util.isInteger(message.protoVer))
                        return "protoVer: integer expected";
                if (message.buildHash != null && message.hasOwnProperty("buildHash"))
                    if (!$util.isString(message.buildHash))
                        return "buildHash: string expected";
                if (message.resultHash != null && message.hasOwnProperty("resultHash"))
                    if (!(message.resultHash && typeof message.resultHash.length === "number" || $util.isString(message.resultHash)))
                        return "resultHash: buffer expected";
                if (message.payload != null && message.hasOwnProperty("payload")) {
                    let error = $root.breacher.v2.WireValue.verify(message.payload);
                    if (error)
                        return "payload." + error;
                }
                if (message.error != null && message.hasOwnProperty("error")) {
                    let error = $root.breacher.v2.WireError.verify(message.error);
                    if (error)
                        return "error." + error;
                }
                return null;
            };

            /**
             * Creates a ServerEnvelope message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.ServerEnvelope
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.ServerEnvelope} ServerEnvelope
             */
            ServerEnvelope.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.ServerEnvelope)
                    return object;
                let message = new $root.breacher.v2.ServerEnvelope();
                if (object.requestId != null)
                    message.requestId = String(object.requestId);
                if (object.event != null)
                    message.event = String(object.event);
                if (object.ok != null)
                    message.ok = Boolean(object.ok);
                if (object.protoVer != null)
                    message.protoVer = object.protoVer >>> 0;
                if (object.buildHash != null)
                    message.buildHash = String(object.buildHash);
                if (object.resultHash != null)
                    if (typeof object.resultHash === "string")
                        $util.base64.decode(object.resultHash, message.resultHash = $util.newBuffer($util.base64.length(object.resultHash)), 0);
                    else if (object.resultHash.length >= 0)
                        message.resultHash = object.resultHash;
                if (object.payload != null) {
                    if (typeof object.payload !== "object")
                        throw TypeError(".breacher.v2.ServerEnvelope.payload: object expected");
                    message.payload = $root.breacher.v2.WireValue.fromObject(object.payload);
                }
                if (object.error != null) {
                    if (typeof object.error !== "object")
                        throw TypeError(".breacher.v2.ServerEnvelope.error: object expected");
                    message.error = $root.breacher.v2.WireError.fromObject(object.error);
                }
                return message;
            };

            /**
             * Creates a plain object from a ServerEnvelope message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.ServerEnvelope
             * @static
             * @param {breacher.v2.ServerEnvelope} message ServerEnvelope
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ServerEnvelope.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.requestId = "";
                    object.event = "";
                    object.ok = false;
                    object.protoVer = 0;
                    object.buildHash = "";
                    if (options.bytes === String)
                        object.resultHash = "";
                    else {
                        object.resultHash = [];
                        if (options.bytes !== Array)
                            object.resultHash = $util.newBuffer(object.resultHash);
                    }
                    object.payload = null;
                    object.error = null;
                }
                if (message.requestId != null && message.hasOwnProperty("requestId"))
                    object.requestId = message.requestId;
                if (message.event != null && message.hasOwnProperty("event"))
                    object.event = message.event;
                if (message.ok != null && message.hasOwnProperty("ok"))
                    object.ok = message.ok;
                if (message.protoVer != null && message.hasOwnProperty("protoVer"))
                    object.protoVer = message.protoVer;
                if (message.buildHash != null && message.hasOwnProperty("buildHash"))
                    object.buildHash = message.buildHash;
                if (message.resultHash != null && message.hasOwnProperty("resultHash"))
                    object.resultHash = options.bytes === String ? $util.base64.encode(message.resultHash, 0, message.resultHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.resultHash) : message.resultHash;
                if (message.payload != null && message.hasOwnProperty("payload"))
                    object.payload = $root.breacher.v2.WireValue.toObject(message.payload, options);
                if (message.error != null && message.hasOwnProperty("error"))
                    object.error = $root.breacher.v2.WireError.toObject(message.error, options);
                return object;
            };

            /**
             * Converts this ServerEnvelope to JSON.
             * @function toJSON
             * @memberof breacher.v2.ServerEnvelope
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ServerEnvelope.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ServerEnvelope
             * @function getTypeUrl
             * @memberof breacher.v2.ServerEnvelope
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ServerEnvelope.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.ServerEnvelope";
            };

            return ServerEnvelope;
        })();

        v2.ClientHello = (function() {

            /**
             * Properties of a ClientHello.
             * @memberof breacher.v2
             * @interface IClientHello
             * @property {number|null} [handshakeVersion] ClientHello handshakeVersion
             * @property {Uint8Array|null} [ephemeralPublicKey] ClientHello ephemeralPublicKey
             * @property {Uint8Array|null} [nonce] ClientHello nonce
             * @property {number|null} [protoVer] ClientHello protoVer
             * @property {string|null} [buildHash] ClientHello buildHash
             */

            /**
             * Constructs a new ClientHello.
             * @memberof breacher.v2
             * @classdesc Represents a ClientHello.
             * @implements IClientHello
             * @constructor
             * @param {breacher.v2.IClientHello=} [properties] Properties to set
             */
            function ClientHello(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ClientHello handshakeVersion.
             * @member {number} handshakeVersion
             * @memberof breacher.v2.ClientHello
             * @instance
             */
            ClientHello.prototype.handshakeVersion = 0;

            /**
             * ClientHello ephemeralPublicKey.
             * @member {Uint8Array} ephemeralPublicKey
             * @memberof breacher.v2.ClientHello
             * @instance
             */
            ClientHello.prototype.ephemeralPublicKey = $util.newBuffer([]);

            /**
             * ClientHello nonce.
             * @member {Uint8Array} nonce
             * @memberof breacher.v2.ClientHello
             * @instance
             */
            ClientHello.prototype.nonce = $util.newBuffer([]);

            /**
             * ClientHello protoVer.
             * @member {number} protoVer
             * @memberof breacher.v2.ClientHello
             * @instance
             */
            ClientHello.prototype.protoVer = 0;

            /**
             * ClientHello buildHash.
             * @member {string} buildHash
             * @memberof breacher.v2.ClientHello
             * @instance
             */
            ClientHello.prototype.buildHash = "";

            /**
             * Creates a new ClientHello instance using the specified properties.
             * @function create
             * @memberof breacher.v2.ClientHello
             * @static
             * @param {breacher.v2.IClientHello=} [properties] Properties to set
             * @returns {breacher.v2.ClientHello} ClientHello instance
             */
            ClientHello.create = function create(properties) {
                return new ClientHello(properties);
            };

            /**
             * Encodes the specified ClientHello message. Does not implicitly {@link breacher.v2.ClientHello.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.ClientHello
             * @static
             * @param {breacher.v2.IClientHello} message ClientHello message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ClientHello.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.handshakeVersion != null && Object.hasOwnProperty.call(message, "handshakeVersion"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.handshakeVersion);
                if (message.ephemeralPublicKey != null && Object.hasOwnProperty.call(message, "ephemeralPublicKey"))
                    writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.ephemeralPublicKey);
                if (message.nonce != null && Object.hasOwnProperty.call(message, "nonce"))
                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.nonce);
                if (message.protoVer != null && Object.hasOwnProperty.call(message, "protoVer"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.protoVer);
                if (message.buildHash != null && Object.hasOwnProperty.call(message, "buildHash"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.buildHash);
                return writer;
            };

            /**
             * Encodes the specified ClientHello message, length delimited. Does not implicitly {@link breacher.v2.ClientHello.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.ClientHello
             * @static
             * @param {breacher.v2.IClientHello} message ClientHello message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ClientHello.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ClientHello message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.ClientHello
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.ClientHello} ClientHello
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ClientHello.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.ClientHello();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.handshakeVersion = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.ephemeralPublicKey = reader.bytes();
                            break;
                        }
                    case 3: {
                            message.nonce = reader.bytes();
                            break;
                        }
                    case 4: {
                            message.protoVer = reader.uint32();
                            break;
                        }
                    case 5: {
                            message.buildHash = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ClientHello message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.ClientHello
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.ClientHello} ClientHello
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ClientHello.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ClientHello message.
             * @function verify
             * @memberof breacher.v2.ClientHello
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ClientHello.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.handshakeVersion != null && message.hasOwnProperty("handshakeVersion"))
                    if (!$util.isInteger(message.handshakeVersion))
                        return "handshakeVersion: integer expected";
                if (message.ephemeralPublicKey != null && message.hasOwnProperty("ephemeralPublicKey"))
                    if (!(message.ephemeralPublicKey && typeof message.ephemeralPublicKey.length === "number" || $util.isString(message.ephemeralPublicKey)))
                        return "ephemeralPublicKey: buffer expected";
                if (message.nonce != null && message.hasOwnProperty("nonce"))
                    if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
                        return "nonce: buffer expected";
                if (message.protoVer != null && message.hasOwnProperty("protoVer"))
                    if (!$util.isInteger(message.protoVer))
                        return "protoVer: integer expected";
                if (message.buildHash != null && message.hasOwnProperty("buildHash"))
                    if (!$util.isString(message.buildHash))
                        return "buildHash: string expected";
                return null;
            };

            /**
             * Creates a ClientHello message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.ClientHello
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.ClientHello} ClientHello
             */
            ClientHello.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.ClientHello)
                    return object;
                let message = new $root.breacher.v2.ClientHello();
                if (object.handshakeVersion != null)
                    message.handshakeVersion = object.handshakeVersion >>> 0;
                if (object.ephemeralPublicKey != null)
                    if (typeof object.ephemeralPublicKey === "string")
                        $util.base64.decode(object.ephemeralPublicKey, message.ephemeralPublicKey = $util.newBuffer($util.base64.length(object.ephemeralPublicKey)), 0);
                    else if (object.ephemeralPublicKey.length >= 0)
                        message.ephemeralPublicKey = object.ephemeralPublicKey;
                if (object.nonce != null)
                    if (typeof object.nonce === "string")
                        $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
                    else if (object.nonce.length >= 0)
                        message.nonce = object.nonce;
                if (object.protoVer != null)
                    message.protoVer = object.protoVer >>> 0;
                if (object.buildHash != null)
                    message.buildHash = String(object.buildHash);
                return message;
            };

            /**
             * Creates a plain object from a ClientHello message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.ClientHello
             * @static
             * @param {breacher.v2.ClientHello} message ClientHello
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ClientHello.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.handshakeVersion = 0;
                    if (options.bytes === String)
                        object.ephemeralPublicKey = "";
                    else {
                        object.ephemeralPublicKey = [];
                        if (options.bytes !== Array)
                            object.ephemeralPublicKey = $util.newBuffer(object.ephemeralPublicKey);
                    }
                    if (options.bytes === String)
                        object.nonce = "";
                    else {
                        object.nonce = [];
                        if (options.bytes !== Array)
                            object.nonce = $util.newBuffer(object.nonce);
                    }
                    object.protoVer = 0;
                    object.buildHash = "";
                }
                if (message.handshakeVersion != null && message.hasOwnProperty("handshakeVersion"))
                    object.handshakeVersion = message.handshakeVersion;
                if (message.ephemeralPublicKey != null && message.hasOwnProperty("ephemeralPublicKey"))
                    object.ephemeralPublicKey = options.bytes === String ? $util.base64.encode(message.ephemeralPublicKey, 0, message.ephemeralPublicKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.ephemeralPublicKey) : message.ephemeralPublicKey;
                if (message.nonce != null && message.hasOwnProperty("nonce"))
                    object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
                if (message.protoVer != null && message.hasOwnProperty("protoVer"))
                    object.protoVer = message.protoVer;
                if (message.buildHash != null && message.hasOwnProperty("buildHash"))
                    object.buildHash = message.buildHash;
                return object;
            };

            /**
             * Converts this ClientHello to JSON.
             * @function toJSON
             * @memberof breacher.v2.ClientHello
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ClientHello.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ClientHello
             * @function getTypeUrl
             * @memberof breacher.v2.ClientHello
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ClientHello.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.ClientHello";
            };

            return ClientHello;
        })();

        v2.ServerHello = (function() {

            /**
             * Properties of a ServerHello.
             * @memberof breacher.v2
             * @interface IServerHello
             * @property {number|null} [handshakeVersion] ServerHello handshakeVersion
             * @property {Uint8Array|null} [ephemeralPublicKey] ServerHello ephemeralPublicKey
             * @property {Uint8Array|null} [nonce] ServerHello nonce
             * @property {Uint8Array|null} [signature] ServerHello signature
             * @property {Uint8Array|null} [signingPublicKey] ServerHello signingPublicKey
             * @property {string|null} [keyId] ServerHello keyId
             */

            /**
             * Constructs a new ServerHello.
             * @memberof breacher.v2
             * @classdesc Represents a ServerHello.
             * @implements IServerHello
             * @constructor
             * @param {breacher.v2.IServerHello=} [properties] Properties to set
             */
            function ServerHello(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ServerHello handshakeVersion.
             * @member {number} handshakeVersion
             * @memberof breacher.v2.ServerHello
             * @instance
             */
            ServerHello.prototype.handshakeVersion = 0;

            /**
             * ServerHello ephemeralPublicKey.
             * @member {Uint8Array} ephemeralPublicKey
             * @memberof breacher.v2.ServerHello
             * @instance
             */
            ServerHello.prototype.ephemeralPublicKey = $util.newBuffer([]);

            /**
             * ServerHello nonce.
             * @member {Uint8Array} nonce
             * @memberof breacher.v2.ServerHello
             * @instance
             */
            ServerHello.prototype.nonce = $util.newBuffer([]);

            /**
             * ServerHello signature.
             * @member {Uint8Array} signature
             * @memberof breacher.v2.ServerHello
             * @instance
             */
            ServerHello.prototype.signature = $util.newBuffer([]);

            /**
             * ServerHello signingPublicKey.
             * @member {Uint8Array} signingPublicKey
             * @memberof breacher.v2.ServerHello
             * @instance
             */
            ServerHello.prototype.signingPublicKey = $util.newBuffer([]);

            /**
             * ServerHello keyId.
             * @member {string} keyId
             * @memberof breacher.v2.ServerHello
             * @instance
             */
            ServerHello.prototype.keyId = "";

            /**
             * Creates a new ServerHello instance using the specified properties.
             * @function create
             * @memberof breacher.v2.ServerHello
             * @static
             * @param {breacher.v2.IServerHello=} [properties] Properties to set
             * @returns {breacher.v2.ServerHello} ServerHello instance
             */
            ServerHello.create = function create(properties) {
                return new ServerHello(properties);
            };

            /**
             * Encodes the specified ServerHello message. Does not implicitly {@link breacher.v2.ServerHello.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.ServerHello
             * @static
             * @param {breacher.v2.IServerHello} message ServerHello message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ServerHello.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.handshakeVersion != null && Object.hasOwnProperty.call(message, "handshakeVersion"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.handshakeVersion);
                if (message.ephemeralPublicKey != null && Object.hasOwnProperty.call(message, "ephemeralPublicKey"))
                    writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.ephemeralPublicKey);
                if (message.nonce != null && Object.hasOwnProperty.call(message, "nonce"))
                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.nonce);
                if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
                    writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.signature);
                if (message.signingPublicKey != null && Object.hasOwnProperty.call(message, "signingPublicKey"))
                    writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.signingPublicKey);
                if (message.keyId != null && Object.hasOwnProperty.call(message, "keyId"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.keyId);
                return writer;
            };

            /**
             * Encodes the specified ServerHello message, length delimited. Does not implicitly {@link breacher.v2.ServerHello.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.ServerHello
             * @static
             * @param {breacher.v2.IServerHello} message ServerHello message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ServerHello.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ServerHello message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.ServerHello
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.ServerHello} ServerHello
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ServerHello.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.ServerHello();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.handshakeVersion = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.ephemeralPublicKey = reader.bytes();
                            break;
                        }
                    case 3: {
                            message.nonce = reader.bytes();
                            break;
                        }
                    case 4: {
                            message.signature = reader.bytes();
                            break;
                        }
                    case 5: {
                            message.signingPublicKey = reader.bytes();
                            break;
                        }
                    case 6: {
                            message.keyId = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ServerHello message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.ServerHello
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.ServerHello} ServerHello
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ServerHello.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ServerHello message.
             * @function verify
             * @memberof breacher.v2.ServerHello
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ServerHello.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.handshakeVersion != null && message.hasOwnProperty("handshakeVersion"))
                    if (!$util.isInteger(message.handshakeVersion))
                        return "handshakeVersion: integer expected";
                if (message.ephemeralPublicKey != null && message.hasOwnProperty("ephemeralPublicKey"))
                    if (!(message.ephemeralPublicKey && typeof message.ephemeralPublicKey.length === "number" || $util.isString(message.ephemeralPublicKey)))
                        return "ephemeralPublicKey: buffer expected";
                if (message.nonce != null && message.hasOwnProperty("nonce"))
                    if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
                        return "nonce: buffer expected";
                if (message.signature != null && message.hasOwnProperty("signature"))
                    if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                        return "signature: buffer expected";
                if (message.signingPublicKey != null && message.hasOwnProperty("signingPublicKey"))
                    if (!(message.signingPublicKey && typeof message.signingPublicKey.length === "number" || $util.isString(message.signingPublicKey)))
                        return "signingPublicKey: buffer expected";
                if (message.keyId != null && message.hasOwnProperty("keyId"))
                    if (!$util.isString(message.keyId))
                        return "keyId: string expected";
                return null;
            };

            /**
             * Creates a ServerHello message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.ServerHello
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.ServerHello} ServerHello
             */
            ServerHello.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.ServerHello)
                    return object;
                let message = new $root.breacher.v2.ServerHello();
                if (object.handshakeVersion != null)
                    message.handshakeVersion = object.handshakeVersion >>> 0;
                if (object.ephemeralPublicKey != null)
                    if (typeof object.ephemeralPublicKey === "string")
                        $util.base64.decode(object.ephemeralPublicKey, message.ephemeralPublicKey = $util.newBuffer($util.base64.length(object.ephemeralPublicKey)), 0);
                    else if (object.ephemeralPublicKey.length >= 0)
                        message.ephemeralPublicKey = object.ephemeralPublicKey;
                if (object.nonce != null)
                    if (typeof object.nonce === "string")
                        $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
                    else if (object.nonce.length >= 0)
                        message.nonce = object.nonce;
                if (object.signature != null)
                    if (typeof object.signature === "string")
                        $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
                    else if (object.signature.length >= 0)
                        message.signature = object.signature;
                if (object.signingPublicKey != null)
                    if (typeof object.signingPublicKey === "string")
                        $util.base64.decode(object.signingPublicKey, message.signingPublicKey = $util.newBuffer($util.base64.length(object.signingPublicKey)), 0);
                    else if (object.signingPublicKey.length >= 0)
                        message.signingPublicKey = object.signingPublicKey;
                if (object.keyId != null)
                    message.keyId = String(object.keyId);
                return message;
            };

            /**
             * Creates a plain object from a ServerHello message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.ServerHello
             * @static
             * @param {breacher.v2.ServerHello} message ServerHello
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ServerHello.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.handshakeVersion = 0;
                    if (options.bytes === String)
                        object.ephemeralPublicKey = "";
                    else {
                        object.ephemeralPublicKey = [];
                        if (options.bytes !== Array)
                            object.ephemeralPublicKey = $util.newBuffer(object.ephemeralPublicKey);
                    }
                    if (options.bytes === String)
                        object.nonce = "";
                    else {
                        object.nonce = [];
                        if (options.bytes !== Array)
                            object.nonce = $util.newBuffer(object.nonce);
                    }
                    if (options.bytes === String)
                        object.signature = "";
                    else {
                        object.signature = [];
                        if (options.bytes !== Array)
                            object.signature = $util.newBuffer(object.signature);
                    }
                    if (options.bytes === String)
                        object.signingPublicKey = "";
                    else {
                        object.signingPublicKey = [];
                        if (options.bytes !== Array)
                            object.signingPublicKey = $util.newBuffer(object.signingPublicKey);
                    }
                    object.keyId = "";
                }
                if (message.handshakeVersion != null && message.hasOwnProperty("handshakeVersion"))
                    object.handshakeVersion = message.handshakeVersion;
                if (message.ephemeralPublicKey != null && message.hasOwnProperty("ephemeralPublicKey"))
                    object.ephemeralPublicKey = options.bytes === String ? $util.base64.encode(message.ephemeralPublicKey, 0, message.ephemeralPublicKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.ephemeralPublicKey) : message.ephemeralPublicKey;
                if (message.nonce != null && message.hasOwnProperty("nonce"))
                    object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
                if (message.signature != null && message.hasOwnProperty("signature"))
                    object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
                if (message.signingPublicKey != null && message.hasOwnProperty("signingPublicKey"))
                    object.signingPublicKey = options.bytes === String ? $util.base64.encode(message.signingPublicKey, 0, message.signingPublicKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.signingPublicKey) : message.signingPublicKey;
                if (message.keyId != null && message.hasOwnProperty("keyId"))
                    object.keyId = message.keyId;
                return object;
            };

            /**
             * Converts this ServerHello to JSON.
             * @function toJSON
             * @memberof breacher.v2.ServerHello
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ServerHello.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ServerHello
             * @function getTypeUrl
             * @memberof breacher.v2.ServerHello
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ServerHello.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.ServerHello";
            };

            return ServerHello;
        })();

        v2.SecureReady = (function() {

            /**
             * Properties of a SecureReady.
             * @memberof breacher.v2
             * @interface ISecureReady
             * @property {number|Long|null} [serverNowMs] SecureReady serverNowMs
             * @property {number|null} [keyEpoch] SecureReady keyEpoch
             */

            /**
             * Constructs a new SecureReady.
             * @memberof breacher.v2
             * @classdesc Represents a SecureReady.
             * @implements ISecureReady
             * @constructor
             * @param {breacher.v2.ISecureReady=} [properties] Properties to set
             */
            function SecureReady(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SecureReady serverNowMs.
             * @member {number|Long} serverNowMs
             * @memberof breacher.v2.SecureReady
             * @instance
             */
            SecureReady.prototype.serverNowMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * SecureReady keyEpoch.
             * @member {number} keyEpoch
             * @memberof breacher.v2.SecureReady
             * @instance
             */
            SecureReady.prototype.keyEpoch = 0;

            /**
             * Creates a new SecureReady instance using the specified properties.
             * @function create
             * @memberof breacher.v2.SecureReady
             * @static
             * @param {breacher.v2.ISecureReady=} [properties] Properties to set
             * @returns {breacher.v2.SecureReady} SecureReady instance
             */
            SecureReady.create = function create(properties) {
                return new SecureReady(properties);
            };

            /**
             * Encodes the specified SecureReady message. Does not implicitly {@link breacher.v2.SecureReady.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.SecureReady
             * @static
             * @param {breacher.v2.ISecureReady} message SecureReady message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SecureReady.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.serverNowMs != null && Object.hasOwnProperty.call(message, "serverNowMs"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.serverNowMs);
                if (message.keyEpoch != null && Object.hasOwnProperty.call(message, "keyEpoch"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.keyEpoch);
                return writer;
            };

            /**
             * Encodes the specified SecureReady message, length delimited. Does not implicitly {@link breacher.v2.SecureReady.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.SecureReady
             * @static
             * @param {breacher.v2.ISecureReady} message SecureReady message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SecureReady.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SecureReady message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.SecureReady
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.SecureReady} SecureReady
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SecureReady.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.SecureReady();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.serverNowMs = reader.int64();
                            break;
                        }
                    case 2: {
                            message.keyEpoch = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SecureReady message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.SecureReady
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.SecureReady} SecureReady
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SecureReady.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SecureReady message.
             * @function verify
             * @memberof breacher.v2.SecureReady
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SecureReady.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.serverNowMs != null && message.hasOwnProperty("serverNowMs"))
                    if (!$util.isInteger(message.serverNowMs) && !(message.serverNowMs && $util.isInteger(message.serverNowMs.low) && $util.isInteger(message.serverNowMs.high)))
                        return "serverNowMs: integer|Long expected";
                if (message.keyEpoch != null && message.hasOwnProperty("keyEpoch"))
                    if (!$util.isInteger(message.keyEpoch))
                        return "keyEpoch: integer expected";
                return null;
            };

            /**
             * Creates a SecureReady message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.SecureReady
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.SecureReady} SecureReady
             */
            SecureReady.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.SecureReady)
                    return object;
                let message = new $root.breacher.v2.SecureReady();
                if (object.serverNowMs != null)
                    if ($util.Long)
                        (message.serverNowMs = $util.Long.fromValue(object.serverNowMs)).unsigned = false;
                    else if (typeof object.serverNowMs === "string")
                        message.serverNowMs = parseInt(object.serverNowMs, 10);
                    else if (typeof object.serverNowMs === "number")
                        message.serverNowMs = object.serverNowMs;
                    else if (typeof object.serverNowMs === "object")
                        message.serverNowMs = new $util.LongBits(object.serverNowMs.low >>> 0, object.serverNowMs.high >>> 0).toNumber();
                if (object.keyEpoch != null)
                    message.keyEpoch = object.keyEpoch >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a SecureReady message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.SecureReady
             * @static
             * @param {breacher.v2.SecureReady} message SecureReady
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SecureReady.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.serverNowMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.serverNowMs = options.longs === String ? "0" : 0;
                    object.keyEpoch = 0;
                }
                if (message.serverNowMs != null && message.hasOwnProperty("serverNowMs"))
                    if (typeof message.serverNowMs === "number")
                        object.serverNowMs = options.longs === String ? String(message.serverNowMs) : message.serverNowMs;
                    else
                        object.serverNowMs = options.longs === String ? $util.Long.prototype.toString.call(message.serverNowMs) : options.longs === Number ? new $util.LongBits(message.serverNowMs.low >>> 0, message.serverNowMs.high >>> 0).toNumber() : message.serverNowMs;
                if (message.keyEpoch != null && message.hasOwnProperty("keyEpoch"))
                    object.keyEpoch = message.keyEpoch;
                return object;
            };

            /**
             * Converts this SecureReady to JSON.
             * @function toJSON
             * @memberof breacher.v2.SecureReady
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SecureReady.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SecureReady
             * @function getTypeUrl
             * @memberof breacher.v2.SecureReady
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SecureReady.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.SecureReady";
            };

            return SecureReady;
        })();

        v2.KeyUpdate = (function() {

            /**
             * Properties of a KeyUpdate.
             * @memberof breacher.v2
             * @interface IKeyUpdate
             * @property {number|null} [nextEpoch] KeyUpdate nextEpoch
             */

            /**
             * Constructs a new KeyUpdate.
             * @memberof breacher.v2
             * @classdesc Represents a KeyUpdate.
             * @implements IKeyUpdate
             * @constructor
             * @param {breacher.v2.IKeyUpdate=} [properties] Properties to set
             */
            function KeyUpdate(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * KeyUpdate nextEpoch.
             * @member {number} nextEpoch
             * @memberof breacher.v2.KeyUpdate
             * @instance
             */
            KeyUpdate.prototype.nextEpoch = 0;

            /**
             * Creates a new KeyUpdate instance using the specified properties.
             * @function create
             * @memberof breacher.v2.KeyUpdate
             * @static
             * @param {breacher.v2.IKeyUpdate=} [properties] Properties to set
             * @returns {breacher.v2.KeyUpdate} KeyUpdate instance
             */
            KeyUpdate.create = function create(properties) {
                return new KeyUpdate(properties);
            };

            /**
             * Encodes the specified KeyUpdate message. Does not implicitly {@link breacher.v2.KeyUpdate.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.KeyUpdate
             * @static
             * @param {breacher.v2.IKeyUpdate} message KeyUpdate message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            KeyUpdate.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.nextEpoch != null && Object.hasOwnProperty.call(message, "nextEpoch"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.nextEpoch);
                return writer;
            };

            /**
             * Encodes the specified KeyUpdate message, length delimited. Does not implicitly {@link breacher.v2.KeyUpdate.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.KeyUpdate
             * @static
             * @param {breacher.v2.IKeyUpdate} message KeyUpdate message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            KeyUpdate.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a KeyUpdate message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.KeyUpdate
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.KeyUpdate} KeyUpdate
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            KeyUpdate.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.KeyUpdate();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.nextEpoch = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a KeyUpdate message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.KeyUpdate
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.KeyUpdate} KeyUpdate
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            KeyUpdate.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a KeyUpdate message.
             * @function verify
             * @memberof breacher.v2.KeyUpdate
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            KeyUpdate.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.nextEpoch != null && message.hasOwnProperty("nextEpoch"))
                    if (!$util.isInteger(message.nextEpoch))
                        return "nextEpoch: integer expected";
                return null;
            };

            /**
             * Creates a KeyUpdate message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.KeyUpdate
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.KeyUpdate} KeyUpdate
             */
            KeyUpdate.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.KeyUpdate)
                    return object;
                let message = new $root.breacher.v2.KeyUpdate();
                if (object.nextEpoch != null)
                    message.nextEpoch = object.nextEpoch >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a KeyUpdate message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.KeyUpdate
             * @static
             * @param {breacher.v2.KeyUpdate} message KeyUpdate
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            KeyUpdate.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.nextEpoch = 0;
                if (message.nextEpoch != null && message.hasOwnProperty("nextEpoch"))
                    object.nextEpoch = message.nextEpoch;
                return object;
            };

            /**
             * Converts this KeyUpdate to JSON.
             * @function toJSON
             * @memberof breacher.v2.KeyUpdate
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            KeyUpdate.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for KeyUpdate
             * @function getTypeUrl
             * @memberof breacher.v2.KeyUpdate
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            KeyUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.KeyUpdate";
            };

            return KeyUpdate;
        })();

        v2.StateHash = (function() {

            /**
             * Properties of a StateHash.
             * @memberof breacher.v2
             * @interface IStateHash
             * @property {Uint8Array|null} [value] StateHash value
             * @property {number|Long|null} [revision] StateHash revision
             */

            /**
             * Constructs a new StateHash.
             * @memberof breacher.v2
             * @classdesc Represents a StateHash.
             * @implements IStateHash
             * @constructor
             * @param {breacher.v2.IStateHash=} [properties] Properties to set
             */
            function StateHash(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StateHash value.
             * @member {Uint8Array} value
             * @memberof breacher.v2.StateHash
             * @instance
             */
            StateHash.prototype.value = $util.newBuffer([]);

            /**
             * StateHash revision.
             * @member {number|Long} revision
             * @memberof breacher.v2.StateHash
             * @instance
             */
            StateHash.prototype.revision = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new StateHash instance using the specified properties.
             * @function create
             * @memberof breacher.v2.StateHash
             * @static
             * @param {breacher.v2.IStateHash=} [properties] Properties to set
             * @returns {breacher.v2.StateHash} StateHash instance
             */
            StateHash.create = function create(properties) {
                return new StateHash(properties);
            };

            /**
             * Encodes the specified StateHash message. Does not implicitly {@link breacher.v2.StateHash.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.StateHash
             * @static
             * @param {breacher.v2.IStateHash} message StateHash message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StateHash.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
                if (message.revision != null && Object.hasOwnProperty.call(message, "revision"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.revision);
                return writer;
            };

            /**
             * Encodes the specified StateHash message, length delimited. Does not implicitly {@link breacher.v2.StateHash.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.StateHash
             * @static
             * @param {breacher.v2.IStateHash} message StateHash message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StateHash.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StateHash message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.StateHash
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.StateHash} StateHash
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StateHash.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.StateHash();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.value = reader.bytes();
                            break;
                        }
                    case 2: {
                            message.revision = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StateHash message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.StateHash
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.StateHash} StateHash
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StateHash.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StateHash message.
             * @function verify
             * @memberof breacher.v2.StateHash
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StateHash.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                        return "value: buffer expected";
                if (message.revision != null && message.hasOwnProperty("revision"))
                    if (!$util.isInteger(message.revision) && !(message.revision && $util.isInteger(message.revision.low) && $util.isInteger(message.revision.high)))
                        return "revision: integer|Long expected";
                return null;
            };

            /**
             * Creates a StateHash message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.StateHash
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.StateHash} StateHash
             */
            StateHash.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.StateHash)
                    return object;
                let message = new $root.breacher.v2.StateHash();
                if (object.value != null)
                    if (typeof object.value === "string")
                        $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                    else if (object.value.length >= 0)
                        message.value = object.value;
                if (object.revision != null)
                    if ($util.Long)
                        (message.revision = $util.Long.fromValue(object.revision)).unsigned = true;
                    else if (typeof object.revision === "string")
                        message.revision = parseInt(object.revision, 10);
                    else if (typeof object.revision === "number")
                        message.revision = object.revision;
                    else if (typeof object.revision === "object")
                        message.revision = new $util.LongBits(object.revision.low >>> 0, object.revision.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a StateHash message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.StateHash
             * @static
             * @param {breacher.v2.StateHash} message StateHash
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StateHash.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if (options.bytes === String)
                        object.value = "";
                    else {
                        object.value = [];
                        if (options.bytes !== Array)
                            object.value = $util.newBuffer(object.value);
                    }
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.revision = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.revision = options.longs === String ? "0" : 0;
                }
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
                if (message.revision != null && message.hasOwnProperty("revision"))
                    if (typeof message.revision === "number")
                        object.revision = options.longs === String ? String(message.revision) : message.revision;
                    else
                        object.revision = options.longs === String ? $util.Long.prototype.toString.call(message.revision) : options.longs === Number ? new $util.LongBits(message.revision.low >>> 0, message.revision.high >>> 0).toNumber(true) : message.revision;
                return object;
            };

            /**
             * Converts this StateHash to JSON.
             * @function toJSON
             * @memberof breacher.v2.StateHash
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StateHash.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StateHash
             * @function getTypeUrl
             * @memberof breacher.v2.StateHash
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StateHash.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.StateHash";
            };

            return StateHash;
        })();

        v2.SlideAction = (function() {

            /**
             * Properties of a SlideAction.
             * @memberof breacher.v2
             * @interface ISlideAction
             * @property {string|null} [axis] SlideAction axis
             * @property {number|null} [index] SlideAction index
             * @property {number|null} [distance] SlideAction distance
             * @property {boolean|null} [automated] SlideAction automated
             */

            /**
             * Constructs a new SlideAction.
             * @memberof breacher.v2
             * @classdesc Represents a SlideAction.
             * @implements ISlideAction
             * @constructor
             * @param {breacher.v2.ISlideAction=} [properties] Properties to set
             */
            function SlideAction(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SlideAction axis.
             * @member {string} axis
             * @memberof breacher.v2.SlideAction
             * @instance
             */
            SlideAction.prototype.axis = "";

            /**
             * SlideAction index.
             * @member {number} index
             * @memberof breacher.v2.SlideAction
             * @instance
             */
            SlideAction.prototype.index = 0;

            /**
             * SlideAction distance.
             * @member {number} distance
             * @memberof breacher.v2.SlideAction
             * @instance
             */
            SlideAction.prototype.distance = 0;

            /**
             * SlideAction automated.
             * @member {boolean} automated
             * @memberof breacher.v2.SlideAction
             * @instance
             */
            SlideAction.prototype.automated = false;

            /**
             * Creates a new SlideAction instance using the specified properties.
             * @function create
             * @memberof breacher.v2.SlideAction
             * @static
             * @param {breacher.v2.ISlideAction=} [properties] Properties to set
             * @returns {breacher.v2.SlideAction} SlideAction instance
             */
            SlideAction.create = function create(properties) {
                return new SlideAction(properties);
            };

            /**
             * Encodes the specified SlideAction message. Does not implicitly {@link breacher.v2.SlideAction.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.SlideAction
             * @static
             * @param {breacher.v2.ISlideAction} message SlideAction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SlideAction.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.axis != null && Object.hasOwnProperty.call(message, "axis"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.axis);
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.index);
                if (message.distance != null && Object.hasOwnProperty.call(message, "distance"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.distance);
                if (message.automated != null && Object.hasOwnProperty.call(message, "automated"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.automated);
                return writer;
            };

            /**
             * Encodes the specified SlideAction message, length delimited. Does not implicitly {@link breacher.v2.SlideAction.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.SlideAction
             * @static
             * @param {breacher.v2.ISlideAction} message SlideAction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SlideAction.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SlideAction message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.SlideAction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.SlideAction} SlideAction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SlideAction.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.SlideAction();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.axis = reader.string();
                            break;
                        }
                    case 2: {
                            message.index = reader.int32();
                            break;
                        }
                    case 3: {
                            message.distance = reader.int32();
                            break;
                        }
                    case 4: {
                            message.automated = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SlideAction message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.SlideAction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.SlideAction} SlideAction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SlideAction.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SlideAction message.
             * @function verify
             * @memberof breacher.v2.SlideAction
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SlideAction.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.axis != null && message.hasOwnProperty("axis"))
                    if (!$util.isString(message.axis))
                        return "axis: string expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                if (message.distance != null && message.hasOwnProperty("distance"))
                    if (!$util.isInteger(message.distance))
                        return "distance: integer expected";
                if (message.automated != null && message.hasOwnProperty("automated"))
                    if (typeof message.automated !== "boolean")
                        return "automated: boolean expected";
                return null;
            };

            /**
             * Creates a SlideAction message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.SlideAction
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.SlideAction} SlideAction
             */
            SlideAction.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.SlideAction)
                    return object;
                let message = new $root.breacher.v2.SlideAction();
                if (object.axis != null)
                    message.axis = String(object.axis);
                if (object.index != null)
                    message.index = object.index | 0;
                if (object.distance != null)
                    message.distance = object.distance | 0;
                if (object.automated != null)
                    message.automated = Boolean(object.automated);
                return message;
            };

            /**
             * Creates a plain object from a SlideAction message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.SlideAction
             * @static
             * @param {breacher.v2.SlideAction} message SlideAction
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SlideAction.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.axis = "";
                    object.index = 0;
                    object.distance = 0;
                    object.automated = false;
                }
                if (message.axis != null && message.hasOwnProperty("axis"))
                    object.axis = message.axis;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                if (message.distance != null && message.hasOwnProperty("distance"))
                    object.distance = message.distance;
                if (message.automated != null && message.hasOwnProperty("automated"))
                    object.automated = message.automated;
                return object;
            };

            /**
             * Converts this SlideAction to JSON.
             * @function toJSON
             * @memberof breacher.v2.SlideAction
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SlideAction.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SlideAction
             * @function getTypeUrl
             * @memberof breacher.v2.SlideAction
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SlideAction.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.SlideAction";
            };

            return SlideAction;
        })();

        v2.SkillAction = (function() {

            /**
             * Properties of a SkillAction.
             * @memberof breacher.v2
             * @interface ISkillAction
             * @property {string|null} [skill] SkillAction skill
             */

            /**
             * Constructs a new SkillAction.
             * @memberof breacher.v2
             * @classdesc Represents a SkillAction.
             * @implements ISkillAction
             * @constructor
             * @param {breacher.v2.ISkillAction=} [properties] Properties to set
             */
            function SkillAction(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SkillAction skill.
             * @member {string} skill
             * @memberof breacher.v2.SkillAction
             * @instance
             */
            SkillAction.prototype.skill = "";

            /**
             * Creates a new SkillAction instance using the specified properties.
             * @function create
             * @memberof breacher.v2.SkillAction
             * @static
             * @param {breacher.v2.ISkillAction=} [properties] Properties to set
             * @returns {breacher.v2.SkillAction} SkillAction instance
             */
            SkillAction.create = function create(properties) {
                return new SkillAction(properties);
            };

            /**
             * Encodes the specified SkillAction message. Does not implicitly {@link breacher.v2.SkillAction.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.SkillAction
             * @static
             * @param {breacher.v2.ISkillAction} message SkillAction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SkillAction.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.skill != null && Object.hasOwnProperty.call(message, "skill"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.skill);
                return writer;
            };

            /**
             * Encodes the specified SkillAction message, length delimited. Does not implicitly {@link breacher.v2.SkillAction.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.SkillAction
             * @static
             * @param {breacher.v2.ISkillAction} message SkillAction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SkillAction.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SkillAction message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.SkillAction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.SkillAction} SkillAction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SkillAction.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.SkillAction();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.skill = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SkillAction message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.SkillAction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.SkillAction} SkillAction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SkillAction.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SkillAction message.
             * @function verify
             * @memberof breacher.v2.SkillAction
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SkillAction.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.skill != null && message.hasOwnProperty("skill"))
                    if (!$util.isString(message.skill))
                        return "skill: string expected";
                return null;
            };

            /**
             * Creates a SkillAction message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.SkillAction
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.SkillAction} SkillAction
             */
            SkillAction.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.SkillAction)
                    return object;
                let message = new $root.breacher.v2.SkillAction();
                if (object.skill != null)
                    message.skill = String(object.skill);
                return message;
            };

            /**
             * Creates a plain object from a SkillAction message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.SkillAction
             * @static
             * @param {breacher.v2.SkillAction} message SkillAction
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SkillAction.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.skill = "";
                if (message.skill != null && message.hasOwnProperty("skill"))
                    object.skill = message.skill;
                return object;
            };

            /**
             * Converts this SkillAction to JSON.
             * @function toJSON
             * @memberof breacher.v2.SkillAction
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SkillAction.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SkillAction
             * @function getTypeUrl
             * @memberof breacher.v2.SkillAction
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SkillAction.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.SkillAction";
            };

            return SkillAction;
        })();

        v2.LockRowAction = (function() {

            /**
             * Properties of a LockRowAction.
             * @memberof breacher.v2
             * @interface ILockRowAction
             * @property {number|null} [row] LockRowAction row
             */

            /**
             * Constructs a new LockRowAction.
             * @memberof breacher.v2
             * @classdesc Represents a LockRowAction.
             * @implements ILockRowAction
             * @constructor
             * @param {breacher.v2.ILockRowAction=} [properties] Properties to set
             */
            function LockRowAction(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LockRowAction row.
             * @member {number} row
             * @memberof breacher.v2.LockRowAction
             * @instance
             */
            LockRowAction.prototype.row = 0;

            /**
             * Creates a new LockRowAction instance using the specified properties.
             * @function create
             * @memberof breacher.v2.LockRowAction
             * @static
             * @param {breacher.v2.ILockRowAction=} [properties] Properties to set
             * @returns {breacher.v2.LockRowAction} LockRowAction instance
             */
            LockRowAction.create = function create(properties) {
                return new LockRowAction(properties);
            };

            /**
             * Encodes the specified LockRowAction message. Does not implicitly {@link breacher.v2.LockRowAction.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.LockRowAction
             * @static
             * @param {breacher.v2.ILockRowAction} message LockRowAction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LockRowAction.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.row != null && Object.hasOwnProperty.call(message, "row"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.row);
                return writer;
            };

            /**
             * Encodes the specified LockRowAction message, length delimited. Does not implicitly {@link breacher.v2.LockRowAction.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.LockRowAction
             * @static
             * @param {breacher.v2.ILockRowAction} message LockRowAction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LockRowAction.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LockRowAction message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.LockRowAction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.LockRowAction} LockRowAction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LockRowAction.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.LockRowAction();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.row = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LockRowAction message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.LockRowAction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.LockRowAction} LockRowAction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LockRowAction.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LockRowAction message.
             * @function verify
             * @memberof breacher.v2.LockRowAction
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LockRowAction.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.row != null && message.hasOwnProperty("row"))
                    if (!$util.isInteger(message.row))
                        return "row: integer expected";
                return null;
            };

            /**
             * Creates a LockRowAction message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.LockRowAction
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.LockRowAction} LockRowAction
             */
            LockRowAction.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.LockRowAction)
                    return object;
                let message = new $root.breacher.v2.LockRowAction();
                if (object.row != null)
                    message.row = object.row | 0;
                return message;
            };

            /**
             * Creates a plain object from a LockRowAction message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.LockRowAction
             * @static
             * @param {breacher.v2.LockRowAction} message LockRowAction
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LockRowAction.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.row = 0;
                if (message.row != null && message.hasOwnProperty("row"))
                    object.row = message.row;
                return object;
            };

            /**
             * Converts this LockRowAction to JSON.
             * @function toJSON
             * @memberof breacher.v2.LockRowAction
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LockRowAction.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LockRowAction
             * @function getTypeUrl
             * @memberof breacher.v2.LockRowAction
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LockRowAction.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.LockRowAction";
            };

            return LockRowAction;
        })();

        v2.ChestAction = (function() {

            /**
             * Properties of a ChestAction.
             * @memberof breacher.v2
             * @interface IChestAction
             * @property {boolean|null} [open] ChestAction open
             */

            /**
             * Constructs a new ChestAction.
             * @memberof breacher.v2
             * @classdesc Represents a ChestAction.
             * @implements IChestAction
             * @constructor
             * @param {breacher.v2.IChestAction=} [properties] Properties to set
             */
            function ChestAction(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ChestAction open.
             * @member {boolean} open
             * @memberof breacher.v2.ChestAction
             * @instance
             */
            ChestAction.prototype.open = false;

            /**
             * Creates a new ChestAction instance using the specified properties.
             * @function create
             * @memberof breacher.v2.ChestAction
             * @static
             * @param {breacher.v2.IChestAction=} [properties] Properties to set
             * @returns {breacher.v2.ChestAction} ChestAction instance
             */
            ChestAction.create = function create(properties) {
                return new ChestAction(properties);
            };

            /**
             * Encodes the specified ChestAction message. Does not implicitly {@link breacher.v2.ChestAction.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.ChestAction
             * @static
             * @param {breacher.v2.IChestAction} message ChestAction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ChestAction.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.open != null && Object.hasOwnProperty.call(message, "open"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.open);
                return writer;
            };

            /**
             * Encodes the specified ChestAction message, length delimited. Does not implicitly {@link breacher.v2.ChestAction.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.ChestAction
             * @static
             * @param {breacher.v2.IChestAction} message ChestAction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ChestAction.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ChestAction message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.ChestAction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.ChestAction} ChestAction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ChestAction.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.ChestAction();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.open = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ChestAction message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.ChestAction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.ChestAction} ChestAction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ChestAction.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ChestAction message.
             * @function verify
             * @memberof breacher.v2.ChestAction
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ChestAction.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.open != null && message.hasOwnProperty("open"))
                    if (typeof message.open !== "boolean")
                        return "open: boolean expected";
                return null;
            };

            /**
             * Creates a ChestAction message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.ChestAction
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.ChestAction} ChestAction
             */
            ChestAction.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.ChestAction)
                    return object;
                let message = new $root.breacher.v2.ChestAction();
                if (object.open != null)
                    message.open = Boolean(object.open);
                return message;
            };

            /**
             * Creates a plain object from a ChestAction message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.ChestAction
             * @static
             * @param {breacher.v2.ChestAction} message ChestAction
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ChestAction.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.open = false;
                if (message.open != null && message.hasOwnProperty("open"))
                    object.open = message.open;
                return object;
            };

            /**
             * Converts this ChestAction to JSON.
             * @function toJSON
             * @memberof breacher.v2.ChestAction
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ChestAction.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ChestAction
             * @function getTypeUrl
             * @memberof breacher.v2.ChestAction
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ChestAction.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.ChestAction";
            };

            return ChestAction;
        })();

        v2.RetreatAction = (function() {

            /**
             * Properties of a RetreatAction.
             * @memberof breacher.v2
             * @interface IRetreatAction
             */

            /**
             * Constructs a new RetreatAction.
             * @memberof breacher.v2
             * @classdesc Represents a RetreatAction.
             * @implements IRetreatAction
             * @constructor
             * @param {breacher.v2.IRetreatAction=} [properties] Properties to set
             */
            function RetreatAction(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RetreatAction instance using the specified properties.
             * @function create
             * @memberof breacher.v2.RetreatAction
             * @static
             * @param {breacher.v2.IRetreatAction=} [properties] Properties to set
             * @returns {breacher.v2.RetreatAction} RetreatAction instance
             */
            RetreatAction.create = function create(properties) {
                return new RetreatAction(properties);
            };

            /**
             * Encodes the specified RetreatAction message. Does not implicitly {@link breacher.v2.RetreatAction.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.RetreatAction
             * @static
             * @param {breacher.v2.IRetreatAction} message RetreatAction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RetreatAction.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RetreatAction message, length delimited. Does not implicitly {@link breacher.v2.RetreatAction.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.RetreatAction
             * @static
             * @param {breacher.v2.IRetreatAction} message RetreatAction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RetreatAction.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RetreatAction message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.RetreatAction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.RetreatAction} RetreatAction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RetreatAction.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.RetreatAction();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RetreatAction message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.RetreatAction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.RetreatAction} RetreatAction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RetreatAction.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RetreatAction message.
             * @function verify
             * @memberof breacher.v2.RetreatAction
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RetreatAction.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RetreatAction message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.RetreatAction
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.RetreatAction} RetreatAction
             */
            RetreatAction.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.RetreatAction)
                    return object;
                return new $root.breacher.v2.RetreatAction();
            };

            /**
             * Creates a plain object from a RetreatAction message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.RetreatAction
             * @static
             * @param {breacher.v2.RetreatAction} message RetreatAction
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RetreatAction.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RetreatAction to JSON.
             * @function toJSON
             * @memberof breacher.v2.RetreatAction
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RetreatAction.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RetreatAction
             * @function getTypeUrl
             * @memberof breacher.v2.RetreatAction
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RetreatAction.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.RetreatAction";
            };

            return RetreatAction;
        })();

        v2.RunOperation = (function() {

            /**
             * Properties of a RunOperation.
             * @memberof breacher.v2
             * @interface IRunOperation
             * @property {string|null} [runId] RunOperation runId
             * @property {number|Long|null} [opSeq] RunOperation opSeq
             * @property {string|null} [opId] RunOperation opId
             * @property {number|Long|null} [clientTickMs] RunOperation clientTickMs
             * @property {breacher.v2.IStateHash|null} [preStateHash] RunOperation preStateHash
             * @property {breacher.v2.ISlideAction|null} [slide] RunOperation slide
             * @property {breacher.v2.ISkillAction|null} [skill] RunOperation skill
             * @property {breacher.v2.ILockRowAction|null} [lockRow] RunOperation lockRow
             * @property {breacher.v2.IChestAction|null} [chest] RunOperation chest
             * @property {breacher.v2.IRetreatAction|null} [retreat] RunOperation retreat
             */

            /**
             * Constructs a new RunOperation.
             * @memberof breacher.v2
             * @classdesc Represents a RunOperation.
             * @implements IRunOperation
             * @constructor
             * @param {breacher.v2.IRunOperation=} [properties] Properties to set
             */
            function RunOperation(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RunOperation runId.
             * @member {string} runId
             * @memberof breacher.v2.RunOperation
             * @instance
             */
            RunOperation.prototype.runId = "";

            /**
             * RunOperation opSeq.
             * @member {number|Long} opSeq
             * @memberof breacher.v2.RunOperation
             * @instance
             */
            RunOperation.prototype.opSeq = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * RunOperation opId.
             * @member {string} opId
             * @memberof breacher.v2.RunOperation
             * @instance
             */
            RunOperation.prototype.opId = "";

            /**
             * RunOperation clientTickMs.
             * @member {number|Long} clientTickMs
             * @memberof breacher.v2.RunOperation
             * @instance
             */
            RunOperation.prototype.clientTickMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * RunOperation preStateHash.
             * @member {breacher.v2.IStateHash|null|undefined} preStateHash
             * @memberof breacher.v2.RunOperation
             * @instance
             */
            RunOperation.prototype.preStateHash = null;

            /**
             * RunOperation slide.
             * @member {breacher.v2.ISlideAction|null|undefined} slide
             * @memberof breacher.v2.RunOperation
             * @instance
             */
            RunOperation.prototype.slide = null;

            /**
             * RunOperation skill.
             * @member {breacher.v2.ISkillAction|null|undefined} skill
             * @memberof breacher.v2.RunOperation
             * @instance
             */
            RunOperation.prototype.skill = null;

            /**
             * RunOperation lockRow.
             * @member {breacher.v2.ILockRowAction|null|undefined} lockRow
             * @memberof breacher.v2.RunOperation
             * @instance
             */
            RunOperation.prototype.lockRow = null;

            /**
             * RunOperation chest.
             * @member {breacher.v2.IChestAction|null|undefined} chest
             * @memberof breacher.v2.RunOperation
             * @instance
             */
            RunOperation.prototype.chest = null;

            /**
             * RunOperation retreat.
             * @member {breacher.v2.IRetreatAction|null|undefined} retreat
             * @memberof breacher.v2.RunOperation
             * @instance
             */
            RunOperation.prototype.retreat = null;

            // OneOf field names bound to virtual getters and setters
            let $oneOfFields;

            /**
             * RunOperation action.
             * @member {"slide"|"skill"|"lockRow"|"chest"|"retreat"|undefined} action
             * @memberof breacher.v2.RunOperation
             * @instance
             */
            Object.defineProperty(RunOperation.prototype, "action", {
                get: $util.oneOfGetter($oneOfFields = ["slide", "skill", "lockRow", "chest", "retreat"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new RunOperation instance using the specified properties.
             * @function create
             * @memberof breacher.v2.RunOperation
             * @static
             * @param {breacher.v2.IRunOperation=} [properties] Properties to set
             * @returns {breacher.v2.RunOperation} RunOperation instance
             */
            RunOperation.create = function create(properties) {
                return new RunOperation(properties);
            };

            /**
             * Encodes the specified RunOperation message. Does not implicitly {@link breacher.v2.RunOperation.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.RunOperation
             * @static
             * @param {breacher.v2.IRunOperation} message RunOperation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunOperation.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.runId != null && Object.hasOwnProperty.call(message, "runId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.runId);
                if (message.opSeq != null && Object.hasOwnProperty.call(message, "opSeq"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.opSeq);
                if (message.opId != null && Object.hasOwnProperty.call(message, "opId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.opId);
                if (message.clientTickMs != null && Object.hasOwnProperty.call(message, "clientTickMs"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.clientTickMs);
                if (message.preStateHash != null && Object.hasOwnProperty.call(message, "preStateHash"))
                    $root.breacher.v2.StateHash.encode(message.preStateHash, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.slide != null && Object.hasOwnProperty.call(message, "slide"))
                    $root.breacher.v2.SlideAction.encode(message.slide, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.skill != null && Object.hasOwnProperty.call(message, "skill"))
                    $root.breacher.v2.SkillAction.encode(message.skill, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.lockRow != null && Object.hasOwnProperty.call(message, "lockRow"))
                    $root.breacher.v2.LockRowAction.encode(message.lockRow, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.chest != null && Object.hasOwnProperty.call(message, "chest"))
                    $root.breacher.v2.ChestAction.encode(message.chest, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                if (message.retreat != null && Object.hasOwnProperty.call(message, "retreat"))
                    $root.breacher.v2.RetreatAction.encode(message.retreat, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified RunOperation message, length delimited. Does not implicitly {@link breacher.v2.RunOperation.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.RunOperation
             * @static
             * @param {breacher.v2.IRunOperation} message RunOperation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunOperation.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RunOperation message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.RunOperation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.RunOperation} RunOperation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunOperation.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.RunOperation();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.runId = reader.string();
                            break;
                        }
                    case 2: {
                            message.opSeq = reader.uint64();
                            break;
                        }
                    case 3: {
                            message.opId = reader.string();
                            break;
                        }
                    case 4: {
                            message.clientTickMs = reader.int64();
                            break;
                        }
                    case 5: {
                            message.preStateHash = $root.breacher.v2.StateHash.decode(reader, reader.uint32());
                            break;
                        }
                    case 10: {
                            message.slide = $root.breacher.v2.SlideAction.decode(reader, reader.uint32());
                            break;
                        }
                    case 11: {
                            message.skill = $root.breacher.v2.SkillAction.decode(reader, reader.uint32());
                            break;
                        }
                    case 12: {
                            message.lockRow = $root.breacher.v2.LockRowAction.decode(reader, reader.uint32());
                            break;
                        }
                    case 13: {
                            message.chest = $root.breacher.v2.ChestAction.decode(reader, reader.uint32());
                            break;
                        }
                    case 14: {
                            message.retreat = $root.breacher.v2.RetreatAction.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RunOperation message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.RunOperation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.RunOperation} RunOperation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunOperation.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RunOperation message.
             * @function verify
             * @memberof breacher.v2.RunOperation
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RunOperation.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                let properties = {};
                if (message.runId != null && message.hasOwnProperty("runId"))
                    if (!$util.isString(message.runId))
                        return "runId: string expected";
                if (message.opSeq != null && message.hasOwnProperty("opSeq"))
                    if (!$util.isInteger(message.opSeq) && !(message.opSeq && $util.isInteger(message.opSeq.low) && $util.isInteger(message.opSeq.high)))
                        return "opSeq: integer|Long expected";
                if (message.opId != null && message.hasOwnProperty("opId"))
                    if (!$util.isString(message.opId))
                        return "opId: string expected";
                if (message.clientTickMs != null && message.hasOwnProperty("clientTickMs"))
                    if (!$util.isInteger(message.clientTickMs) && !(message.clientTickMs && $util.isInteger(message.clientTickMs.low) && $util.isInteger(message.clientTickMs.high)))
                        return "clientTickMs: integer|Long expected";
                if (message.preStateHash != null && message.hasOwnProperty("preStateHash")) {
                    let error = $root.breacher.v2.StateHash.verify(message.preStateHash);
                    if (error)
                        return "preStateHash." + error;
                }
                if (message.slide != null && message.hasOwnProperty("slide")) {
                    properties.action = 1;
                    {
                        let error = $root.breacher.v2.SlideAction.verify(message.slide);
                        if (error)
                            return "slide." + error;
                    }
                }
                if (message.skill != null && message.hasOwnProperty("skill")) {
                    if (properties.action === 1)
                        return "action: multiple values";
                    properties.action = 1;
                    {
                        let error = $root.breacher.v2.SkillAction.verify(message.skill);
                        if (error)
                            return "skill." + error;
                    }
                }
                if (message.lockRow != null && message.hasOwnProperty("lockRow")) {
                    if (properties.action === 1)
                        return "action: multiple values";
                    properties.action = 1;
                    {
                        let error = $root.breacher.v2.LockRowAction.verify(message.lockRow);
                        if (error)
                            return "lockRow." + error;
                    }
                }
                if (message.chest != null && message.hasOwnProperty("chest")) {
                    if (properties.action === 1)
                        return "action: multiple values";
                    properties.action = 1;
                    {
                        let error = $root.breacher.v2.ChestAction.verify(message.chest);
                        if (error)
                            return "chest." + error;
                    }
                }
                if (message.retreat != null && message.hasOwnProperty("retreat")) {
                    if (properties.action === 1)
                        return "action: multiple values";
                    properties.action = 1;
                    {
                        let error = $root.breacher.v2.RetreatAction.verify(message.retreat);
                        if (error)
                            return "retreat." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a RunOperation message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.RunOperation
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.RunOperation} RunOperation
             */
            RunOperation.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.RunOperation)
                    return object;
                let message = new $root.breacher.v2.RunOperation();
                if (object.runId != null)
                    message.runId = String(object.runId);
                if (object.opSeq != null)
                    if ($util.Long)
                        (message.opSeq = $util.Long.fromValue(object.opSeq)).unsigned = true;
                    else if (typeof object.opSeq === "string")
                        message.opSeq = parseInt(object.opSeq, 10);
                    else if (typeof object.opSeq === "number")
                        message.opSeq = object.opSeq;
                    else if (typeof object.opSeq === "object")
                        message.opSeq = new $util.LongBits(object.opSeq.low >>> 0, object.opSeq.high >>> 0).toNumber(true);
                if (object.opId != null)
                    message.opId = String(object.opId);
                if (object.clientTickMs != null)
                    if ($util.Long)
                        (message.clientTickMs = $util.Long.fromValue(object.clientTickMs)).unsigned = false;
                    else if (typeof object.clientTickMs === "string")
                        message.clientTickMs = parseInt(object.clientTickMs, 10);
                    else if (typeof object.clientTickMs === "number")
                        message.clientTickMs = object.clientTickMs;
                    else if (typeof object.clientTickMs === "object")
                        message.clientTickMs = new $util.LongBits(object.clientTickMs.low >>> 0, object.clientTickMs.high >>> 0).toNumber();
                if (object.preStateHash != null) {
                    if (typeof object.preStateHash !== "object")
                        throw TypeError(".breacher.v2.RunOperation.preStateHash: object expected");
                    message.preStateHash = $root.breacher.v2.StateHash.fromObject(object.preStateHash);
                }
                if (object.slide != null) {
                    if (typeof object.slide !== "object")
                        throw TypeError(".breacher.v2.RunOperation.slide: object expected");
                    message.slide = $root.breacher.v2.SlideAction.fromObject(object.slide);
                }
                if (object.skill != null) {
                    if (typeof object.skill !== "object")
                        throw TypeError(".breacher.v2.RunOperation.skill: object expected");
                    message.skill = $root.breacher.v2.SkillAction.fromObject(object.skill);
                }
                if (object.lockRow != null) {
                    if (typeof object.lockRow !== "object")
                        throw TypeError(".breacher.v2.RunOperation.lockRow: object expected");
                    message.lockRow = $root.breacher.v2.LockRowAction.fromObject(object.lockRow);
                }
                if (object.chest != null) {
                    if (typeof object.chest !== "object")
                        throw TypeError(".breacher.v2.RunOperation.chest: object expected");
                    message.chest = $root.breacher.v2.ChestAction.fromObject(object.chest);
                }
                if (object.retreat != null) {
                    if (typeof object.retreat !== "object")
                        throw TypeError(".breacher.v2.RunOperation.retreat: object expected");
                    message.retreat = $root.breacher.v2.RetreatAction.fromObject(object.retreat);
                }
                return message;
            };

            /**
             * Creates a plain object from a RunOperation message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.RunOperation
             * @static
             * @param {breacher.v2.RunOperation} message RunOperation
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RunOperation.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.runId = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.opSeq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.opSeq = options.longs === String ? "0" : 0;
                    object.opId = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.clientTickMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.clientTickMs = options.longs === String ? "0" : 0;
                    object.preStateHash = null;
                }
                if (message.runId != null && message.hasOwnProperty("runId"))
                    object.runId = message.runId;
                if (message.opSeq != null && message.hasOwnProperty("opSeq"))
                    if (typeof message.opSeq === "number")
                        object.opSeq = options.longs === String ? String(message.opSeq) : message.opSeq;
                    else
                        object.opSeq = options.longs === String ? $util.Long.prototype.toString.call(message.opSeq) : options.longs === Number ? new $util.LongBits(message.opSeq.low >>> 0, message.opSeq.high >>> 0).toNumber(true) : message.opSeq;
                if (message.opId != null && message.hasOwnProperty("opId"))
                    object.opId = message.opId;
                if (message.clientTickMs != null && message.hasOwnProperty("clientTickMs"))
                    if (typeof message.clientTickMs === "number")
                        object.clientTickMs = options.longs === String ? String(message.clientTickMs) : message.clientTickMs;
                    else
                        object.clientTickMs = options.longs === String ? $util.Long.prototype.toString.call(message.clientTickMs) : options.longs === Number ? new $util.LongBits(message.clientTickMs.low >>> 0, message.clientTickMs.high >>> 0).toNumber() : message.clientTickMs;
                if (message.preStateHash != null && message.hasOwnProperty("preStateHash"))
                    object.preStateHash = $root.breacher.v2.StateHash.toObject(message.preStateHash, options);
                if (message.slide != null && message.hasOwnProperty("slide")) {
                    object.slide = $root.breacher.v2.SlideAction.toObject(message.slide, options);
                    if (options.oneofs)
                        object.action = "slide";
                }
                if (message.skill != null && message.hasOwnProperty("skill")) {
                    object.skill = $root.breacher.v2.SkillAction.toObject(message.skill, options);
                    if (options.oneofs)
                        object.action = "skill";
                }
                if (message.lockRow != null && message.hasOwnProperty("lockRow")) {
                    object.lockRow = $root.breacher.v2.LockRowAction.toObject(message.lockRow, options);
                    if (options.oneofs)
                        object.action = "lockRow";
                }
                if (message.chest != null && message.hasOwnProperty("chest")) {
                    object.chest = $root.breacher.v2.ChestAction.toObject(message.chest, options);
                    if (options.oneofs)
                        object.action = "chest";
                }
                if (message.retreat != null && message.hasOwnProperty("retreat")) {
                    object.retreat = $root.breacher.v2.RetreatAction.toObject(message.retreat, options);
                    if (options.oneofs)
                        object.action = "retreat";
                }
                return object;
            };

            /**
             * Converts this RunOperation to JSON.
             * @function toJSON
             * @memberof breacher.v2.RunOperation
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RunOperation.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RunOperation
             * @function getTypeUrl
             * @memberof breacher.v2.RunOperation
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RunOperation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.RunOperation";
            };

            return RunOperation;
        })();

        v2.RunEvent = (function() {

            /**
             * Properties of a RunEvent.
             * @memberof breacher.v2
             * @interface IRunEvent
             * @property {string|null} [type] RunEvent type
             * @property {number|Long|null} [atMs] RunEvent atMs
             * @property {breacher.v2.IWireValue|null} [payload] RunEvent payload
             */

            /**
             * Constructs a new RunEvent.
             * @memberof breacher.v2
             * @classdesc Represents a RunEvent.
             * @implements IRunEvent
             * @constructor
             * @param {breacher.v2.IRunEvent=} [properties] Properties to set
             */
            function RunEvent(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RunEvent type.
             * @member {string} type
             * @memberof breacher.v2.RunEvent
             * @instance
             */
            RunEvent.prototype.type = "";

            /**
             * RunEvent atMs.
             * @member {number|Long} atMs
             * @memberof breacher.v2.RunEvent
             * @instance
             */
            RunEvent.prototype.atMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * RunEvent payload.
             * @member {breacher.v2.IWireValue|null|undefined} payload
             * @memberof breacher.v2.RunEvent
             * @instance
             */
            RunEvent.prototype.payload = null;

            /**
             * Creates a new RunEvent instance using the specified properties.
             * @function create
             * @memberof breacher.v2.RunEvent
             * @static
             * @param {breacher.v2.IRunEvent=} [properties] Properties to set
             * @returns {breacher.v2.RunEvent} RunEvent instance
             */
            RunEvent.create = function create(properties) {
                return new RunEvent(properties);
            };

            /**
             * Encodes the specified RunEvent message. Does not implicitly {@link breacher.v2.RunEvent.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.RunEvent
             * @static
             * @param {breacher.v2.IRunEvent} message RunEvent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunEvent.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                if (message.atMs != null && Object.hasOwnProperty.call(message, "atMs"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.atMs);
                if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
                    $root.breacher.v2.WireValue.encode(message.payload, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified RunEvent message, length delimited. Does not implicitly {@link breacher.v2.RunEvent.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.RunEvent
             * @static
             * @param {breacher.v2.IRunEvent} message RunEvent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunEvent.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RunEvent message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.RunEvent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.RunEvent} RunEvent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunEvent.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.RunEvent();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.type = reader.string();
                            break;
                        }
                    case 2: {
                            message.atMs = reader.int64();
                            break;
                        }
                    case 3: {
                            message.payload = $root.breacher.v2.WireValue.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RunEvent message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.RunEvent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.RunEvent} RunEvent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunEvent.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RunEvent message.
             * @function verify
             * @memberof breacher.v2.RunEvent
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RunEvent.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.atMs != null && message.hasOwnProperty("atMs"))
                    if (!$util.isInteger(message.atMs) && !(message.atMs && $util.isInteger(message.atMs.low) && $util.isInteger(message.atMs.high)))
                        return "atMs: integer|Long expected";
                if (message.payload != null && message.hasOwnProperty("payload")) {
                    let error = $root.breacher.v2.WireValue.verify(message.payload);
                    if (error)
                        return "payload." + error;
                }
                return null;
            };

            /**
             * Creates a RunEvent message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.RunEvent
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.RunEvent} RunEvent
             */
            RunEvent.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.RunEvent)
                    return object;
                let message = new $root.breacher.v2.RunEvent();
                if (object.type != null)
                    message.type = String(object.type);
                if (object.atMs != null)
                    if ($util.Long)
                        (message.atMs = $util.Long.fromValue(object.atMs)).unsigned = false;
                    else if (typeof object.atMs === "string")
                        message.atMs = parseInt(object.atMs, 10);
                    else if (typeof object.atMs === "number")
                        message.atMs = object.atMs;
                    else if (typeof object.atMs === "object")
                        message.atMs = new $util.LongBits(object.atMs.low >>> 0, object.atMs.high >>> 0).toNumber();
                if (object.payload != null) {
                    if (typeof object.payload !== "object")
                        throw TypeError(".breacher.v2.RunEvent.payload: object expected");
                    message.payload = $root.breacher.v2.WireValue.fromObject(object.payload);
                }
                return message;
            };

            /**
             * Creates a plain object from a RunEvent message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.RunEvent
             * @static
             * @param {breacher.v2.RunEvent} message RunEvent
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RunEvent.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.type = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.atMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.atMs = options.longs === String ? "0" : 0;
                    object.payload = null;
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.atMs != null && message.hasOwnProperty("atMs"))
                    if (typeof message.atMs === "number")
                        object.atMs = options.longs === String ? String(message.atMs) : message.atMs;
                    else
                        object.atMs = options.longs === String ? $util.Long.prototype.toString.call(message.atMs) : options.longs === Number ? new $util.LongBits(message.atMs.low >>> 0, message.atMs.high >>> 0).toNumber() : message.atMs;
                if (message.payload != null && message.hasOwnProperty("payload"))
                    object.payload = $root.breacher.v2.WireValue.toObject(message.payload, options);
                return object;
            };

            /**
             * Converts this RunEvent to JSON.
             * @function toJSON
             * @memberof breacher.v2.RunEvent
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RunEvent.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RunEvent
             * @function getTypeUrl
             * @memberof breacher.v2.RunEvent
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RunEvent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.RunEvent";
            };

            return RunEvent;
        })();

        v2.RandomChunk = (function() {

            /**
             * Properties of a RandomChunk.
             * @memberof breacher.v2
             * @interface IRandomChunk
             * @property {number|Long|null} [index] RandomChunk index
             * @property {Array.<number>|null} [values] RandomChunk values
             */

            /**
             * Constructs a new RandomChunk.
             * @memberof breacher.v2
             * @classdesc Represents a RandomChunk.
             * @implements IRandomChunk
             * @constructor
             * @param {breacher.v2.IRandomChunk=} [properties] Properties to set
             */
            function RandomChunk(properties) {
                this.values = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RandomChunk index.
             * @member {number|Long} index
             * @memberof breacher.v2.RandomChunk
             * @instance
             */
            RandomChunk.prototype.index = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * RandomChunk values.
             * @member {Array.<number>} values
             * @memberof breacher.v2.RandomChunk
             * @instance
             */
            RandomChunk.prototype.values = $util.emptyArray;

            /**
             * Creates a new RandomChunk instance using the specified properties.
             * @function create
             * @memberof breacher.v2.RandomChunk
             * @static
             * @param {breacher.v2.IRandomChunk=} [properties] Properties to set
             * @returns {breacher.v2.RandomChunk} RandomChunk instance
             */
            RandomChunk.create = function create(properties) {
                return new RandomChunk(properties);
            };

            /**
             * Encodes the specified RandomChunk message. Does not implicitly {@link breacher.v2.RandomChunk.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.RandomChunk
             * @static
             * @param {breacher.v2.IRandomChunk} message RandomChunk message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RandomChunk.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.index);
                if (message.values != null && message.values.length) {
                    writer.uint32(/* id 2, wireType 2 =*/18).fork();
                    for (let i = 0; i < message.values.length; ++i)
                        writer.fixed32(message.values[i]);
                    writer.ldelim();
                }
                return writer;
            };

            /**
             * Encodes the specified RandomChunk message, length delimited. Does not implicitly {@link breacher.v2.RandomChunk.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.RandomChunk
             * @static
             * @param {breacher.v2.IRandomChunk} message RandomChunk message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RandomChunk.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RandomChunk message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.RandomChunk
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.RandomChunk} RandomChunk
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RandomChunk.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.RandomChunk();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.uint64();
                            break;
                        }
                    case 2: {
                            if (!(message.values && message.values.length))
                                message.values = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.values.push(reader.fixed32());
                            } else
                                message.values.push(reader.fixed32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RandomChunk message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.RandomChunk
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.RandomChunk} RandomChunk
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RandomChunk.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RandomChunk message.
             * @function verify
             * @memberof breacher.v2.RandomChunk
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RandomChunk.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index) && !(message.index && $util.isInteger(message.index.low) && $util.isInteger(message.index.high)))
                        return "index: integer|Long expected";
                if (message.values != null && message.hasOwnProperty("values")) {
                    if (!Array.isArray(message.values))
                        return "values: array expected";
                    for (let i = 0; i < message.values.length; ++i)
                        if (!$util.isInteger(message.values[i]))
                            return "values: integer[] expected";
                }
                return null;
            };

            /**
             * Creates a RandomChunk message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.RandomChunk
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.RandomChunk} RandomChunk
             */
            RandomChunk.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.RandomChunk)
                    return object;
                let message = new $root.breacher.v2.RandomChunk();
                if (object.index != null)
                    if ($util.Long)
                        (message.index = $util.Long.fromValue(object.index)).unsigned = true;
                    else if (typeof object.index === "string")
                        message.index = parseInt(object.index, 10);
                    else if (typeof object.index === "number")
                        message.index = object.index;
                    else if (typeof object.index === "object")
                        message.index = new $util.LongBits(object.index.low >>> 0, object.index.high >>> 0).toNumber(true);
                if (object.values) {
                    if (!Array.isArray(object.values))
                        throw TypeError(".breacher.v2.RandomChunk.values: array expected");
                    message.values = [];
                    for (let i = 0; i < object.values.length; ++i)
                        message.values[i] = object.values[i] >>> 0;
                }
                return message;
            };

            /**
             * Creates a plain object from a RandomChunk message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.RandomChunk
             * @static
             * @param {breacher.v2.RandomChunk} message RandomChunk
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RandomChunk.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.values = [];
                if (options.defaults)
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.index = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.index = options.longs === String ? "0" : 0;
                if (message.index != null && message.hasOwnProperty("index"))
                    if (typeof message.index === "number")
                        object.index = options.longs === String ? String(message.index) : message.index;
                    else
                        object.index = options.longs === String ? $util.Long.prototype.toString.call(message.index) : options.longs === Number ? new $util.LongBits(message.index.low >>> 0, message.index.high >>> 0).toNumber(true) : message.index;
                if (message.values && message.values.length) {
                    object.values = [];
                    for (let j = 0; j < message.values.length; ++j)
                        object.values[j] = message.values[j];
                }
                return object;
            };

            /**
             * Converts this RandomChunk to JSON.
             * @function toJSON
             * @memberof breacher.v2.RandomChunk
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RandomChunk.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RandomChunk
             * @function getTypeUrl
             * @memberof breacher.v2.RandomChunk
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RandomChunk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.RandomChunk";
            };

            return RandomChunk;
        })();

        v2.RandomWindowDelta = (function() {

            /**
             * Properties of a RandomWindowDelta.
             * @memberof breacher.v2
             * @interface IRandomWindowDelta
             * @property {number|Long|null} [consumed] RandomWindowDelta consumed
             * @property {number|null} [offset] RandomWindowDelta offset
             * @property {number|null} [prefetchAfter] RandomWindowDelta prefetchAfter
             * @property {Array.<breacher.v2.IRandomChunk>|null} [chunks] RandomWindowDelta chunks
             */

            /**
             * Constructs a new RandomWindowDelta.
             * @memberof breacher.v2
             * @classdesc Represents a RandomWindowDelta.
             * @implements IRandomWindowDelta
             * @constructor
             * @param {breacher.v2.IRandomWindowDelta=} [properties] Properties to set
             */
            function RandomWindowDelta(properties) {
                this.chunks = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RandomWindowDelta consumed.
             * @member {number|Long} consumed
             * @memberof breacher.v2.RandomWindowDelta
             * @instance
             */
            RandomWindowDelta.prototype.consumed = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * RandomWindowDelta offset.
             * @member {number} offset
             * @memberof breacher.v2.RandomWindowDelta
             * @instance
             */
            RandomWindowDelta.prototype.offset = 0;

            /**
             * RandomWindowDelta prefetchAfter.
             * @member {number} prefetchAfter
             * @memberof breacher.v2.RandomWindowDelta
             * @instance
             */
            RandomWindowDelta.prototype.prefetchAfter = 0;

            /**
             * RandomWindowDelta chunks.
             * @member {Array.<breacher.v2.IRandomChunk>} chunks
             * @memberof breacher.v2.RandomWindowDelta
             * @instance
             */
            RandomWindowDelta.prototype.chunks = $util.emptyArray;

            /**
             * Creates a new RandomWindowDelta instance using the specified properties.
             * @function create
             * @memberof breacher.v2.RandomWindowDelta
             * @static
             * @param {breacher.v2.IRandomWindowDelta=} [properties] Properties to set
             * @returns {breacher.v2.RandomWindowDelta} RandomWindowDelta instance
             */
            RandomWindowDelta.create = function create(properties) {
                return new RandomWindowDelta(properties);
            };

            /**
             * Encodes the specified RandomWindowDelta message. Does not implicitly {@link breacher.v2.RandomWindowDelta.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.RandomWindowDelta
             * @static
             * @param {breacher.v2.IRandomWindowDelta} message RandomWindowDelta message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RandomWindowDelta.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.consumed != null && Object.hasOwnProperty.call(message, "consumed"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.consumed);
                if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.offset);
                if (message.prefetchAfter != null && Object.hasOwnProperty.call(message, "prefetchAfter"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.prefetchAfter);
                if (message.chunks != null && message.chunks.length)
                    for (let i = 0; i < message.chunks.length; ++i)
                        $root.breacher.v2.RandomChunk.encode(message.chunks[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified RandomWindowDelta message, length delimited. Does not implicitly {@link breacher.v2.RandomWindowDelta.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.RandomWindowDelta
             * @static
             * @param {breacher.v2.IRandomWindowDelta} message RandomWindowDelta message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RandomWindowDelta.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RandomWindowDelta message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.RandomWindowDelta
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.RandomWindowDelta} RandomWindowDelta
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RandomWindowDelta.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.RandomWindowDelta();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.consumed = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.offset = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.prefetchAfter = reader.uint32();
                            break;
                        }
                    case 4: {
                            if (!(message.chunks && message.chunks.length))
                                message.chunks = [];
                            message.chunks.push($root.breacher.v2.RandomChunk.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RandomWindowDelta message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.RandomWindowDelta
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.RandomWindowDelta} RandomWindowDelta
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RandomWindowDelta.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RandomWindowDelta message.
             * @function verify
             * @memberof breacher.v2.RandomWindowDelta
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RandomWindowDelta.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.consumed != null && message.hasOwnProperty("consumed"))
                    if (!$util.isInteger(message.consumed) && !(message.consumed && $util.isInteger(message.consumed.low) && $util.isInteger(message.consumed.high)))
                        return "consumed: integer|Long expected";
                if (message.offset != null && message.hasOwnProperty("offset"))
                    if (!$util.isInteger(message.offset))
                        return "offset: integer expected";
                if (message.prefetchAfter != null && message.hasOwnProperty("prefetchAfter"))
                    if (!$util.isInteger(message.prefetchAfter))
                        return "prefetchAfter: integer expected";
                if (message.chunks != null && message.hasOwnProperty("chunks")) {
                    if (!Array.isArray(message.chunks))
                        return "chunks: array expected";
                    for (let i = 0; i < message.chunks.length; ++i) {
                        let error = $root.breacher.v2.RandomChunk.verify(message.chunks[i]);
                        if (error)
                            return "chunks." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a RandomWindowDelta message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.RandomWindowDelta
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.RandomWindowDelta} RandomWindowDelta
             */
            RandomWindowDelta.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.RandomWindowDelta)
                    return object;
                let message = new $root.breacher.v2.RandomWindowDelta();
                if (object.consumed != null)
                    if ($util.Long)
                        (message.consumed = $util.Long.fromValue(object.consumed)).unsigned = true;
                    else if (typeof object.consumed === "string")
                        message.consumed = parseInt(object.consumed, 10);
                    else if (typeof object.consumed === "number")
                        message.consumed = object.consumed;
                    else if (typeof object.consumed === "object")
                        message.consumed = new $util.LongBits(object.consumed.low >>> 0, object.consumed.high >>> 0).toNumber(true);
                if (object.offset != null)
                    message.offset = object.offset >>> 0;
                if (object.prefetchAfter != null)
                    message.prefetchAfter = object.prefetchAfter >>> 0;
                if (object.chunks) {
                    if (!Array.isArray(object.chunks))
                        throw TypeError(".breacher.v2.RandomWindowDelta.chunks: array expected");
                    message.chunks = [];
                    for (let i = 0; i < object.chunks.length; ++i) {
                        if (typeof object.chunks[i] !== "object")
                            throw TypeError(".breacher.v2.RandomWindowDelta.chunks: object expected");
                        message.chunks[i] = $root.breacher.v2.RandomChunk.fromObject(object.chunks[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a RandomWindowDelta message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.RandomWindowDelta
             * @static
             * @param {breacher.v2.RandomWindowDelta} message RandomWindowDelta
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RandomWindowDelta.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.chunks = [];
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.consumed = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.consumed = options.longs === String ? "0" : 0;
                    object.offset = 0;
                    object.prefetchAfter = 0;
                }
                if (message.consumed != null && message.hasOwnProperty("consumed"))
                    if (typeof message.consumed === "number")
                        object.consumed = options.longs === String ? String(message.consumed) : message.consumed;
                    else
                        object.consumed = options.longs === String ? $util.Long.prototype.toString.call(message.consumed) : options.longs === Number ? new $util.LongBits(message.consumed.low >>> 0, message.consumed.high >>> 0).toNumber(true) : message.consumed;
                if (message.offset != null && message.hasOwnProperty("offset"))
                    object.offset = message.offset;
                if (message.prefetchAfter != null && message.hasOwnProperty("prefetchAfter"))
                    object.prefetchAfter = message.prefetchAfter;
                if (message.chunks && message.chunks.length) {
                    object.chunks = [];
                    for (let j = 0; j < message.chunks.length; ++j)
                        object.chunks[j] = $root.breacher.v2.RandomChunk.toObject(message.chunks[j], options);
                }
                return object;
            };

            /**
             * Converts this RandomWindowDelta to JSON.
             * @function toJSON
             * @memberof breacher.v2.RandomWindowDelta
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RandomWindowDelta.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RandomWindowDelta
             * @function getTypeUrl
             * @memberof breacher.v2.RandomWindowDelta
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RandomWindowDelta.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.RandomWindowDelta";
            };

            return RandomWindowDelta;
        })();

        v2.RunAck = (function() {

            /**
             * Properties of a RunAck.
             * @memberof breacher.v2
             * @interface IRunAck
             * @property {number|Long|null} [opSeq] RunAck opSeq
             * @property {number|Long|null} [acceptedAtMs] RunAck acceptedAtMs
             * @property {number|Long|null} [revision] RunAck revision
             * @property {Uint8Array|null} [stateHash] RunAck stateHash
             * @property {Array.<breacher.v2.IRunEvent>|null} [events] RunAck events
             * @property {breacher.v2.IRandomWindowDelta|null} [randomWindowDelta] RunAck randomWindowDelta
             * @property {number|Long|null} [nextDeadlineMs] RunAck nextDeadlineMs
             * @property {boolean|null} [ended] RunAck ended
             */

            /**
             * Constructs a new RunAck.
             * @memberof breacher.v2
             * @classdesc Represents a RunAck.
             * @implements IRunAck
             * @constructor
             * @param {breacher.v2.IRunAck=} [properties] Properties to set
             */
            function RunAck(properties) {
                this.events = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RunAck opSeq.
             * @member {number|Long} opSeq
             * @memberof breacher.v2.RunAck
             * @instance
             */
            RunAck.prototype.opSeq = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * RunAck acceptedAtMs.
             * @member {number|Long} acceptedAtMs
             * @memberof breacher.v2.RunAck
             * @instance
             */
            RunAck.prototype.acceptedAtMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * RunAck revision.
             * @member {number|Long} revision
             * @memberof breacher.v2.RunAck
             * @instance
             */
            RunAck.prototype.revision = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * RunAck stateHash.
             * @member {Uint8Array} stateHash
             * @memberof breacher.v2.RunAck
             * @instance
             */
            RunAck.prototype.stateHash = $util.newBuffer([]);

            /**
             * RunAck events.
             * @member {Array.<breacher.v2.IRunEvent>} events
             * @memberof breacher.v2.RunAck
             * @instance
             */
            RunAck.prototype.events = $util.emptyArray;

            /**
             * RunAck randomWindowDelta.
             * @member {breacher.v2.IRandomWindowDelta|null|undefined} randomWindowDelta
             * @memberof breacher.v2.RunAck
             * @instance
             */
            RunAck.prototype.randomWindowDelta = null;

            /**
             * RunAck nextDeadlineMs.
             * @member {number|Long} nextDeadlineMs
             * @memberof breacher.v2.RunAck
             * @instance
             */
            RunAck.prototype.nextDeadlineMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * RunAck ended.
             * @member {boolean} ended
             * @memberof breacher.v2.RunAck
             * @instance
             */
            RunAck.prototype.ended = false;

            /**
             * Creates a new RunAck instance using the specified properties.
             * @function create
             * @memberof breacher.v2.RunAck
             * @static
             * @param {breacher.v2.IRunAck=} [properties] Properties to set
             * @returns {breacher.v2.RunAck} RunAck instance
             */
            RunAck.create = function create(properties) {
                return new RunAck(properties);
            };

            /**
             * Encodes the specified RunAck message. Does not implicitly {@link breacher.v2.RunAck.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.RunAck
             * @static
             * @param {breacher.v2.IRunAck} message RunAck message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunAck.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.opSeq != null && Object.hasOwnProperty.call(message, "opSeq"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.opSeq);
                if (message.acceptedAtMs != null && Object.hasOwnProperty.call(message, "acceptedAtMs"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.acceptedAtMs);
                if (message.revision != null && Object.hasOwnProperty.call(message, "revision"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.revision);
                if (message.stateHash != null && Object.hasOwnProperty.call(message, "stateHash"))
                    writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.stateHash);
                if (message.events != null && message.events.length)
                    for (let i = 0; i < message.events.length; ++i)
                        $root.breacher.v2.RunEvent.encode(message.events[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.randomWindowDelta != null && Object.hasOwnProperty.call(message, "randomWindowDelta"))
                    $root.breacher.v2.RandomWindowDelta.encode(message.randomWindowDelta, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.nextDeadlineMs != null && Object.hasOwnProperty.call(message, "nextDeadlineMs"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int64(message.nextDeadlineMs);
                if (message.ended != null && Object.hasOwnProperty.call(message, "ended"))
                    writer.uint32(/* id 8, wireType 0 =*/64).bool(message.ended);
                return writer;
            };

            /**
             * Encodes the specified RunAck message, length delimited. Does not implicitly {@link breacher.v2.RunAck.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.RunAck
             * @static
             * @param {breacher.v2.IRunAck} message RunAck message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunAck.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RunAck message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.RunAck
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.RunAck} RunAck
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunAck.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.RunAck();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.opSeq = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.acceptedAtMs = reader.int64();
                            break;
                        }
                    case 3: {
                            message.revision = reader.uint64();
                            break;
                        }
                    case 4: {
                            message.stateHash = reader.bytes();
                            break;
                        }
                    case 5: {
                            if (!(message.events && message.events.length))
                                message.events = [];
                            message.events.push($root.breacher.v2.RunEvent.decode(reader, reader.uint32()));
                            break;
                        }
                    case 6: {
                            message.randomWindowDelta = $root.breacher.v2.RandomWindowDelta.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.nextDeadlineMs = reader.int64();
                            break;
                        }
                    case 8: {
                            message.ended = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RunAck message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.RunAck
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.RunAck} RunAck
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunAck.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RunAck message.
             * @function verify
             * @memberof breacher.v2.RunAck
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RunAck.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.opSeq != null && message.hasOwnProperty("opSeq"))
                    if (!$util.isInteger(message.opSeq) && !(message.opSeq && $util.isInteger(message.opSeq.low) && $util.isInteger(message.opSeq.high)))
                        return "opSeq: integer|Long expected";
                if (message.acceptedAtMs != null && message.hasOwnProperty("acceptedAtMs"))
                    if (!$util.isInteger(message.acceptedAtMs) && !(message.acceptedAtMs && $util.isInteger(message.acceptedAtMs.low) && $util.isInteger(message.acceptedAtMs.high)))
                        return "acceptedAtMs: integer|Long expected";
                if (message.revision != null && message.hasOwnProperty("revision"))
                    if (!$util.isInteger(message.revision) && !(message.revision && $util.isInteger(message.revision.low) && $util.isInteger(message.revision.high)))
                        return "revision: integer|Long expected";
                if (message.stateHash != null && message.hasOwnProperty("stateHash"))
                    if (!(message.stateHash && typeof message.stateHash.length === "number" || $util.isString(message.stateHash)))
                        return "stateHash: buffer expected";
                if (message.events != null && message.hasOwnProperty("events")) {
                    if (!Array.isArray(message.events))
                        return "events: array expected";
                    for (let i = 0; i < message.events.length; ++i) {
                        let error = $root.breacher.v2.RunEvent.verify(message.events[i]);
                        if (error)
                            return "events." + error;
                    }
                }
                if (message.randomWindowDelta != null && message.hasOwnProperty("randomWindowDelta")) {
                    let error = $root.breacher.v2.RandomWindowDelta.verify(message.randomWindowDelta);
                    if (error)
                        return "randomWindowDelta." + error;
                }
                if (message.nextDeadlineMs != null && message.hasOwnProperty("nextDeadlineMs"))
                    if (!$util.isInteger(message.nextDeadlineMs) && !(message.nextDeadlineMs && $util.isInteger(message.nextDeadlineMs.low) && $util.isInteger(message.nextDeadlineMs.high)))
                        return "nextDeadlineMs: integer|Long expected";
                if (message.ended != null && message.hasOwnProperty("ended"))
                    if (typeof message.ended !== "boolean")
                        return "ended: boolean expected";
                return null;
            };

            /**
             * Creates a RunAck message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.RunAck
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.RunAck} RunAck
             */
            RunAck.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.RunAck)
                    return object;
                let message = new $root.breacher.v2.RunAck();
                if (object.opSeq != null)
                    if ($util.Long)
                        (message.opSeq = $util.Long.fromValue(object.opSeq)).unsigned = true;
                    else if (typeof object.opSeq === "string")
                        message.opSeq = parseInt(object.opSeq, 10);
                    else if (typeof object.opSeq === "number")
                        message.opSeq = object.opSeq;
                    else if (typeof object.opSeq === "object")
                        message.opSeq = new $util.LongBits(object.opSeq.low >>> 0, object.opSeq.high >>> 0).toNumber(true);
                if (object.acceptedAtMs != null)
                    if ($util.Long)
                        (message.acceptedAtMs = $util.Long.fromValue(object.acceptedAtMs)).unsigned = false;
                    else if (typeof object.acceptedAtMs === "string")
                        message.acceptedAtMs = parseInt(object.acceptedAtMs, 10);
                    else if (typeof object.acceptedAtMs === "number")
                        message.acceptedAtMs = object.acceptedAtMs;
                    else if (typeof object.acceptedAtMs === "object")
                        message.acceptedAtMs = new $util.LongBits(object.acceptedAtMs.low >>> 0, object.acceptedAtMs.high >>> 0).toNumber();
                if (object.revision != null)
                    if ($util.Long)
                        (message.revision = $util.Long.fromValue(object.revision)).unsigned = true;
                    else if (typeof object.revision === "string")
                        message.revision = parseInt(object.revision, 10);
                    else if (typeof object.revision === "number")
                        message.revision = object.revision;
                    else if (typeof object.revision === "object")
                        message.revision = new $util.LongBits(object.revision.low >>> 0, object.revision.high >>> 0).toNumber(true);
                if (object.stateHash != null)
                    if (typeof object.stateHash === "string")
                        $util.base64.decode(object.stateHash, message.stateHash = $util.newBuffer($util.base64.length(object.stateHash)), 0);
                    else if (object.stateHash.length >= 0)
                        message.stateHash = object.stateHash;
                if (object.events) {
                    if (!Array.isArray(object.events))
                        throw TypeError(".breacher.v2.RunAck.events: array expected");
                    message.events = [];
                    for (let i = 0; i < object.events.length; ++i) {
                        if (typeof object.events[i] !== "object")
                            throw TypeError(".breacher.v2.RunAck.events: object expected");
                        message.events[i] = $root.breacher.v2.RunEvent.fromObject(object.events[i]);
                    }
                }
                if (object.randomWindowDelta != null) {
                    if (typeof object.randomWindowDelta !== "object")
                        throw TypeError(".breacher.v2.RunAck.randomWindowDelta: object expected");
                    message.randomWindowDelta = $root.breacher.v2.RandomWindowDelta.fromObject(object.randomWindowDelta);
                }
                if (object.nextDeadlineMs != null)
                    if ($util.Long)
                        (message.nextDeadlineMs = $util.Long.fromValue(object.nextDeadlineMs)).unsigned = false;
                    else if (typeof object.nextDeadlineMs === "string")
                        message.nextDeadlineMs = parseInt(object.nextDeadlineMs, 10);
                    else if (typeof object.nextDeadlineMs === "number")
                        message.nextDeadlineMs = object.nextDeadlineMs;
                    else if (typeof object.nextDeadlineMs === "object")
                        message.nextDeadlineMs = new $util.LongBits(object.nextDeadlineMs.low >>> 0, object.nextDeadlineMs.high >>> 0).toNumber();
                if (object.ended != null)
                    message.ended = Boolean(object.ended);
                return message;
            };

            /**
             * Creates a plain object from a RunAck message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.RunAck
             * @static
             * @param {breacher.v2.RunAck} message RunAck
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RunAck.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.events = [];
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.opSeq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.opSeq = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.acceptedAtMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.acceptedAtMs = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.revision = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.revision = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.stateHash = "";
                    else {
                        object.stateHash = [];
                        if (options.bytes !== Array)
                            object.stateHash = $util.newBuffer(object.stateHash);
                    }
                    object.randomWindowDelta = null;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.nextDeadlineMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.nextDeadlineMs = options.longs === String ? "0" : 0;
                    object.ended = false;
                }
                if (message.opSeq != null && message.hasOwnProperty("opSeq"))
                    if (typeof message.opSeq === "number")
                        object.opSeq = options.longs === String ? String(message.opSeq) : message.opSeq;
                    else
                        object.opSeq = options.longs === String ? $util.Long.prototype.toString.call(message.opSeq) : options.longs === Number ? new $util.LongBits(message.opSeq.low >>> 0, message.opSeq.high >>> 0).toNumber(true) : message.opSeq;
                if (message.acceptedAtMs != null && message.hasOwnProperty("acceptedAtMs"))
                    if (typeof message.acceptedAtMs === "number")
                        object.acceptedAtMs = options.longs === String ? String(message.acceptedAtMs) : message.acceptedAtMs;
                    else
                        object.acceptedAtMs = options.longs === String ? $util.Long.prototype.toString.call(message.acceptedAtMs) : options.longs === Number ? new $util.LongBits(message.acceptedAtMs.low >>> 0, message.acceptedAtMs.high >>> 0).toNumber() : message.acceptedAtMs;
                if (message.revision != null && message.hasOwnProperty("revision"))
                    if (typeof message.revision === "number")
                        object.revision = options.longs === String ? String(message.revision) : message.revision;
                    else
                        object.revision = options.longs === String ? $util.Long.prototype.toString.call(message.revision) : options.longs === Number ? new $util.LongBits(message.revision.low >>> 0, message.revision.high >>> 0).toNumber(true) : message.revision;
                if (message.stateHash != null && message.hasOwnProperty("stateHash"))
                    object.stateHash = options.bytes === String ? $util.base64.encode(message.stateHash, 0, message.stateHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.stateHash) : message.stateHash;
                if (message.events && message.events.length) {
                    object.events = [];
                    for (let j = 0; j < message.events.length; ++j)
                        object.events[j] = $root.breacher.v2.RunEvent.toObject(message.events[j], options);
                }
                if (message.randomWindowDelta != null && message.hasOwnProperty("randomWindowDelta"))
                    object.randomWindowDelta = $root.breacher.v2.RandomWindowDelta.toObject(message.randomWindowDelta, options);
                if (message.nextDeadlineMs != null && message.hasOwnProperty("nextDeadlineMs"))
                    if (typeof message.nextDeadlineMs === "number")
                        object.nextDeadlineMs = options.longs === String ? String(message.nextDeadlineMs) : message.nextDeadlineMs;
                    else
                        object.nextDeadlineMs = options.longs === String ? $util.Long.prototype.toString.call(message.nextDeadlineMs) : options.longs === Number ? new $util.LongBits(message.nextDeadlineMs.low >>> 0, message.nextDeadlineMs.high >>> 0).toNumber() : message.nextDeadlineMs;
                if (message.ended != null && message.hasOwnProperty("ended"))
                    object.ended = message.ended;
                return object;
            };

            /**
             * Converts this RunAck to JSON.
             * @function toJSON
             * @memberof breacher.v2.RunAck
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RunAck.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RunAck
             * @function getTypeUrl
             * @memberof breacher.v2.RunAck
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RunAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.RunAck";
            };

            return RunAck;
        })();

        v2.RunCheckpointChallenge = (function() {

            /**
             * Properties of a RunCheckpointChallenge.
             * @memberof breacher.v2
             * @interface IRunCheckpointChallenge
             * @property {string|null} [checkpointId] RunCheckpointChallenge checkpointId
             * @property {number|Long|null} [serverTimeMs] RunCheckpointChallenge serverTimeMs
             * @property {number|Long|null} [revision] RunCheckpointChallenge revision
             * @property {number|Long|null} [lastOpSeq] RunCheckpointChallenge lastOpSeq
             */

            /**
             * Constructs a new RunCheckpointChallenge.
             * @memberof breacher.v2
             * @classdesc Represents a RunCheckpointChallenge.
             * @implements IRunCheckpointChallenge
             * @constructor
             * @param {breacher.v2.IRunCheckpointChallenge=} [properties] Properties to set
             */
            function RunCheckpointChallenge(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RunCheckpointChallenge checkpointId.
             * @member {string} checkpointId
             * @memberof breacher.v2.RunCheckpointChallenge
             * @instance
             */
            RunCheckpointChallenge.prototype.checkpointId = "";

            /**
             * RunCheckpointChallenge serverTimeMs.
             * @member {number|Long} serverTimeMs
             * @memberof breacher.v2.RunCheckpointChallenge
             * @instance
             */
            RunCheckpointChallenge.prototype.serverTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * RunCheckpointChallenge revision.
             * @member {number|Long} revision
             * @memberof breacher.v2.RunCheckpointChallenge
             * @instance
             */
            RunCheckpointChallenge.prototype.revision = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * RunCheckpointChallenge lastOpSeq.
             * @member {number|Long} lastOpSeq
             * @memberof breacher.v2.RunCheckpointChallenge
             * @instance
             */
            RunCheckpointChallenge.prototype.lastOpSeq = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new RunCheckpointChallenge instance using the specified properties.
             * @function create
             * @memberof breacher.v2.RunCheckpointChallenge
             * @static
             * @param {breacher.v2.IRunCheckpointChallenge=} [properties] Properties to set
             * @returns {breacher.v2.RunCheckpointChallenge} RunCheckpointChallenge instance
             */
            RunCheckpointChallenge.create = function create(properties) {
                return new RunCheckpointChallenge(properties);
            };

            /**
             * Encodes the specified RunCheckpointChallenge message. Does not implicitly {@link breacher.v2.RunCheckpointChallenge.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.RunCheckpointChallenge
             * @static
             * @param {breacher.v2.IRunCheckpointChallenge} message RunCheckpointChallenge message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunCheckpointChallenge.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.checkpointId != null && Object.hasOwnProperty.call(message, "checkpointId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.checkpointId);
                if (message.serverTimeMs != null && Object.hasOwnProperty.call(message, "serverTimeMs"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.serverTimeMs);
                if (message.revision != null && Object.hasOwnProperty.call(message, "revision"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.revision);
                if (message.lastOpSeq != null && Object.hasOwnProperty.call(message, "lastOpSeq"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.lastOpSeq);
                return writer;
            };

            /**
             * Encodes the specified RunCheckpointChallenge message, length delimited. Does not implicitly {@link breacher.v2.RunCheckpointChallenge.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.RunCheckpointChallenge
             * @static
             * @param {breacher.v2.IRunCheckpointChallenge} message RunCheckpointChallenge message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunCheckpointChallenge.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RunCheckpointChallenge message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.RunCheckpointChallenge
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.RunCheckpointChallenge} RunCheckpointChallenge
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunCheckpointChallenge.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.RunCheckpointChallenge();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.checkpointId = reader.string();
                            break;
                        }
                    case 2: {
                            message.serverTimeMs = reader.int64();
                            break;
                        }
                    case 3: {
                            message.revision = reader.uint64();
                            break;
                        }
                    case 4: {
                            message.lastOpSeq = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RunCheckpointChallenge message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.RunCheckpointChallenge
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.RunCheckpointChallenge} RunCheckpointChallenge
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunCheckpointChallenge.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RunCheckpointChallenge message.
             * @function verify
             * @memberof breacher.v2.RunCheckpointChallenge
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RunCheckpointChallenge.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.checkpointId != null && message.hasOwnProperty("checkpointId"))
                    if (!$util.isString(message.checkpointId))
                        return "checkpointId: string expected";
                if (message.serverTimeMs != null && message.hasOwnProperty("serverTimeMs"))
                    if (!$util.isInteger(message.serverTimeMs) && !(message.serverTimeMs && $util.isInteger(message.serverTimeMs.low) && $util.isInteger(message.serverTimeMs.high)))
                        return "serverTimeMs: integer|Long expected";
                if (message.revision != null && message.hasOwnProperty("revision"))
                    if (!$util.isInteger(message.revision) && !(message.revision && $util.isInteger(message.revision.low) && $util.isInteger(message.revision.high)))
                        return "revision: integer|Long expected";
                if (message.lastOpSeq != null && message.hasOwnProperty("lastOpSeq"))
                    if (!$util.isInteger(message.lastOpSeq) && !(message.lastOpSeq && $util.isInteger(message.lastOpSeq.low) && $util.isInteger(message.lastOpSeq.high)))
                        return "lastOpSeq: integer|Long expected";
                return null;
            };

            /**
             * Creates a RunCheckpointChallenge message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.RunCheckpointChallenge
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.RunCheckpointChallenge} RunCheckpointChallenge
             */
            RunCheckpointChallenge.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.RunCheckpointChallenge)
                    return object;
                let message = new $root.breacher.v2.RunCheckpointChallenge();
                if (object.checkpointId != null)
                    message.checkpointId = String(object.checkpointId);
                if (object.serverTimeMs != null)
                    if ($util.Long)
                        (message.serverTimeMs = $util.Long.fromValue(object.serverTimeMs)).unsigned = false;
                    else if (typeof object.serverTimeMs === "string")
                        message.serverTimeMs = parseInt(object.serverTimeMs, 10);
                    else if (typeof object.serverTimeMs === "number")
                        message.serverTimeMs = object.serverTimeMs;
                    else if (typeof object.serverTimeMs === "object")
                        message.serverTimeMs = new $util.LongBits(object.serverTimeMs.low >>> 0, object.serverTimeMs.high >>> 0).toNumber();
                if (object.revision != null)
                    if ($util.Long)
                        (message.revision = $util.Long.fromValue(object.revision)).unsigned = true;
                    else if (typeof object.revision === "string")
                        message.revision = parseInt(object.revision, 10);
                    else if (typeof object.revision === "number")
                        message.revision = object.revision;
                    else if (typeof object.revision === "object")
                        message.revision = new $util.LongBits(object.revision.low >>> 0, object.revision.high >>> 0).toNumber(true);
                if (object.lastOpSeq != null)
                    if ($util.Long)
                        (message.lastOpSeq = $util.Long.fromValue(object.lastOpSeq)).unsigned = true;
                    else if (typeof object.lastOpSeq === "string")
                        message.lastOpSeq = parseInt(object.lastOpSeq, 10);
                    else if (typeof object.lastOpSeq === "number")
                        message.lastOpSeq = object.lastOpSeq;
                    else if (typeof object.lastOpSeq === "object")
                        message.lastOpSeq = new $util.LongBits(object.lastOpSeq.low >>> 0, object.lastOpSeq.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a RunCheckpointChallenge message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.RunCheckpointChallenge
             * @static
             * @param {breacher.v2.RunCheckpointChallenge} message RunCheckpointChallenge
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RunCheckpointChallenge.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.checkpointId = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.serverTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.serverTimeMs = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.revision = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.revision = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.lastOpSeq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.lastOpSeq = options.longs === String ? "0" : 0;
                }
                if (message.checkpointId != null && message.hasOwnProperty("checkpointId"))
                    object.checkpointId = message.checkpointId;
                if (message.serverTimeMs != null && message.hasOwnProperty("serverTimeMs"))
                    if (typeof message.serverTimeMs === "number")
                        object.serverTimeMs = options.longs === String ? String(message.serverTimeMs) : message.serverTimeMs;
                    else
                        object.serverTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.serverTimeMs) : options.longs === Number ? new $util.LongBits(message.serverTimeMs.low >>> 0, message.serverTimeMs.high >>> 0).toNumber() : message.serverTimeMs;
                if (message.revision != null && message.hasOwnProperty("revision"))
                    if (typeof message.revision === "number")
                        object.revision = options.longs === String ? String(message.revision) : message.revision;
                    else
                        object.revision = options.longs === String ? $util.Long.prototype.toString.call(message.revision) : options.longs === Number ? new $util.LongBits(message.revision.low >>> 0, message.revision.high >>> 0).toNumber(true) : message.revision;
                if (message.lastOpSeq != null && message.hasOwnProperty("lastOpSeq"))
                    if (typeof message.lastOpSeq === "number")
                        object.lastOpSeq = options.longs === String ? String(message.lastOpSeq) : message.lastOpSeq;
                    else
                        object.lastOpSeq = options.longs === String ? $util.Long.prototype.toString.call(message.lastOpSeq) : options.longs === Number ? new $util.LongBits(message.lastOpSeq.low >>> 0, message.lastOpSeq.high >>> 0).toNumber(true) : message.lastOpSeq;
                return object;
            };

            /**
             * Converts this RunCheckpointChallenge to JSON.
             * @function toJSON
             * @memberof breacher.v2.RunCheckpointChallenge
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RunCheckpointChallenge.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RunCheckpointChallenge
             * @function getTypeUrl
             * @memberof breacher.v2.RunCheckpointChallenge
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RunCheckpointChallenge.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.RunCheckpointChallenge";
            };

            return RunCheckpointChallenge;
        })();

        v2.RunCheckpoint = (function() {

            /**
             * Properties of a RunCheckpoint.
             * @memberof breacher.v2
             * @interface IRunCheckpoint
             * @property {string|null} [checkpointId] RunCheckpoint checkpointId
             * @property {string|null} [runId] RunCheckpoint runId
             * @property {number|Long|null} [revision] RunCheckpoint revision
             * @property {number|Long|null} [lastOpSeq] RunCheckpoint lastOpSeq
             * @property {Uint8Array|null} [stateHash] RunCheckpoint stateHash
             * @property {Uint8Array|null} [operationDigest] RunCheckpoint operationDigest
             */

            /**
             * Constructs a new RunCheckpoint.
             * @memberof breacher.v2
             * @classdesc Represents a RunCheckpoint.
             * @implements IRunCheckpoint
             * @constructor
             * @param {breacher.v2.IRunCheckpoint=} [properties] Properties to set
             */
            function RunCheckpoint(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RunCheckpoint checkpointId.
             * @member {string} checkpointId
             * @memberof breacher.v2.RunCheckpoint
             * @instance
             */
            RunCheckpoint.prototype.checkpointId = "";

            /**
             * RunCheckpoint runId.
             * @member {string} runId
             * @memberof breacher.v2.RunCheckpoint
             * @instance
             */
            RunCheckpoint.prototype.runId = "";

            /**
             * RunCheckpoint revision.
             * @member {number|Long} revision
             * @memberof breacher.v2.RunCheckpoint
             * @instance
             */
            RunCheckpoint.prototype.revision = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * RunCheckpoint lastOpSeq.
             * @member {number|Long} lastOpSeq
             * @memberof breacher.v2.RunCheckpoint
             * @instance
             */
            RunCheckpoint.prototype.lastOpSeq = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * RunCheckpoint stateHash.
             * @member {Uint8Array} stateHash
             * @memberof breacher.v2.RunCheckpoint
             * @instance
             */
            RunCheckpoint.prototype.stateHash = $util.newBuffer([]);

            /**
             * RunCheckpoint operationDigest.
             * @member {Uint8Array} operationDigest
             * @memberof breacher.v2.RunCheckpoint
             * @instance
             */
            RunCheckpoint.prototype.operationDigest = $util.newBuffer([]);

            /**
             * Creates a new RunCheckpoint instance using the specified properties.
             * @function create
             * @memberof breacher.v2.RunCheckpoint
             * @static
             * @param {breacher.v2.IRunCheckpoint=} [properties] Properties to set
             * @returns {breacher.v2.RunCheckpoint} RunCheckpoint instance
             */
            RunCheckpoint.create = function create(properties) {
                return new RunCheckpoint(properties);
            };

            /**
             * Encodes the specified RunCheckpoint message. Does not implicitly {@link breacher.v2.RunCheckpoint.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.RunCheckpoint
             * @static
             * @param {breacher.v2.IRunCheckpoint} message RunCheckpoint message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunCheckpoint.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.checkpointId != null && Object.hasOwnProperty.call(message, "checkpointId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.checkpointId);
                if (message.runId != null && Object.hasOwnProperty.call(message, "runId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.runId);
                if (message.revision != null && Object.hasOwnProperty.call(message, "revision"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.revision);
                if (message.lastOpSeq != null && Object.hasOwnProperty.call(message, "lastOpSeq"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.lastOpSeq);
                if (message.stateHash != null && Object.hasOwnProperty.call(message, "stateHash"))
                    writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.stateHash);
                if (message.operationDigest != null && Object.hasOwnProperty.call(message, "operationDigest"))
                    writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.operationDigest);
                return writer;
            };

            /**
             * Encodes the specified RunCheckpoint message, length delimited. Does not implicitly {@link breacher.v2.RunCheckpoint.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.RunCheckpoint
             * @static
             * @param {breacher.v2.IRunCheckpoint} message RunCheckpoint message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunCheckpoint.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RunCheckpoint message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.RunCheckpoint
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.RunCheckpoint} RunCheckpoint
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunCheckpoint.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.RunCheckpoint();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.checkpointId = reader.string();
                            break;
                        }
                    case 2: {
                            message.runId = reader.string();
                            break;
                        }
                    case 3: {
                            message.revision = reader.uint64();
                            break;
                        }
                    case 4: {
                            message.lastOpSeq = reader.uint64();
                            break;
                        }
                    case 5: {
                            message.stateHash = reader.bytes();
                            break;
                        }
                    case 6: {
                            message.operationDigest = reader.bytes();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RunCheckpoint message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.RunCheckpoint
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.RunCheckpoint} RunCheckpoint
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunCheckpoint.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RunCheckpoint message.
             * @function verify
             * @memberof breacher.v2.RunCheckpoint
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RunCheckpoint.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.checkpointId != null && message.hasOwnProperty("checkpointId"))
                    if (!$util.isString(message.checkpointId))
                        return "checkpointId: string expected";
                if (message.runId != null && message.hasOwnProperty("runId"))
                    if (!$util.isString(message.runId))
                        return "runId: string expected";
                if (message.revision != null && message.hasOwnProperty("revision"))
                    if (!$util.isInteger(message.revision) && !(message.revision && $util.isInteger(message.revision.low) && $util.isInteger(message.revision.high)))
                        return "revision: integer|Long expected";
                if (message.lastOpSeq != null && message.hasOwnProperty("lastOpSeq"))
                    if (!$util.isInteger(message.lastOpSeq) && !(message.lastOpSeq && $util.isInteger(message.lastOpSeq.low) && $util.isInteger(message.lastOpSeq.high)))
                        return "lastOpSeq: integer|Long expected";
                if (message.stateHash != null && message.hasOwnProperty("stateHash"))
                    if (!(message.stateHash && typeof message.stateHash.length === "number" || $util.isString(message.stateHash)))
                        return "stateHash: buffer expected";
                if (message.operationDigest != null && message.hasOwnProperty("operationDigest"))
                    if (!(message.operationDigest && typeof message.operationDigest.length === "number" || $util.isString(message.operationDigest)))
                        return "operationDigest: buffer expected";
                return null;
            };

            /**
             * Creates a RunCheckpoint message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.RunCheckpoint
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.RunCheckpoint} RunCheckpoint
             */
            RunCheckpoint.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.RunCheckpoint)
                    return object;
                let message = new $root.breacher.v2.RunCheckpoint();
                if (object.checkpointId != null)
                    message.checkpointId = String(object.checkpointId);
                if (object.runId != null)
                    message.runId = String(object.runId);
                if (object.revision != null)
                    if ($util.Long)
                        (message.revision = $util.Long.fromValue(object.revision)).unsigned = true;
                    else if (typeof object.revision === "string")
                        message.revision = parseInt(object.revision, 10);
                    else if (typeof object.revision === "number")
                        message.revision = object.revision;
                    else if (typeof object.revision === "object")
                        message.revision = new $util.LongBits(object.revision.low >>> 0, object.revision.high >>> 0).toNumber(true);
                if (object.lastOpSeq != null)
                    if ($util.Long)
                        (message.lastOpSeq = $util.Long.fromValue(object.lastOpSeq)).unsigned = true;
                    else if (typeof object.lastOpSeq === "string")
                        message.lastOpSeq = parseInt(object.lastOpSeq, 10);
                    else if (typeof object.lastOpSeq === "number")
                        message.lastOpSeq = object.lastOpSeq;
                    else if (typeof object.lastOpSeq === "object")
                        message.lastOpSeq = new $util.LongBits(object.lastOpSeq.low >>> 0, object.lastOpSeq.high >>> 0).toNumber(true);
                if (object.stateHash != null)
                    if (typeof object.stateHash === "string")
                        $util.base64.decode(object.stateHash, message.stateHash = $util.newBuffer($util.base64.length(object.stateHash)), 0);
                    else if (object.stateHash.length >= 0)
                        message.stateHash = object.stateHash;
                if (object.operationDigest != null)
                    if (typeof object.operationDigest === "string")
                        $util.base64.decode(object.operationDigest, message.operationDigest = $util.newBuffer($util.base64.length(object.operationDigest)), 0);
                    else if (object.operationDigest.length >= 0)
                        message.operationDigest = object.operationDigest;
                return message;
            };

            /**
             * Creates a plain object from a RunCheckpoint message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.RunCheckpoint
             * @static
             * @param {breacher.v2.RunCheckpoint} message RunCheckpoint
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RunCheckpoint.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.checkpointId = "";
                    object.runId = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.revision = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.revision = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.lastOpSeq = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.lastOpSeq = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.stateHash = "";
                    else {
                        object.stateHash = [];
                        if (options.bytes !== Array)
                            object.stateHash = $util.newBuffer(object.stateHash);
                    }
                    if (options.bytes === String)
                        object.operationDigest = "";
                    else {
                        object.operationDigest = [];
                        if (options.bytes !== Array)
                            object.operationDigest = $util.newBuffer(object.operationDigest);
                    }
                }
                if (message.checkpointId != null && message.hasOwnProperty("checkpointId"))
                    object.checkpointId = message.checkpointId;
                if (message.runId != null && message.hasOwnProperty("runId"))
                    object.runId = message.runId;
                if (message.revision != null && message.hasOwnProperty("revision"))
                    if (typeof message.revision === "number")
                        object.revision = options.longs === String ? String(message.revision) : message.revision;
                    else
                        object.revision = options.longs === String ? $util.Long.prototype.toString.call(message.revision) : options.longs === Number ? new $util.LongBits(message.revision.low >>> 0, message.revision.high >>> 0).toNumber(true) : message.revision;
                if (message.lastOpSeq != null && message.hasOwnProperty("lastOpSeq"))
                    if (typeof message.lastOpSeq === "number")
                        object.lastOpSeq = options.longs === String ? String(message.lastOpSeq) : message.lastOpSeq;
                    else
                        object.lastOpSeq = options.longs === String ? $util.Long.prototype.toString.call(message.lastOpSeq) : options.longs === Number ? new $util.LongBits(message.lastOpSeq.low >>> 0, message.lastOpSeq.high >>> 0).toNumber(true) : message.lastOpSeq;
                if (message.stateHash != null && message.hasOwnProperty("stateHash"))
                    object.stateHash = options.bytes === String ? $util.base64.encode(message.stateHash, 0, message.stateHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.stateHash) : message.stateHash;
                if (message.operationDigest != null && message.hasOwnProperty("operationDigest"))
                    object.operationDigest = options.bytes === String ? $util.base64.encode(message.operationDigest, 0, message.operationDigest.length) : options.bytes === Array ? Array.prototype.slice.call(message.operationDigest) : message.operationDigest;
                return object;
            };

            /**
             * Converts this RunCheckpoint to JSON.
             * @function toJSON
             * @memberof breacher.v2.RunCheckpoint
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RunCheckpoint.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RunCheckpoint
             * @function getTypeUrl
             * @memberof breacher.v2.RunCheckpoint
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RunCheckpoint.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.RunCheckpoint";
            };

            return RunCheckpoint;
        })();

        v2.RunSnapshot = (function() {

            /**
             * Properties of a RunSnapshot.
             * @memberof breacher.v2
             * @interface IRunSnapshot
             * @property {number|null} [snapshotVersion] RunSnapshot snapshotVersion
             * @property {breacher.v2.IWireValue|null} [state] RunSnapshot state
             * @property {breacher.v2.IRandomWindowDelta|null} [randomWindow] RunSnapshot randomWindow
             * @property {Uint8Array|null} [stateHash] RunSnapshot stateHash
             * @property {number|Long|null} [serverNowMs] RunSnapshot serverNowMs
             * @property {breacher.v2.IWireValue|null} [machineConfig] RunSnapshot machineConfig
             * @property {string|null} [simulationProfileId] RunSnapshot simulationProfileId
             * @property {string|null} [engineVersion] RunSnapshot engineVersion
             */

            /**
             * Constructs a new RunSnapshot.
             * @memberof breacher.v2
             * @classdesc Represents a RunSnapshot.
             * @implements IRunSnapshot
             * @constructor
             * @param {breacher.v2.IRunSnapshot=} [properties] Properties to set
             */
            function RunSnapshot(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RunSnapshot snapshotVersion.
             * @member {number} snapshotVersion
             * @memberof breacher.v2.RunSnapshot
             * @instance
             */
            RunSnapshot.prototype.snapshotVersion = 0;

            /**
             * RunSnapshot state.
             * @member {breacher.v2.IWireValue|null|undefined} state
             * @memberof breacher.v2.RunSnapshot
             * @instance
             */
            RunSnapshot.prototype.state = null;

            /**
             * RunSnapshot randomWindow.
             * @member {breacher.v2.IRandomWindowDelta|null|undefined} randomWindow
             * @memberof breacher.v2.RunSnapshot
             * @instance
             */
            RunSnapshot.prototype.randomWindow = null;

            /**
             * RunSnapshot stateHash.
             * @member {Uint8Array} stateHash
             * @memberof breacher.v2.RunSnapshot
             * @instance
             */
            RunSnapshot.prototype.stateHash = $util.newBuffer([]);

            /**
             * RunSnapshot serverNowMs.
             * @member {number|Long} serverNowMs
             * @memberof breacher.v2.RunSnapshot
             * @instance
             */
            RunSnapshot.prototype.serverNowMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * RunSnapshot machineConfig.
             * @member {breacher.v2.IWireValue|null|undefined} machineConfig
             * @memberof breacher.v2.RunSnapshot
             * @instance
             */
            RunSnapshot.prototype.machineConfig = null;

            /**
             * RunSnapshot simulationProfileId.
             * @member {string} simulationProfileId
             * @memberof breacher.v2.RunSnapshot
             * @instance
             */
            RunSnapshot.prototype.simulationProfileId = "";

            /**
             * RunSnapshot engineVersion.
             * @member {string} engineVersion
             * @memberof breacher.v2.RunSnapshot
             * @instance
             */
            RunSnapshot.prototype.engineVersion = "";

            /**
             * Creates a new RunSnapshot instance using the specified properties.
             * @function create
             * @memberof breacher.v2.RunSnapshot
             * @static
             * @param {breacher.v2.IRunSnapshot=} [properties] Properties to set
             * @returns {breacher.v2.RunSnapshot} RunSnapshot instance
             */
            RunSnapshot.create = function create(properties) {
                return new RunSnapshot(properties);
            };

            /**
             * Encodes the specified RunSnapshot message. Does not implicitly {@link breacher.v2.RunSnapshot.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.RunSnapshot
             * @static
             * @param {breacher.v2.IRunSnapshot} message RunSnapshot message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunSnapshot.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.snapshotVersion != null && Object.hasOwnProperty.call(message, "snapshotVersion"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.snapshotVersion);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    $root.breacher.v2.WireValue.encode(message.state, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.randomWindow != null && Object.hasOwnProperty.call(message, "randomWindow"))
                    $root.breacher.v2.RandomWindowDelta.encode(message.randomWindow, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.stateHash != null && Object.hasOwnProperty.call(message, "stateHash"))
                    writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.stateHash);
                if (message.serverNowMs != null && Object.hasOwnProperty.call(message, "serverNowMs"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int64(message.serverNowMs);
                if (message.machineConfig != null && Object.hasOwnProperty.call(message, "machineConfig"))
                    $root.breacher.v2.WireValue.encode(message.machineConfig, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.simulationProfileId != null && Object.hasOwnProperty.call(message, "simulationProfileId"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.simulationProfileId);
                if (message.engineVersion != null && Object.hasOwnProperty.call(message, "engineVersion"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.engineVersion);
                return writer;
            };

            /**
             * Encodes the specified RunSnapshot message, length delimited. Does not implicitly {@link breacher.v2.RunSnapshot.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.RunSnapshot
             * @static
             * @param {breacher.v2.IRunSnapshot} message RunSnapshot message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunSnapshot.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RunSnapshot message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.RunSnapshot
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.RunSnapshot} RunSnapshot
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunSnapshot.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.RunSnapshot();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.snapshotVersion = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.state = $root.breacher.v2.WireValue.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.randomWindow = $root.breacher.v2.RandomWindowDelta.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.stateHash = reader.bytes();
                            break;
                        }
                    case 5: {
                            message.serverNowMs = reader.int64();
                            break;
                        }
                    case 6: {
                            message.machineConfig = $root.breacher.v2.WireValue.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.simulationProfileId = reader.string();
                            break;
                        }
                    case 8: {
                            message.engineVersion = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RunSnapshot message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.RunSnapshot
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.RunSnapshot} RunSnapshot
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunSnapshot.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RunSnapshot message.
             * @function verify
             * @memberof breacher.v2.RunSnapshot
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RunSnapshot.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.snapshotVersion != null && message.hasOwnProperty("snapshotVersion"))
                    if (!$util.isInteger(message.snapshotVersion))
                        return "snapshotVersion: integer expected";
                if (message.state != null && message.hasOwnProperty("state")) {
                    let error = $root.breacher.v2.WireValue.verify(message.state);
                    if (error)
                        return "state." + error;
                }
                if (message.randomWindow != null && message.hasOwnProperty("randomWindow")) {
                    let error = $root.breacher.v2.RandomWindowDelta.verify(message.randomWindow);
                    if (error)
                        return "randomWindow." + error;
                }
                if (message.stateHash != null && message.hasOwnProperty("stateHash"))
                    if (!(message.stateHash && typeof message.stateHash.length === "number" || $util.isString(message.stateHash)))
                        return "stateHash: buffer expected";
                if (message.serverNowMs != null && message.hasOwnProperty("serverNowMs"))
                    if (!$util.isInteger(message.serverNowMs) && !(message.serverNowMs && $util.isInteger(message.serverNowMs.low) && $util.isInteger(message.serverNowMs.high)))
                        return "serverNowMs: integer|Long expected";
                if (message.machineConfig != null && message.hasOwnProperty("machineConfig")) {
                    let error = $root.breacher.v2.WireValue.verify(message.machineConfig);
                    if (error)
                        return "machineConfig." + error;
                }
                if (message.simulationProfileId != null && message.hasOwnProperty("simulationProfileId"))
                    if (!$util.isString(message.simulationProfileId))
                        return "simulationProfileId: string expected";
                if (message.engineVersion != null && message.hasOwnProperty("engineVersion"))
                    if (!$util.isString(message.engineVersion))
                        return "engineVersion: string expected";
                return null;
            };

            /**
             * Creates a RunSnapshot message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.RunSnapshot
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.RunSnapshot} RunSnapshot
             */
            RunSnapshot.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.RunSnapshot)
                    return object;
                let message = new $root.breacher.v2.RunSnapshot();
                if (object.snapshotVersion != null)
                    message.snapshotVersion = object.snapshotVersion >>> 0;
                if (object.state != null) {
                    if (typeof object.state !== "object")
                        throw TypeError(".breacher.v2.RunSnapshot.state: object expected");
                    message.state = $root.breacher.v2.WireValue.fromObject(object.state);
                }
                if (object.randomWindow != null) {
                    if (typeof object.randomWindow !== "object")
                        throw TypeError(".breacher.v2.RunSnapshot.randomWindow: object expected");
                    message.randomWindow = $root.breacher.v2.RandomWindowDelta.fromObject(object.randomWindow);
                }
                if (object.stateHash != null)
                    if (typeof object.stateHash === "string")
                        $util.base64.decode(object.stateHash, message.stateHash = $util.newBuffer($util.base64.length(object.stateHash)), 0);
                    else if (object.stateHash.length >= 0)
                        message.stateHash = object.stateHash;
                if (object.serverNowMs != null)
                    if ($util.Long)
                        (message.serverNowMs = $util.Long.fromValue(object.serverNowMs)).unsigned = false;
                    else if (typeof object.serverNowMs === "string")
                        message.serverNowMs = parseInt(object.serverNowMs, 10);
                    else if (typeof object.serverNowMs === "number")
                        message.serverNowMs = object.serverNowMs;
                    else if (typeof object.serverNowMs === "object")
                        message.serverNowMs = new $util.LongBits(object.serverNowMs.low >>> 0, object.serverNowMs.high >>> 0).toNumber();
                if (object.machineConfig != null) {
                    if (typeof object.machineConfig !== "object")
                        throw TypeError(".breacher.v2.RunSnapshot.machineConfig: object expected");
                    message.machineConfig = $root.breacher.v2.WireValue.fromObject(object.machineConfig);
                }
                if (object.simulationProfileId != null)
                    message.simulationProfileId = String(object.simulationProfileId);
                if (object.engineVersion != null)
                    message.engineVersion = String(object.engineVersion);
                return message;
            };

            /**
             * Creates a plain object from a RunSnapshot message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.RunSnapshot
             * @static
             * @param {breacher.v2.RunSnapshot} message RunSnapshot
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RunSnapshot.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.snapshotVersion = 0;
                    object.state = null;
                    object.randomWindow = null;
                    if (options.bytes === String)
                        object.stateHash = "";
                    else {
                        object.stateHash = [];
                        if (options.bytes !== Array)
                            object.stateHash = $util.newBuffer(object.stateHash);
                    }
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.serverNowMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.serverNowMs = options.longs === String ? "0" : 0;
                    object.machineConfig = null;
                    object.simulationProfileId = "";
                    object.engineVersion = "";
                }
                if (message.snapshotVersion != null && message.hasOwnProperty("snapshotVersion"))
                    object.snapshotVersion = message.snapshotVersion;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = $root.breacher.v2.WireValue.toObject(message.state, options);
                if (message.randomWindow != null && message.hasOwnProperty("randomWindow"))
                    object.randomWindow = $root.breacher.v2.RandomWindowDelta.toObject(message.randomWindow, options);
                if (message.stateHash != null && message.hasOwnProperty("stateHash"))
                    object.stateHash = options.bytes === String ? $util.base64.encode(message.stateHash, 0, message.stateHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.stateHash) : message.stateHash;
                if (message.serverNowMs != null && message.hasOwnProperty("serverNowMs"))
                    if (typeof message.serverNowMs === "number")
                        object.serverNowMs = options.longs === String ? String(message.serverNowMs) : message.serverNowMs;
                    else
                        object.serverNowMs = options.longs === String ? $util.Long.prototype.toString.call(message.serverNowMs) : options.longs === Number ? new $util.LongBits(message.serverNowMs.low >>> 0, message.serverNowMs.high >>> 0).toNumber() : message.serverNowMs;
                if (message.machineConfig != null && message.hasOwnProperty("machineConfig"))
                    object.machineConfig = $root.breacher.v2.WireValue.toObject(message.machineConfig, options);
                if (message.simulationProfileId != null && message.hasOwnProperty("simulationProfileId"))
                    object.simulationProfileId = message.simulationProfileId;
                if (message.engineVersion != null && message.hasOwnProperty("engineVersion"))
                    object.engineVersion = message.engineVersion;
                return object;
            };

            /**
             * Converts this RunSnapshot to JSON.
             * @function toJSON
             * @memberof breacher.v2.RunSnapshot
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RunSnapshot.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RunSnapshot
             * @function getTypeUrl
             * @memberof breacher.v2.RunSnapshot
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RunSnapshot.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.RunSnapshot";
            };

            return RunSnapshot;
        })();

        /**
         * RunMachineCommand enum.
         * @name breacher.v2.RunMachineCommand
         * @enum {number}
         * @property {number} RUN_MACHINE_COMMAND_UNSPECIFIED=0 RUN_MACHINE_COMMAND_UNSPECIFIED value
         * @property {number} RUN_MACHINE_COMMAND_INIT=1 RUN_MACHINE_COMMAND_INIT value
         * @property {number} RUN_MACHINE_COMMAND_APPLY=2 RUN_MACHINE_COMMAND_APPLY value
         * @property {number} RUN_MACHINE_COMMAND_ADVANCE=3 RUN_MACHINE_COMMAND_ADVANCE value
         * @property {number} RUN_MACHINE_COMMAND_CONFIRM=4 RUN_MACHINE_COMMAND_CONFIRM value
         * @property {number} RUN_MACHINE_COMMAND_ROLLBACK=5 RUN_MACHINE_COMMAND_ROLLBACK value
         * @property {number} RUN_MACHINE_COMMAND_RELEASE=6 RUN_MACHINE_COMMAND_RELEASE value
         */
        v2.RunMachineCommand = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "RUN_MACHINE_COMMAND_UNSPECIFIED"] = 0;
            values[valuesById[1] = "RUN_MACHINE_COMMAND_INIT"] = 1;
            values[valuesById[2] = "RUN_MACHINE_COMMAND_APPLY"] = 2;
            values[valuesById[3] = "RUN_MACHINE_COMMAND_ADVANCE"] = 3;
            values[valuesById[4] = "RUN_MACHINE_COMMAND_CONFIRM"] = 4;
            values[valuesById[5] = "RUN_MACHINE_COMMAND_ROLLBACK"] = 5;
            values[valuesById[6] = "RUN_MACHINE_COMMAND_RELEASE"] = 6;
            return values;
        })();

        v2.RunMachineRequest = (function() {

            /**
             * Properties of a RunMachineRequest.
             * @memberof breacher.v2
             * @interface IRunMachineRequest
             * @property {breacher.v2.RunMachineCommand|null} [command] RunMachineRequest command
             * @property {breacher.v2.IRunSnapshot|null} [snapshot] RunMachineRequest snapshot
             * @property {breacher.v2.IRunOperation|null} [operation] RunMachineRequest operation
             * @property {number|Long|null} [advanceToMs] RunMachineRequest advanceToMs
             * @property {number|Long|null} [acceptedAtMs] RunMachineRequest acceptedAtMs
             */

            /**
             * Constructs a new RunMachineRequest.
             * @memberof breacher.v2
             * @classdesc Represents a RunMachineRequest.
             * @implements IRunMachineRequest
             * @constructor
             * @param {breacher.v2.IRunMachineRequest=} [properties] Properties to set
             */
            function RunMachineRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RunMachineRequest command.
             * @member {breacher.v2.RunMachineCommand} command
             * @memberof breacher.v2.RunMachineRequest
             * @instance
             */
            RunMachineRequest.prototype.command = 0;

            /**
             * RunMachineRequest snapshot.
             * @member {breacher.v2.IRunSnapshot|null|undefined} snapshot
             * @memberof breacher.v2.RunMachineRequest
             * @instance
             */
            RunMachineRequest.prototype.snapshot = null;

            /**
             * RunMachineRequest operation.
             * @member {breacher.v2.IRunOperation|null|undefined} operation
             * @memberof breacher.v2.RunMachineRequest
             * @instance
             */
            RunMachineRequest.prototype.operation = null;

            /**
             * RunMachineRequest advanceToMs.
             * @member {number|Long} advanceToMs
             * @memberof breacher.v2.RunMachineRequest
             * @instance
             */
            RunMachineRequest.prototype.advanceToMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * RunMachineRequest acceptedAtMs.
             * @member {number|Long} acceptedAtMs
             * @memberof breacher.v2.RunMachineRequest
             * @instance
             */
            RunMachineRequest.prototype.acceptedAtMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new RunMachineRequest instance using the specified properties.
             * @function create
             * @memberof breacher.v2.RunMachineRequest
             * @static
             * @param {breacher.v2.IRunMachineRequest=} [properties] Properties to set
             * @returns {breacher.v2.RunMachineRequest} RunMachineRequest instance
             */
            RunMachineRequest.create = function create(properties) {
                return new RunMachineRequest(properties);
            };

            /**
             * Encodes the specified RunMachineRequest message. Does not implicitly {@link breacher.v2.RunMachineRequest.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.RunMachineRequest
             * @static
             * @param {breacher.v2.IRunMachineRequest} message RunMachineRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunMachineRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.command != null && Object.hasOwnProperty.call(message, "command"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.command);
                if (message.snapshot != null && Object.hasOwnProperty.call(message, "snapshot"))
                    $root.breacher.v2.RunSnapshot.encode(message.snapshot, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                    $root.breacher.v2.RunOperation.encode(message.operation, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.advanceToMs != null && Object.hasOwnProperty.call(message, "advanceToMs"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.advanceToMs);
                if (message.acceptedAtMs != null && Object.hasOwnProperty.call(message, "acceptedAtMs"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int64(message.acceptedAtMs);
                return writer;
            };

            /**
             * Encodes the specified RunMachineRequest message, length delimited. Does not implicitly {@link breacher.v2.RunMachineRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.RunMachineRequest
             * @static
             * @param {breacher.v2.IRunMachineRequest} message RunMachineRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunMachineRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RunMachineRequest message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.RunMachineRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.RunMachineRequest} RunMachineRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunMachineRequest.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.RunMachineRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.command = reader.int32();
                            break;
                        }
                    case 2: {
                            message.snapshot = $root.breacher.v2.RunSnapshot.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.operation = $root.breacher.v2.RunOperation.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.advanceToMs = reader.int64();
                            break;
                        }
                    case 5: {
                            message.acceptedAtMs = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RunMachineRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.RunMachineRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.RunMachineRequest} RunMachineRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunMachineRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RunMachineRequest message.
             * @function verify
             * @memberof breacher.v2.RunMachineRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RunMachineRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.command != null && message.hasOwnProperty("command"))
                    switch (message.command) {
                    default:
                        return "command: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                        break;
                    }
                if (message.snapshot != null && message.hasOwnProperty("snapshot")) {
                    let error = $root.breacher.v2.RunSnapshot.verify(message.snapshot);
                    if (error)
                        return "snapshot." + error;
                }
                if (message.operation != null && message.hasOwnProperty("operation")) {
                    let error = $root.breacher.v2.RunOperation.verify(message.operation);
                    if (error)
                        return "operation." + error;
                }
                if (message.advanceToMs != null && message.hasOwnProperty("advanceToMs"))
                    if (!$util.isInteger(message.advanceToMs) && !(message.advanceToMs && $util.isInteger(message.advanceToMs.low) && $util.isInteger(message.advanceToMs.high)))
                        return "advanceToMs: integer|Long expected";
                if (message.acceptedAtMs != null && message.hasOwnProperty("acceptedAtMs"))
                    if (!$util.isInteger(message.acceptedAtMs) && !(message.acceptedAtMs && $util.isInteger(message.acceptedAtMs.low) && $util.isInteger(message.acceptedAtMs.high)))
                        return "acceptedAtMs: integer|Long expected";
                return null;
            };

            /**
             * Creates a RunMachineRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.RunMachineRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.RunMachineRequest} RunMachineRequest
             */
            RunMachineRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.RunMachineRequest)
                    return object;
                let message = new $root.breacher.v2.RunMachineRequest();
                switch (object.command) {
                default:
                    if (typeof object.command === "number") {
                        message.command = object.command;
                        break;
                    }
                    break;
                case "RUN_MACHINE_COMMAND_UNSPECIFIED":
                case 0:
                    message.command = 0;
                    break;
                case "RUN_MACHINE_COMMAND_INIT":
                case 1:
                    message.command = 1;
                    break;
                case "RUN_MACHINE_COMMAND_APPLY":
                case 2:
                    message.command = 2;
                    break;
                case "RUN_MACHINE_COMMAND_ADVANCE":
                case 3:
                    message.command = 3;
                    break;
                case "RUN_MACHINE_COMMAND_CONFIRM":
                case 4:
                    message.command = 4;
                    break;
                case "RUN_MACHINE_COMMAND_ROLLBACK":
                case 5:
                    message.command = 5;
                    break;
                case "RUN_MACHINE_COMMAND_RELEASE":
                case 6:
                    message.command = 6;
                    break;
                }
                if (object.snapshot != null) {
                    if (typeof object.snapshot !== "object")
                        throw TypeError(".breacher.v2.RunMachineRequest.snapshot: object expected");
                    message.snapshot = $root.breacher.v2.RunSnapshot.fromObject(object.snapshot);
                }
                if (object.operation != null) {
                    if (typeof object.operation !== "object")
                        throw TypeError(".breacher.v2.RunMachineRequest.operation: object expected");
                    message.operation = $root.breacher.v2.RunOperation.fromObject(object.operation);
                }
                if (object.advanceToMs != null)
                    if ($util.Long)
                        (message.advanceToMs = $util.Long.fromValue(object.advanceToMs)).unsigned = false;
                    else if (typeof object.advanceToMs === "string")
                        message.advanceToMs = parseInt(object.advanceToMs, 10);
                    else if (typeof object.advanceToMs === "number")
                        message.advanceToMs = object.advanceToMs;
                    else if (typeof object.advanceToMs === "object")
                        message.advanceToMs = new $util.LongBits(object.advanceToMs.low >>> 0, object.advanceToMs.high >>> 0).toNumber();
                if (object.acceptedAtMs != null)
                    if ($util.Long)
                        (message.acceptedAtMs = $util.Long.fromValue(object.acceptedAtMs)).unsigned = false;
                    else if (typeof object.acceptedAtMs === "string")
                        message.acceptedAtMs = parseInt(object.acceptedAtMs, 10);
                    else if (typeof object.acceptedAtMs === "number")
                        message.acceptedAtMs = object.acceptedAtMs;
                    else if (typeof object.acceptedAtMs === "object")
                        message.acceptedAtMs = new $util.LongBits(object.acceptedAtMs.low >>> 0, object.acceptedAtMs.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a RunMachineRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.RunMachineRequest
             * @static
             * @param {breacher.v2.RunMachineRequest} message RunMachineRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RunMachineRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.command = options.enums === String ? "RUN_MACHINE_COMMAND_UNSPECIFIED" : 0;
                    object.snapshot = null;
                    object.operation = null;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.advanceToMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.advanceToMs = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.acceptedAtMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.acceptedAtMs = options.longs === String ? "0" : 0;
                }
                if (message.command != null && message.hasOwnProperty("command"))
                    object.command = options.enums === String ? $root.breacher.v2.RunMachineCommand[message.command] === undefined ? message.command : $root.breacher.v2.RunMachineCommand[message.command] : message.command;
                if (message.snapshot != null && message.hasOwnProperty("snapshot"))
                    object.snapshot = $root.breacher.v2.RunSnapshot.toObject(message.snapshot, options);
                if (message.operation != null && message.hasOwnProperty("operation"))
                    object.operation = $root.breacher.v2.RunOperation.toObject(message.operation, options);
                if (message.advanceToMs != null && message.hasOwnProperty("advanceToMs"))
                    if (typeof message.advanceToMs === "number")
                        object.advanceToMs = options.longs === String ? String(message.advanceToMs) : message.advanceToMs;
                    else
                        object.advanceToMs = options.longs === String ? $util.Long.prototype.toString.call(message.advanceToMs) : options.longs === Number ? new $util.LongBits(message.advanceToMs.low >>> 0, message.advanceToMs.high >>> 0).toNumber() : message.advanceToMs;
                if (message.acceptedAtMs != null && message.hasOwnProperty("acceptedAtMs"))
                    if (typeof message.acceptedAtMs === "number")
                        object.acceptedAtMs = options.longs === String ? String(message.acceptedAtMs) : message.acceptedAtMs;
                    else
                        object.acceptedAtMs = options.longs === String ? $util.Long.prototype.toString.call(message.acceptedAtMs) : options.longs === Number ? new $util.LongBits(message.acceptedAtMs.low >>> 0, message.acceptedAtMs.high >>> 0).toNumber() : message.acceptedAtMs;
                return object;
            };

            /**
             * Converts this RunMachineRequest to JSON.
             * @function toJSON
             * @memberof breacher.v2.RunMachineRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RunMachineRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RunMachineRequest
             * @function getTypeUrl
             * @memberof breacher.v2.RunMachineRequest
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RunMachineRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.RunMachineRequest";
            };

            return RunMachineRequest;
        })();

        v2.RunMachineResult = (function() {

            /**
             * Properties of a RunMachineResult.
             * @memberof breacher.v2
             * @interface IRunMachineResult
             * @property {breacher.v2.IRunSnapshot|null} [snapshot] RunMachineResult snapshot
             * @property {breacher.v2.IRunAck|null} [ack] RunMachineResult ack
             * @property {breacher.v2.IWireError|null} [error] RunMachineResult error
             * @property {boolean|null} [randomWindowExhausted] RunMachineResult randomWindowExhausted
             * @property {boolean|null} [needsAuthorityEvent] RunMachineResult needsAuthorityEvent
             * @property {breacher.v2.IWireValue|null} [resolution] RunMachineResult resolution
             */

            /**
             * Constructs a new RunMachineResult.
             * @memberof breacher.v2
             * @classdesc Represents a RunMachineResult.
             * @implements IRunMachineResult
             * @constructor
             * @param {breacher.v2.IRunMachineResult=} [properties] Properties to set
             */
            function RunMachineResult(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RunMachineResult snapshot.
             * @member {breacher.v2.IRunSnapshot|null|undefined} snapshot
             * @memberof breacher.v2.RunMachineResult
             * @instance
             */
            RunMachineResult.prototype.snapshot = null;

            /**
             * RunMachineResult ack.
             * @member {breacher.v2.IRunAck|null|undefined} ack
             * @memberof breacher.v2.RunMachineResult
             * @instance
             */
            RunMachineResult.prototype.ack = null;

            /**
             * RunMachineResult error.
             * @member {breacher.v2.IWireError|null|undefined} error
             * @memberof breacher.v2.RunMachineResult
             * @instance
             */
            RunMachineResult.prototype.error = null;

            /**
             * RunMachineResult randomWindowExhausted.
             * @member {boolean} randomWindowExhausted
             * @memberof breacher.v2.RunMachineResult
             * @instance
             */
            RunMachineResult.prototype.randomWindowExhausted = false;

            /**
             * RunMachineResult needsAuthorityEvent.
             * @member {boolean} needsAuthorityEvent
             * @memberof breacher.v2.RunMachineResult
             * @instance
             */
            RunMachineResult.prototype.needsAuthorityEvent = false;

            /**
             * RunMachineResult resolution.
             * @member {breacher.v2.IWireValue|null|undefined} resolution
             * @memberof breacher.v2.RunMachineResult
             * @instance
             */
            RunMachineResult.prototype.resolution = null;

            /**
             * Creates a new RunMachineResult instance using the specified properties.
             * @function create
             * @memberof breacher.v2.RunMachineResult
             * @static
             * @param {breacher.v2.IRunMachineResult=} [properties] Properties to set
             * @returns {breacher.v2.RunMachineResult} RunMachineResult instance
             */
            RunMachineResult.create = function create(properties) {
                return new RunMachineResult(properties);
            };

            /**
             * Encodes the specified RunMachineResult message. Does not implicitly {@link breacher.v2.RunMachineResult.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.RunMachineResult
             * @static
             * @param {breacher.v2.IRunMachineResult} message RunMachineResult message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunMachineResult.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.snapshot != null && Object.hasOwnProperty.call(message, "snapshot"))
                    $root.breacher.v2.RunSnapshot.encode(message.snapshot, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.ack != null && Object.hasOwnProperty.call(message, "ack"))
                    $root.breacher.v2.RunAck.encode(message.ack, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                    $root.breacher.v2.WireError.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.randomWindowExhausted != null && Object.hasOwnProperty.call(message, "randomWindowExhausted"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.randomWindowExhausted);
                if (message.needsAuthorityEvent != null && Object.hasOwnProperty.call(message, "needsAuthorityEvent"))
                    writer.uint32(/* id 5, wireType 0 =*/40).bool(message.needsAuthorityEvent);
                if (message.resolution != null && Object.hasOwnProperty.call(message, "resolution"))
                    $root.breacher.v2.WireValue.encode(message.resolution, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified RunMachineResult message, length delimited. Does not implicitly {@link breacher.v2.RunMachineResult.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.RunMachineResult
             * @static
             * @param {breacher.v2.IRunMachineResult} message RunMachineResult message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RunMachineResult.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RunMachineResult message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.RunMachineResult
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.RunMachineResult} RunMachineResult
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunMachineResult.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.RunMachineResult();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.snapshot = $root.breacher.v2.RunSnapshot.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.ack = $root.breacher.v2.RunAck.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.error = $root.breacher.v2.WireError.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.randomWindowExhausted = reader.bool();
                            break;
                        }
                    case 5: {
                            message.needsAuthorityEvent = reader.bool();
                            break;
                        }
                    case 6: {
                            message.resolution = $root.breacher.v2.WireValue.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RunMachineResult message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.RunMachineResult
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.RunMachineResult} RunMachineResult
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RunMachineResult.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RunMachineResult message.
             * @function verify
             * @memberof breacher.v2.RunMachineResult
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RunMachineResult.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.snapshot != null && message.hasOwnProperty("snapshot")) {
                    let error = $root.breacher.v2.RunSnapshot.verify(message.snapshot);
                    if (error)
                        return "snapshot." + error;
                }
                if (message.ack != null && message.hasOwnProperty("ack")) {
                    let error = $root.breacher.v2.RunAck.verify(message.ack);
                    if (error)
                        return "ack." + error;
                }
                if (message.error != null && message.hasOwnProperty("error")) {
                    let error = $root.breacher.v2.WireError.verify(message.error);
                    if (error)
                        return "error." + error;
                }
                if (message.randomWindowExhausted != null && message.hasOwnProperty("randomWindowExhausted"))
                    if (typeof message.randomWindowExhausted !== "boolean")
                        return "randomWindowExhausted: boolean expected";
                if (message.needsAuthorityEvent != null && message.hasOwnProperty("needsAuthorityEvent"))
                    if (typeof message.needsAuthorityEvent !== "boolean")
                        return "needsAuthorityEvent: boolean expected";
                if (message.resolution != null && message.hasOwnProperty("resolution")) {
                    let error = $root.breacher.v2.WireValue.verify(message.resolution);
                    if (error)
                        return "resolution." + error;
                }
                return null;
            };

            /**
             * Creates a RunMachineResult message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.RunMachineResult
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.RunMachineResult} RunMachineResult
             */
            RunMachineResult.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.RunMachineResult)
                    return object;
                let message = new $root.breacher.v2.RunMachineResult();
                if (object.snapshot != null) {
                    if (typeof object.snapshot !== "object")
                        throw TypeError(".breacher.v2.RunMachineResult.snapshot: object expected");
                    message.snapshot = $root.breacher.v2.RunSnapshot.fromObject(object.snapshot);
                }
                if (object.ack != null) {
                    if (typeof object.ack !== "object")
                        throw TypeError(".breacher.v2.RunMachineResult.ack: object expected");
                    message.ack = $root.breacher.v2.RunAck.fromObject(object.ack);
                }
                if (object.error != null) {
                    if (typeof object.error !== "object")
                        throw TypeError(".breacher.v2.RunMachineResult.error: object expected");
                    message.error = $root.breacher.v2.WireError.fromObject(object.error);
                }
                if (object.randomWindowExhausted != null)
                    message.randomWindowExhausted = Boolean(object.randomWindowExhausted);
                if (object.needsAuthorityEvent != null)
                    message.needsAuthorityEvent = Boolean(object.needsAuthorityEvent);
                if (object.resolution != null) {
                    if (typeof object.resolution !== "object")
                        throw TypeError(".breacher.v2.RunMachineResult.resolution: object expected");
                    message.resolution = $root.breacher.v2.WireValue.fromObject(object.resolution);
                }
                return message;
            };

            /**
             * Creates a plain object from a RunMachineResult message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.RunMachineResult
             * @static
             * @param {breacher.v2.RunMachineResult} message RunMachineResult
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RunMachineResult.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.snapshot = null;
                    object.ack = null;
                    object.error = null;
                    object.randomWindowExhausted = false;
                    object.needsAuthorityEvent = false;
                    object.resolution = null;
                }
                if (message.snapshot != null && message.hasOwnProperty("snapshot"))
                    object.snapshot = $root.breacher.v2.RunSnapshot.toObject(message.snapshot, options);
                if (message.ack != null && message.hasOwnProperty("ack"))
                    object.ack = $root.breacher.v2.RunAck.toObject(message.ack, options);
                if (message.error != null && message.hasOwnProperty("error"))
                    object.error = $root.breacher.v2.WireError.toObject(message.error, options);
                if (message.randomWindowExhausted != null && message.hasOwnProperty("randomWindowExhausted"))
                    object.randomWindowExhausted = message.randomWindowExhausted;
                if (message.needsAuthorityEvent != null && message.hasOwnProperty("needsAuthorityEvent"))
                    object.needsAuthorityEvent = message.needsAuthorityEvent;
                if (message.resolution != null && message.hasOwnProperty("resolution"))
                    object.resolution = $root.breacher.v2.WireValue.toObject(message.resolution, options);
                return object;
            };

            /**
             * Converts this RunMachineResult to JSON.
             * @function toJSON
             * @memberof breacher.v2.RunMachineResult
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RunMachineResult.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RunMachineResult
             * @function getTypeUrl
             * @memberof breacher.v2.RunMachineResult
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RunMachineResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.RunMachineResult";
            };

            return RunMachineResult;
        })();

        v2.MatchPreviewRequest = (function() {

            /**
             * Properties of a MatchPreviewRequest.
             * @memberof breacher.v2
             * @interface IMatchPreviewRequest
             * @property {Array.<number>|null} [board] MatchPreviewRequest board
             * @property {breacher.v2.ISlideAction|null} [slide] MatchPreviewRequest slide
             * @property {boolean|null} [wrapMatches] MatchPreviewRequest wrapMatches
             * @property {boolean|null} [woodOreUnion] MatchPreviewRequest woodOreUnion
             */

            /**
             * Constructs a new MatchPreviewRequest.
             * @memberof breacher.v2
             * @classdesc Represents a MatchPreviewRequest.
             * @implements IMatchPreviewRequest
             * @constructor
             * @param {breacher.v2.IMatchPreviewRequest=} [properties] Properties to set
             */
            function MatchPreviewRequest(properties) {
                this.board = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MatchPreviewRequest board.
             * @member {Array.<number>} board
             * @memberof breacher.v2.MatchPreviewRequest
             * @instance
             */
            MatchPreviewRequest.prototype.board = $util.emptyArray;

            /**
             * MatchPreviewRequest slide.
             * @member {breacher.v2.ISlideAction|null|undefined} slide
             * @memberof breacher.v2.MatchPreviewRequest
             * @instance
             */
            MatchPreviewRequest.prototype.slide = null;

            /**
             * MatchPreviewRequest wrapMatches.
             * @member {boolean} wrapMatches
             * @memberof breacher.v2.MatchPreviewRequest
             * @instance
             */
            MatchPreviewRequest.prototype.wrapMatches = false;

            /**
             * MatchPreviewRequest woodOreUnion.
             * @member {boolean} woodOreUnion
             * @memberof breacher.v2.MatchPreviewRequest
             * @instance
             */
            MatchPreviewRequest.prototype.woodOreUnion = false;

            /**
             * Creates a new MatchPreviewRequest instance using the specified properties.
             * @function create
             * @memberof breacher.v2.MatchPreviewRequest
             * @static
             * @param {breacher.v2.IMatchPreviewRequest=} [properties] Properties to set
             * @returns {breacher.v2.MatchPreviewRequest} MatchPreviewRequest instance
             */
            MatchPreviewRequest.create = function create(properties) {
                return new MatchPreviewRequest(properties);
            };

            /**
             * Encodes the specified MatchPreviewRequest message. Does not implicitly {@link breacher.v2.MatchPreviewRequest.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.MatchPreviewRequest
             * @static
             * @param {breacher.v2.IMatchPreviewRequest} message MatchPreviewRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MatchPreviewRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.board != null && message.board.length) {
                    writer.uint32(/* id 1, wireType 2 =*/10).fork();
                    for (let i = 0; i < message.board.length; ++i)
                        writer.uint32(message.board[i]);
                    writer.ldelim();
                }
                if (message.slide != null && Object.hasOwnProperty.call(message, "slide"))
                    $root.breacher.v2.SlideAction.encode(message.slide, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.wrapMatches != null && Object.hasOwnProperty.call(message, "wrapMatches"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.wrapMatches);
                if (message.woodOreUnion != null && Object.hasOwnProperty.call(message, "woodOreUnion"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.woodOreUnion);
                return writer;
            };

            /**
             * Encodes the specified MatchPreviewRequest message, length delimited. Does not implicitly {@link breacher.v2.MatchPreviewRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.MatchPreviewRequest
             * @static
             * @param {breacher.v2.IMatchPreviewRequest} message MatchPreviewRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MatchPreviewRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MatchPreviewRequest message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.MatchPreviewRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.MatchPreviewRequest} MatchPreviewRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MatchPreviewRequest.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.MatchPreviewRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.board && message.board.length))
                                message.board = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.board.push(reader.uint32());
                            } else
                                message.board.push(reader.uint32());
                            break;
                        }
                    case 2: {
                            message.slide = $root.breacher.v2.SlideAction.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.wrapMatches = reader.bool();
                            break;
                        }
                    case 4: {
                            message.woodOreUnion = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MatchPreviewRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.MatchPreviewRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.MatchPreviewRequest} MatchPreviewRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MatchPreviewRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MatchPreviewRequest message.
             * @function verify
             * @memberof breacher.v2.MatchPreviewRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MatchPreviewRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.board != null && message.hasOwnProperty("board")) {
                    if (!Array.isArray(message.board))
                        return "board: array expected";
                    for (let i = 0; i < message.board.length; ++i)
                        if (!$util.isInteger(message.board[i]))
                            return "board: integer[] expected";
                }
                if (message.slide != null && message.hasOwnProperty("slide")) {
                    let error = $root.breacher.v2.SlideAction.verify(message.slide);
                    if (error)
                        return "slide." + error;
                }
                if (message.wrapMatches != null && message.hasOwnProperty("wrapMatches"))
                    if (typeof message.wrapMatches !== "boolean")
                        return "wrapMatches: boolean expected";
                if (message.woodOreUnion != null && message.hasOwnProperty("woodOreUnion"))
                    if (typeof message.woodOreUnion !== "boolean")
                        return "woodOreUnion: boolean expected";
                return null;
            };

            /**
             * Creates a MatchPreviewRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.MatchPreviewRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.MatchPreviewRequest} MatchPreviewRequest
             */
            MatchPreviewRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.MatchPreviewRequest)
                    return object;
                let message = new $root.breacher.v2.MatchPreviewRequest();
                if (object.board) {
                    if (!Array.isArray(object.board))
                        throw TypeError(".breacher.v2.MatchPreviewRequest.board: array expected");
                    message.board = [];
                    for (let i = 0; i < object.board.length; ++i)
                        message.board[i] = object.board[i] >>> 0;
                }
                if (object.slide != null) {
                    if (typeof object.slide !== "object")
                        throw TypeError(".breacher.v2.MatchPreviewRequest.slide: object expected");
                    message.slide = $root.breacher.v2.SlideAction.fromObject(object.slide);
                }
                if (object.wrapMatches != null)
                    message.wrapMatches = Boolean(object.wrapMatches);
                if (object.woodOreUnion != null)
                    message.woodOreUnion = Boolean(object.woodOreUnion);
                return message;
            };

            /**
             * Creates a plain object from a MatchPreviewRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.MatchPreviewRequest
             * @static
             * @param {breacher.v2.MatchPreviewRequest} message MatchPreviewRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MatchPreviewRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.board = [];
                if (options.defaults) {
                    object.slide = null;
                    object.wrapMatches = false;
                    object.woodOreUnion = false;
                }
                if (message.board && message.board.length) {
                    object.board = [];
                    for (let j = 0; j < message.board.length; ++j)
                        object.board[j] = message.board[j];
                }
                if (message.slide != null && message.hasOwnProperty("slide"))
                    object.slide = $root.breacher.v2.SlideAction.toObject(message.slide, options);
                if (message.wrapMatches != null && message.hasOwnProperty("wrapMatches"))
                    object.wrapMatches = message.wrapMatches;
                if (message.woodOreUnion != null && message.hasOwnProperty("woodOreUnion"))
                    object.woodOreUnion = message.woodOreUnion;
                return object;
            };

            /**
             * Converts this MatchPreviewRequest to JSON.
             * @function toJSON
             * @memberof breacher.v2.MatchPreviewRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MatchPreviewRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MatchPreviewRequest
             * @function getTypeUrl
             * @memberof breacher.v2.MatchPreviewRequest
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MatchPreviewRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.MatchPreviewRequest";
            };

            return MatchPreviewRequest;
        })();

        v2.MatchPreviewResult = (function() {

            /**
             * Properties of a MatchPreviewResult.
             * @memberof breacher.v2
             * @interface IMatchPreviewResult
             * @property {boolean|null} [matches] MatchPreviewResult matches
             * @property {breacher.v2.IWireError|null} [error] MatchPreviewResult error
             */

            /**
             * Constructs a new MatchPreviewResult.
             * @memberof breacher.v2
             * @classdesc Represents a MatchPreviewResult.
             * @implements IMatchPreviewResult
             * @constructor
             * @param {breacher.v2.IMatchPreviewResult=} [properties] Properties to set
             */
            function MatchPreviewResult(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MatchPreviewResult matches.
             * @member {boolean} matches
             * @memberof breacher.v2.MatchPreviewResult
             * @instance
             */
            MatchPreviewResult.prototype.matches = false;

            /**
             * MatchPreviewResult error.
             * @member {breacher.v2.IWireError|null|undefined} error
             * @memberof breacher.v2.MatchPreviewResult
             * @instance
             */
            MatchPreviewResult.prototype.error = null;

            /**
             * Creates a new MatchPreviewResult instance using the specified properties.
             * @function create
             * @memberof breacher.v2.MatchPreviewResult
             * @static
             * @param {breacher.v2.IMatchPreviewResult=} [properties] Properties to set
             * @returns {breacher.v2.MatchPreviewResult} MatchPreviewResult instance
             */
            MatchPreviewResult.create = function create(properties) {
                return new MatchPreviewResult(properties);
            };

            /**
             * Encodes the specified MatchPreviewResult message. Does not implicitly {@link breacher.v2.MatchPreviewResult.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.MatchPreviewResult
             * @static
             * @param {breacher.v2.IMatchPreviewResult} message MatchPreviewResult message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MatchPreviewResult.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.matches != null && Object.hasOwnProperty.call(message, "matches"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.matches);
                if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                    $root.breacher.v2.WireError.encode(message.error, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified MatchPreviewResult message, length delimited. Does not implicitly {@link breacher.v2.MatchPreviewResult.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.MatchPreviewResult
             * @static
             * @param {breacher.v2.IMatchPreviewResult} message MatchPreviewResult message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MatchPreviewResult.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MatchPreviewResult message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.MatchPreviewResult
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.MatchPreviewResult} MatchPreviewResult
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MatchPreviewResult.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.MatchPreviewResult();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.matches = reader.bool();
                            break;
                        }
                    case 2: {
                            message.error = $root.breacher.v2.WireError.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MatchPreviewResult message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.MatchPreviewResult
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.MatchPreviewResult} MatchPreviewResult
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MatchPreviewResult.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MatchPreviewResult message.
             * @function verify
             * @memberof breacher.v2.MatchPreviewResult
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MatchPreviewResult.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.matches != null && message.hasOwnProperty("matches"))
                    if (typeof message.matches !== "boolean")
                        return "matches: boolean expected";
                if (message.error != null && message.hasOwnProperty("error")) {
                    let error = $root.breacher.v2.WireError.verify(message.error);
                    if (error)
                        return "error." + error;
                }
                return null;
            };

            /**
             * Creates a MatchPreviewResult message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.MatchPreviewResult
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.MatchPreviewResult} MatchPreviewResult
             */
            MatchPreviewResult.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.MatchPreviewResult)
                    return object;
                let message = new $root.breacher.v2.MatchPreviewResult();
                if (object.matches != null)
                    message.matches = Boolean(object.matches);
                if (object.error != null) {
                    if (typeof object.error !== "object")
                        throw TypeError(".breacher.v2.MatchPreviewResult.error: object expected");
                    message.error = $root.breacher.v2.WireError.fromObject(object.error);
                }
                return message;
            };

            /**
             * Creates a plain object from a MatchPreviewResult message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.MatchPreviewResult
             * @static
             * @param {breacher.v2.MatchPreviewResult} message MatchPreviewResult
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MatchPreviewResult.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.matches = false;
                    object.error = null;
                }
                if (message.matches != null && message.hasOwnProperty("matches"))
                    object.matches = message.matches;
                if (message.error != null && message.hasOwnProperty("error"))
                    object.error = $root.breacher.v2.WireError.toObject(message.error, options);
                return object;
            };

            /**
             * Converts this MatchPreviewResult to JSON.
             * @function toJSON
             * @memberof breacher.v2.MatchPreviewResult
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MatchPreviewResult.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MatchPreviewResult
             * @function getTypeUrl
             * @memberof breacher.v2.MatchPreviewResult
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MatchPreviewResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.MatchPreviewResult";
            };

            return MatchPreviewResult;
        })();

        v2.AutomationRequest = (function() {

            /**
             * Properties of an AutomationRequest.
             * @memberof breacher.v2
             * @interface IAutomationRequest
             * @property {Array.<number>|null} [board] AutomationRequest board
             * @property {boolean|null} [wrapMatches] AutomationRequest wrapMatches
             * @property {boolean|null} [woodOreUnion] AutomationRequest woodOreUnion
             * @property {number|null} [startCursor] AutomationRequest startCursor
             * @property {number|null} [policyVersion] AutomationRequest policyVersion
             */

            /**
             * Constructs a new AutomationRequest.
             * @memberof breacher.v2
             * @classdesc Represents an AutomationRequest.
             * @implements IAutomationRequest
             * @constructor
             * @param {breacher.v2.IAutomationRequest=} [properties] Properties to set
             */
            function AutomationRequest(properties) {
                this.board = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AutomationRequest board.
             * @member {Array.<number>} board
             * @memberof breacher.v2.AutomationRequest
             * @instance
             */
            AutomationRequest.prototype.board = $util.emptyArray;

            /**
             * AutomationRequest wrapMatches.
             * @member {boolean} wrapMatches
             * @memberof breacher.v2.AutomationRequest
             * @instance
             */
            AutomationRequest.prototype.wrapMatches = false;

            /**
             * AutomationRequest woodOreUnion.
             * @member {boolean} woodOreUnion
             * @memberof breacher.v2.AutomationRequest
             * @instance
             */
            AutomationRequest.prototype.woodOreUnion = false;

            /**
             * AutomationRequest startCursor.
             * @member {number} startCursor
             * @memberof breacher.v2.AutomationRequest
             * @instance
             */
            AutomationRequest.prototype.startCursor = 0;

            /**
             * AutomationRequest policyVersion.
             * @member {number} policyVersion
             * @memberof breacher.v2.AutomationRequest
             * @instance
             */
            AutomationRequest.prototype.policyVersion = 0;

            /**
             * Creates a new AutomationRequest instance using the specified properties.
             * @function create
             * @memberof breacher.v2.AutomationRequest
             * @static
             * @param {breacher.v2.IAutomationRequest=} [properties] Properties to set
             * @returns {breacher.v2.AutomationRequest} AutomationRequest instance
             */
            AutomationRequest.create = function create(properties) {
                return new AutomationRequest(properties);
            };

            /**
             * Encodes the specified AutomationRequest message. Does not implicitly {@link breacher.v2.AutomationRequest.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.AutomationRequest
             * @static
             * @param {breacher.v2.IAutomationRequest} message AutomationRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AutomationRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.board != null && message.board.length) {
                    writer.uint32(/* id 1, wireType 2 =*/10).fork();
                    for (let i = 0; i < message.board.length; ++i)
                        writer.uint32(message.board[i]);
                    writer.ldelim();
                }
                if (message.wrapMatches != null && Object.hasOwnProperty.call(message, "wrapMatches"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.wrapMatches);
                if (message.woodOreUnion != null && Object.hasOwnProperty.call(message, "woodOreUnion"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.woodOreUnion);
                if (message.startCursor != null && Object.hasOwnProperty.call(message, "startCursor"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.startCursor);
                if (message.policyVersion != null && Object.hasOwnProperty.call(message, "policyVersion"))
                    writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.policyVersion);
                return writer;
            };

            /**
             * Encodes the specified AutomationRequest message, length delimited. Does not implicitly {@link breacher.v2.AutomationRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.AutomationRequest
             * @static
             * @param {breacher.v2.IAutomationRequest} message AutomationRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AutomationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AutomationRequest message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.AutomationRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.AutomationRequest} AutomationRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AutomationRequest.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.AutomationRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.board && message.board.length))
                                message.board = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.board.push(reader.uint32());
                            } else
                                message.board.push(reader.uint32());
                            break;
                        }
                    case 2: {
                            message.wrapMatches = reader.bool();
                            break;
                        }
                    case 3: {
                            message.woodOreUnion = reader.bool();
                            break;
                        }
                    case 4: {
                            message.startCursor = reader.int32();
                            break;
                        }
                    case 5: {
                            message.policyVersion = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AutomationRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.AutomationRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.AutomationRequest} AutomationRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AutomationRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AutomationRequest message.
             * @function verify
             * @memberof breacher.v2.AutomationRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AutomationRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.board != null && message.hasOwnProperty("board")) {
                    if (!Array.isArray(message.board))
                        return "board: array expected";
                    for (let i = 0; i < message.board.length; ++i)
                        if (!$util.isInteger(message.board[i]))
                            return "board: integer[] expected";
                }
                if (message.wrapMatches != null && message.hasOwnProperty("wrapMatches"))
                    if (typeof message.wrapMatches !== "boolean")
                        return "wrapMatches: boolean expected";
                if (message.woodOreUnion != null && message.hasOwnProperty("woodOreUnion"))
                    if (typeof message.woodOreUnion !== "boolean")
                        return "woodOreUnion: boolean expected";
                if (message.startCursor != null && message.hasOwnProperty("startCursor"))
                    if (!$util.isInteger(message.startCursor))
                        return "startCursor: integer expected";
                if (message.policyVersion != null && message.hasOwnProperty("policyVersion"))
                    if (!$util.isInteger(message.policyVersion))
                        return "policyVersion: integer expected";
                return null;
            };

            /**
             * Creates an AutomationRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.AutomationRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.AutomationRequest} AutomationRequest
             */
            AutomationRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.AutomationRequest)
                    return object;
                let message = new $root.breacher.v2.AutomationRequest();
                if (object.board) {
                    if (!Array.isArray(object.board))
                        throw TypeError(".breacher.v2.AutomationRequest.board: array expected");
                    message.board = [];
                    for (let i = 0; i < object.board.length; ++i)
                        message.board[i] = object.board[i] >>> 0;
                }
                if (object.wrapMatches != null)
                    message.wrapMatches = Boolean(object.wrapMatches);
                if (object.woodOreUnion != null)
                    message.woodOreUnion = Boolean(object.woodOreUnion);
                if (object.startCursor != null)
                    message.startCursor = object.startCursor | 0;
                if (object.policyVersion != null)
                    message.policyVersion = object.policyVersion >>> 0;
                return message;
            };

            /**
             * Creates a plain object from an AutomationRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.AutomationRequest
             * @static
             * @param {breacher.v2.AutomationRequest} message AutomationRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AutomationRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.board = [];
                if (options.defaults) {
                    object.wrapMatches = false;
                    object.woodOreUnion = false;
                    object.startCursor = 0;
                    object.policyVersion = 0;
                }
                if (message.board && message.board.length) {
                    object.board = [];
                    for (let j = 0; j < message.board.length; ++j)
                        object.board[j] = message.board[j];
                }
                if (message.wrapMatches != null && message.hasOwnProperty("wrapMatches"))
                    object.wrapMatches = message.wrapMatches;
                if (message.woodOreUnion != null && message.hasOwnProperty("woodOreUnion"))
                    object.woodOreUnion = message.woodOreUnion;
                if (message.startCursor != null && message.hasOwnProperty("startCursor"))
                    object.startCursor = message.startCursor;
                if (message.policyVersion != null && message.hasOwnProperty("policyVersion"))
                    object.policyVersion = message.policyVersion;
                return object;
            };

            /**
             * Converts this AutomationRequest to JSON.
             * @function toJSON
             * @memberof breacher.v2.AutomationRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AutomationRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AutomationRequest
             * @function getTypeUrl
             * @memberof breacher.v2.AutomationRequest
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AutomationRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.AutomationRequest";
            };

            return AutomationRequest;
        })();

        v2.AutomationDecision = (function() {

            /**
             * Properties of an AutomationDecision.
             * @memberof breacher.v2
             * @interface IAutomationDecision
             * @property {string|null} [kind] AutomationDecision kind
             * @property {string|null} [axis] AutomationDecision axis
             * @property {number|null} [index] AutomationDecision index
             * @property {number|null} [distance] AutomationDecision distance
             * @property {string|null} [skill] AutomationDecision skill
             * @property {boolean|null} [open] AutomationDecision open
             * @property {number|null} [nextCursor] AutomationDecision nextCursor
             * @property {breacher.v2.IWireError|null} [error] AutomationDecision error
             */

            /**
             * Constructs a new AutomationDecision.
             * @memberof breacher.v2
             * @classdesc Represents an AutomationDecision.
             * @implements IAutomationDecision
             * @constructor
             * @param {breacher.v2.IAutomationDecision=} [properties] Properties to set
             */
            function AutomationDecision(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AutomationDecision kind.
             * @member {string} kind
             * @memberof breacher.v2.AutomationDecision
             * @instance
             */
            AutomationDecision.prototype.kind = "";

            /**
             * AutomationDecision axis.
             * @member {string} axis
             * @memberof breacher.v2.AutomationDecision
             * @instance
             */
            AutomationDecision.prototype.axis = "";

            /**
             * AutomationDecision index.
             * @member {number} index
             * @memberof breacher.v2.AutomationDecision
             * @instance
             */
            AutomationDecision.prototype.index = 0;

            /**
             * AutomationDecision distance.
             * @member {number} distance
             * @memberof breacher.v2.AutomationDecision
             * @instance
             */
            AutomationDecision.prototype.distance = 0;

            /**
             * AutomationDecision skill.
             * @member {string} skill
             * @memberof breacher.v2.AutomationDecision
             * @instance
             */
            AutomationDecision.prototype.skill = "";

            /**
             * AutomationDecision open.
             * @member {boolean} open
             * @memberof breacher.v2.AutomationDecision
             * @instance
             */
            AutomationDecision.prototype.open = false;

            /**
             * AutomationDecision nextCursor.
             * @member {number} nextCursor
             * @memberof breacher.v2.AutomationDecision
             * @instance
             */
            AutomationDecision.prototype.nextCursor = 0;

            /**
             * AutomationDecision error.
             * @member {breacher.v2.IWireError|null|undefined} error
             * @memberof breacher.v2.AutomationDecision
             * @instance
             */
            AutomationDecision.prototype.error = null;

            /**
             * Creates a new AutomationDecision instance using the specified properties.
             * @function create
             * @memberof breacher.v2.AutomationDecision
             * @static
             * @param {breacher.v2.IAutomationDecision=} [properties] Properties to set
             * @returns {breacher.v2.AutomationDecision} AutomationDecision instance
             */
            AutomationDecision.create = function create(properties) {
                return new AutomationDecision(properties);
            };

            /**
             * Encodes the specified AutomationDecision message. Does not implicitly {@link breacher.v2.AutomationDecision.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.AutomationDecision
             * @static
             * @param {breacher.v2.IAutomationDecision} message AutomationDecision message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AutomationDecision.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.kind);
                if (message.axis != null && Object.hasOwnProperty.call(message, "axis"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.axis);
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.index);
                if (message.distance != null && Object.hasOwnProperty.call(message, "distance"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.distance);
                if (message.skill != null && Object.hasOwnProperty.call(message, "skill"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.skill);
                if (message.open != null && Object.hasOwnProperty.call(message, "open"))
                    writer.uint32(/* id 6, wireType 0 =*/48).bool(message.open);
                if (message.nextCursor != null && Object.hasOwnProperty.call(message, "nextCursor"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.nextCursor);
                if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                    $root.breacher.v2.WireError.encode(message.error, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AutomationDecision message, length delimited. Does not implicitly {@link breacher.v2.AutomationDecision.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.AutomationDecision
             * @static
             * @param {breacher.v2.IAutomationDecision} message AutomationDecision message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AutomationDecision.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AutomationDecision message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.AutomationDecision
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.AutomationDecision} AutomationDecision
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AutomationDecision.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.AutomationDecision();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.kind = reader.string();
                            break;
                        }
                    case 2: {
                            message.axis = reader.string();
                            break;
                        }
                    case 3: {
                            message.index = reader.int32();
                            break;
                        }
                    case 4: {
                            message.distance = reader.int32();
                            break;
                        }
                    case 5: {
                            message.skill = reader.string();
                            break;
                        }
                    case 6: {
                            message.open = reader.bool();
                            break;
                        }
                    case 7: {
                            message.nextCursor = reader.int32();
                            break;
                        }
                    case 8: {
                            message.error = $root.breacher.v2.WireError.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AutomationDecision message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.AutomationDecision
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.AutomationDecision} AutomationDecision
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AutomationDecision.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AutomationDecision message.
             * @function verify
             * @memberof breacher.v2.AutomationDecision
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AutomationDecision.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.kind != null && message.hasOwnProperty("kind"))
                    if (!$util.isString(message.kind))
                        return "kind: string expected";
                if (message.axis != null && message.hasOwnProperty("axis"))
                    if (!$util.isString(message.axis))
                        return "axis: string expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                if (message.distance != null && message.hasOwnProperty("distance"))
                    if (!$util.isInteger(message.distance))
                        return "distance: integer expected";
                if (message.skill != null && message.hasOwnProperty("skill"))
                    if (!$util.isString(message.skill))
                        return "skill: string expected";
                if (message.open != null && message.hasOwnProperty("open"))
                    if (typeof message.open !== "boolean")
                        return "open: boolean expected";
                if (message.nextCursor != null && message.hasOwnProperty("nextCursor"))
                    if (!$util.isInteger(message.nextCursor))
                        return "nextCursor: integer expected";
                if (message.error != null && message.hasOwnProperty("error")) {
                    let error = $root.breacher.v2.WireError.verify(message.error);
                    if (error)
                        return "error." + error;
                }
                return null;
            };

            /**
             * Creates an AutomationDecision message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.AutomationDecision
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.AutomationDecision} AutomationDecision
             */
            AutomationDecision.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.AutomationDecision)
                    return object;
                let message = new $root.breacher.v2.AutomationDecision();
                if (object.kind != null)
                    message.kind = String(object.kind);
                if (object.axis != null)
                    message.axis = String(object.axis);
                if (object.index != null)
                    message.index = object.index | 0;
                if (object.distance != null)
                    message.distance = object.distance | 0;
                if (object.skill != null)
                    message.skill = String(object.skill);
                if (object.open != null)
                    message.open = Boolean(object.open);
                if (object.nextCursor != null)
                    message.nextCursor = object.nextCursor | 0;
                if (object.error != null) {
                    if (typeof object.error !== "object")
                        throw TypeError(".breacher.v2.AutomationDecision.error: object expected");
                    message.error = $root.breacher.v2.WireError.fromObject(object.error);
                }
                return message;
            };

            /**
             * Creates a plain object from an AutomationDecision message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.AutomationDecision
             * @static
             * @param {breacher.v2.AutomationDecision} message AutomationDecision
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AutomationDecision.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.kind = "";
                    object.axis = "";
                    object.index = 0;
                    object.distance = 0;
                    object.skill = "";
                    object.open = false;
                    object.nextCursor = 0;
                    object.error = null;
                }
                if (message.kind != null && message.hasOwnProperty("kind"))
                    object.kind = message.kind;
                if (message.axis != null && message.hasOwnProperty("axis"))
                    object.axis = message.axis;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                if (message.distance != null && message.hasOwnProperty("distance"))
                    object.distance = message.distance;
                if (message.skill != null && message.hasOwnProperty("skill"))
                    object.skill = message.skill;
                if (message.open != null && message.hasOwnProperty("open"))
                    object.open = message.open;
                if (message.nextCursor != null && message.hasOwnProperty("nextCursor"))
                    object.nextCursor = message.nextCursor;
                if (message.error != null && message.hasOwnProperty("error"))
                    object.error = $root.breacher.v2.WireError.toObject(message.error, options);
                return object;
            };

            /**
             * Converts this AutomationDecision to JSON.
             * @function toJSON
             * @memberof breacher.v2.AutomationDecision
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AutomationDecision.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for AutomationDecision
             * @function getTypeUrl
             * @memberof breacher.v2.AutomationDecision
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            AutomationDecision.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.AutomationDecision";
            };

            return AutomationDecision;
        })();

        v2.OfflinePackage = (function() {

            /**
             * Properties of an OfflinePackage.
             * @memberof breacher.v2
             * @interface IOfflinePackage
             * @property {string|null} [id] OfflinePackage id
             * @property {number|Long|null} [seconds] OfflinePackage seconds
             * @property {number|Long|null} [diamond] OfflinePackage diamond
             */

            /**
             * Constructs a new OfflinePackage.
             * @memberof breacher.v2
             * @classdesc Represents an OfflinePackage.
             * @implements IOfflinePackage
             * @constructor
             * @param {breacher.v2.IOfflinePackage=} [properties] Properties to set
             */
            function OfflinePackage(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OfflinePackage id.
             * @member {string} id
             * @memberof breacher.v2.OfflinePackage
             * @instance
             */
            OfflinePackage.prototype.id = "";

            /**
             * OfflinePackage seconds.
             * @member {number|Long} seconds
             * @memberof breacher.v2.OfflinePackage
             * @instance
             */
            OfflinePackage.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OfflinePackage diamond.
             * @member {number|Long} diamond
             * @memberof breacher.v2.OfflinePackage
             * @instance
             */
            OfflinePackage.prototype.diamond = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new OfflinePackage instance using the specified properties.
             * @function create
             * @memberof breacher.v2.OfflinePackage
             * @static
             * @param {breacher.v2.IOfflinePackage=} [properties] Properties to set
             * @returns {breacher.v2.OfflinePackage} OfflinePackage instance
             */
            OfflinePackage.create = function create(properties) {
                return new OfflinePackage(properties);
            };

            /**
             * Encodes the specified OfflinePackage message. Does not implicitly {@link breacher.v2.OfflinePackage.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.OfflinePackage
             * @static
             * @param {breacher.v2.IOfflinePackage} message OfflinePackage message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OfflinePackage.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.seconds);
                if (message.diamond != null && Object.hasOwnProperty.call(message, "diamond"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.diamond);
                return writer;
            };

            /**
             * Encodes the specified OfflinePackage message, length delimited. Does not implicitly {@link breacher.v2.OfflinePackage.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.OfflinePackage
             * @static
             * @param {breacher.v2.IOfflinePackage} message OfflinePackage message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OfflinePackage.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OfflinePackage message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.OfflinePackage
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.OfflinePackage} OfflinePackage
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OfflinePackage.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.OfflinePackage();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.seconds = reader.int64();
                            break;
                        }
                    case 3: {
                            message.diamond = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OfflinePackage message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.OfflinePackage
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.OfflinePackage} OfflinePackage
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OfflinePackage.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OfflinePackage message.
             * @function verify
             * @memberof breacher.v2.OfflinePackage
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OfflinePackage.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                        return "seconds: integer|Long expected";
                if (message.diamond != null && message.hasOwnProperty("diamond"))
                    if (!$util.isInteger(message.diamond) && !(message.diamond && $util.isInteger(message.diamond.low) && $util.isInteger(message.diamond.high)))
                        return "diamond: integer|Long expected";
                return null;
            };

            /**
             * Creates an OfflinePackage message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.OfflinePackage
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.OfflinePackage} OfflinePackage
             */
            OfflinePackage.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.OfflinePackage)
                    return object;
                let message = new $root.breacher.v2.OfflinePackage();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.seconds != null)
                    if ($util.Long)
                        (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.diamond != null)
                    if ($util.Long)
                        (message.diamond = $util.Long.fromValue(object.diamond)).unsigned = false;
                    else if (typeof object.diamond === "string")
                        message.diamond = parseInt(object.diamond, 10);
                    else if (typeof object.diamond === "number")
                        message.diamond = object.diamond;
                    else if (typeof object.diamond === "object")
                        message.diamond = new $util.LongBits(object.diamond.low >>> 0, object.diamond.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from an OfflinePackage message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.OfflinePackage
             * @static
             * @param {breacher.v2.OfflinePackage} message OfflinePackage
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OfflinePackage.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.id = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seconds = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.diamond = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.diamond = options.longs === String ? "0" : 0;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (typeof message.seconds === "number")
                        object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.diamond != null && message.hasOwnProperty("diamond"))
                    if (typeof message.diamond === "number")
                        object.diamond = options.longs === String ? String(message.diamond) : message.diamond;
                    else
                        object.diamond = options.longs === String ? $util.Long.prototype.toString.call(message.diamond) : options.longs === Number ? new $util.LongBits(message.diamond.low >>> 0, message.diamond.high >>> 0).toNumber() : message.diamond;
                return object;
            };

            /**
             * Converts this OfflinePackage to JSON.
             * @function toJSON
             * @memberof breacher.v2.OfflinePackage
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OfflinePackage.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OfflinePackage
             * @function getTypeUrl
             * @memberof breacher.v2.OfflinePackage
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OfflinePackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.OfflinePackage";
            };

            return OfflinePackage;
        })();

        v2.OfflineAutomationSkill = (function() {

            /**
             * Properties of an OfflineAutomationSkill.
             * @memberof breacher.v2
             * @interface IOfflineAutomationSkill
             * @property {string|null} [skillId] OfflineAutomationSkill skillId
             * @property {boolean|null} [enabled] OfflineAutomationSkill enabled
             * @property {number|null} [priority] OfflineAutomationSkill priority
             * @property {string|null} [condition] OfflineAutomationSkill condition
             * @property {number|null} [threshold] OfflineAutomationSkill threshold
             */

            /**
             * Constructs a new OfflineAutomationSkill.
             * @memberof breacher.v2
             * @classdesc Represents an OfflineAutomationSkill.
             * @implements IOfflineAutomationSkill
             * @constructor
             * @param {breacher.v2.IOfflineAutomationSkill=} [properties] Properties to set
             */
            function OfflineAutomationSkill(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OfflineAutomationSkill skillId.
             * @member {string} skillId
             * @memberof breacher.v2.OfflineAutomationSkill
             * @instance
             */
            OfflineAutomationSkill.prototype.skillId = "";

            /**
             * OfflineAutomationSkill enabled.
             * @member {boolean} enabled
             * @memberof breacher.v2.OfflineAutomationSkill
             * @instance
             */
            OfflineAutomationSkill.prototype.enabled = false;

            /**
             * OfflineAutomationSkill priority.
             * @member {number} priority
             * @memberof breacher.v2.OfflineAutomationSkill
             * @instance
             */
            OfflineAutomationSkill.prototype.priority = 0;

            /**
             * OfflineAutomationSkill condition.
             * @member {string} condition
             * @memberof breacher.v2.OfflineAutomationSkill
             * @instance
             */
            OfflineAutomationSkill.prototype.condition = "";

            /**
             * OfflineAutomationSkill threshold.
             * @member {number} threshold
             * @memberof breacher.v2.OfflineAutomationSkill
             * @instance
             */
            OfflineAutomationSkill.prototype.threshold = 0;

            /**
             * Creates a new OfflineAutomationSkill instance using the specified properties.
             * @function create
             * @memberof breacher.v2.OfflineAutomationSkill
             * @static
             * @param {breacher.v2.IOfflineAutomationSkill=} [properties] Properties to set
             * @returns {breacher.v2.OfflineAutomationSkill} OfflineAutomationSkill instance
             */
            OfflineAutomationSkill.create = function create(properties) {
                return new OfflineAutomationSkill(properties);
            };

            /**
             * Encodes the specified OfflineAutomationSkill message. Does not implicitly {@link breacher.v2.OfflineAutomationSkill.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.OfflineAutomationSkill
             * @static
             * @param {breacher.v2.IOfflineAutomationSkill} message OfflineAutomationSkill message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OfflineAutomationSkill.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.skillId != null && Object.hasOwnProperty.call(message, "skillId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.skillId);
                if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.enabled);
                if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.priority);
                if (message.condition != null && Object.hasOwnProperty.call(message, "condition"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.condition);
                if (message.threshold != null && Object.hasOwnProperty.call(message, "threshold"))
                    writer.uint32(/* id 5, wireType 1 =*/41).double(message.threshold);
                return writer;
            };

            /**
             * Encodes the specified OfflineAutomationSkill message, length delimited. Does not implicitly {@link breacher.v2.OfflineAutomationSkill.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.OfflineAutomationSkill
             * @static
             * @param {breacher.v2.IOfflineAutomationSkill} message OfflineAutomationSkill message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OfflineAutomationSkill.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OfflineAutomationSkill message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.OfflineAutomationSkill
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.OfflineAutomationSkill} OfflineAutomationSkill
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OfflineAutomationSkill.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.OfflineAutomationSkill();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.skillId = reader.string();
                            break;
                        }
                    case 2: {
                            message.enabled = reader.bool();
                            break;
                        }
                    case 3: {
                            message.priority = reader.uint32();
                            break;
                        }
                    case 4: {
                            message.condition = reader.string();
                            break;
                        }
                    case 5: {
                            message.threshold = reader.double();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OfflineAutomationSkill message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.OfflineAutomationSkill
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.OfflineAutomationSkill} OfflineAutomationSkill
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OfflineAutomationSkill.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OfflineAutomationSkill message.
             * @function verify
             * @memberof breacher.v2.OfflineAutomationSkill
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OfflineAutomationSkill.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.skillId != null && message.hasOwnProperty("skillId"))
                    if (!$util.isString(message.skillId))
                        return "skillId: string expected";
                if (message.enabled != null && message.hasOwnProperty("enabled"))
                    if (typeof message.enabled !== "boolean")
                        return "enabled: boolean expected";
                if (message.priority != null && message.hasOwnProperty("priority"))
                    if (!$util.isInteger(message.priority))
                        return "priority: integer expected";
                if (message.condition != null && message.hasOwnProperty("condition"))
                    if (!$util.isString(message.condition))
                        return "condition: string expected";
                if (message.threshold != null && message.hasOwnProperty("threshold"))
                    if (typeof message.threshold !== "number")
                        return "threshold: number expected";
                return null;
            };

            /**
             * Creates an OfflineAutomationSkill message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.OfflineAutomationSkill
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.OfflineAutomationSkill} OfflineAutomationSkill
             */
            OfflineAutomationSkill.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.OfflineAutomationSkill)
                    return object;
                let message = new $root.breacher.v2.OfflineAutomationSkill();
                if (object.skillId != null)
                    message.skillId = String(object.skillId);
                if (object.enabled != null)
                    message.enabled = Boolean(object.enabled);
                if (object.priority != null)
                    message.priority = object.priority >>> 0;
                if (object.condition != null)
                    message.condition = String(object.condition);
                if (object.threshold != null)
                    message.threshold = Number(object.threshold);
                return message;
            };

            /**
             * Creates a plain object from an OfflineAutomationSkill message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.OfflineAutomationSkill
             * @static
             * @param {breacher.v2.OfflineAutomationSkill} message OfflineAutomationSkill
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OfflineAutomationSkill.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.skillId = "";
                    object.enabled = false;
                    object.priority = 0;
                    object.condition = "";
                    object.threshold = 0;
                }
                if (message.skillId != null && message.hasOwnProperty("skillId"))
                    object.skillId = message.skillId;
                if (message.enabled != null && message.hasOwnProperty("enabled"))
                    object.enabled = message.enabled;
                if (message.priority != null && message.hasOwnProperty("priority"))
                    object.priority = message.priority;
                if (message.condition != null && message.hasOwnProperty("condition"))
                    object.condition = message.condition;
                if (message.threshold != null && message.hasOwnProperty("threshold"))
                    object.threshold = options.json && !isFinite(message.threshold) ? String(message.threshold) : message.threshold;
                return object;
            };

            /**
             * Converts this OfflineAutomationSkill to JSON.
             * @function toJSON
             * @memberof breacher.v2.OfflineAutomationSkill
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OfflineAutomationSkill.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OfflineAutomationSkill
             * @function getTypeUrl
             * @memberof breacher.v2.OfflineAutomationSkill
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OfflineAutomationSkill.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.OfflineAutomationSkill";
            };

            return OfflineAutomationSkill;
        })();

        v2.OfflineAutomationPolicy = (function() {

            /**
             * Properties of an OfflineAutomationPolicy.
             * @memberof breacher.v2
             * @interface IOfflineAutomationPolicy
             * @property {number|null} [version] OfflineAutomationPolicy version
             * @property {Array.<breacher.v2.IOfflineAutomationSkill>|null} [skills] OfflineAutomationPolicy skills
             * @property {boolean|null} [openChest] OfflineAutomationPolicy openChest
             * @property {boolean|null} [lockRows] OfflineAutomationPolicy lockRows
             * @property {number|null} [retreatHpRatio] OfflineAutomationPolicy retreatHpRatio
             * @property {number|null} [retreatDepth] OfflineAutomationPolicy retreatDepth
             */

            /**
             * Constructs a new OfflineAutomationPolicy.
             * @memberof breacher.v2
             * @classdesc Represents an OfflineAutomationPolicy.
             * @implements IOfflineAutomationPolicy
             * @constructor
             * @param {breacher.v2.IOfflineAutomationPolicy=} [properties] Properties to set
             */
            function OfflineAutomationPolicy(properties) {
                this.skills = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OfflineAutomationPolicy version.
             * @member {number} version
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @instance
             */
            OfflineAutomationPolicy.prototype.version = 0;

            /**
             * OfflineAutomationPolicy skills.
             * @member {Array.<breacher.v2.IOfflineAutomationSkill>} skills
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @instance
             */
            OfflineAutomationPolicy.prototype.skills = $util.emptyArray;

            /**
             * OfflineAutomationPolicy openChest.
             * @member {boolean} openChest
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @instance
             */
            OfflineAutomationPolicy.prototype.openChest = false;

            /**
             * OfflineAutomationPolicy lockRows.
             * @member {boolean} lockRows
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @instance
             */
            OfflineAutomationPolicy.prototype.lockRows = false;

            /**
             * OfflineAutomationPolicy retreatHpRatio.
             * @member {number} retreatHpRatio
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @instance
             */
            OfflineAutomationPolicy.prototype.retreatHpRatio = 0;

            /**
             * OfflineAutomationPolicy retreatDepth.
             * @member {number} retreatDepth
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @instance
             */
            OfflineAutomationPolicy.prototype.retreatDepth = 0;

            /**
             * Creates a new OfflineAutomationPolicy instance using the specified properties.
             * @function create
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @static
             * @param {breacher.v2.IOfflineAutomationPolicy=} [properties] Properties to set
             * @returns {breacher.v2.OfflineAutomationPolicy} OfflineAutomationPolicy instance
             */
            OfflineAutomationPolicy.create = function create(properties) {
                return new OfflineAutomationPolicy(properties);
            };

            /**
             * Encodes the specified OfflineAutomationPolicy message. Does not implicitly {@link breacher.v2.OfflineAutomationPolicy.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @static
             * @param {breacher.v2.IOfflineAutomationPolicy} message OfflineAutomationPolicy message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OfflineAutomationPolicy.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.version);
                if (message.skills != null && message.skills.length)
                    for (let i = 0; i < message.skills.length; ++i)
                        $root.breacher.v2.OfflineAutomationSkill.encode(message.skills[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.openChest != null && Object.hasOwnProperty.call(message, "openChest"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.openChest);
                if (message.lockRows != null && Object.hasOwnProperty.call(message, "lockRows"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.lockRows);
                if (message.retreatHpRatio != null && Object.hasOwnProperty.call(message, "retreatHpRatio"))
                    writer.uint32(/* id 5, wireType 1 =*/41).double(message.retreatHpRatio);
                if (message.retreatDepth != null && Object.hasOwnProperty.call(message, "retreatDepth"))
                    writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.retreatDepth);
                return writer;
            };

            /**
             * Encodes the specified OfflineAutomationPolicy message, length delimited. Does not implicitly {@link breacher.v2.OfflineAutomationPolicy.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @static
             * @param {breacher.v2.IOfflineAutomationPolicy} message OfflineAutomationPolicy message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OfflineAutomationPolicy.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OfflineAutomationPolicy message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.OfflineAutomationPolicy} OfflineAutomationPolicy
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OfflineAutomationPolicy.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.OfflineAutomationPolicy();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.version = reader.uint32();
                            break;
                        }
                    case 2: {
                            if (!(message.skills && message.skills.length))
                                message.skills = [];
                            message.skills.push($root.breacher.v2.OfflineAutomationSkill.decode(reader, reader.uint32()));
                            break;
                        }
                    case 3: {
                            message.openChest = reader.bool();
                            break;
                        }
                    case 4: {
                            message.lockRows = reader.bool();
                            break;
                        }
                    case 5: {
                            message.retreatHpRatio = reader.double();
                            break;
                        }
                    case 6: {
                            message.retreatDepth = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OfflineAutomationPolicy message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.OfflineAutomationPolicy} OfflineAutomationPolicy
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OfflineAutomationPolicy.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OfflineAutomationPolicy message.
             * @function verify
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OfflineAutomationPolicy.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isInteger(message.version))
                        return "version: integer expected";
                if (message.skills != null && message.hasOwnProperty("skills")) {
                    if (!Array.isArray(message.skills))
                        return "skills: array expected";
                    for (let i = 0; i < message.skills.length; ++i) {
                        let error = $root.breacher.v2.OfflineAutomationSkill.verify(message.skills[i]);
                        if (error)
                            return "skills." + error;
                    }
                }
                if (message.openChest != null && message.hasOwnProperty("openChest"))
                    if (typeof message.openChest !== "boolean")
                        return "openChest: boolean expected";
                if (message.lockRows != null && message.hasOwnProperty("lockRows"))
                    if (typeof message.lockRows !== "boolean")
                        return "lockRows: boolean expected";
                if (message.retreatHpRatio != null && message.hasOwnProperty("retreatHpRatio"))
                    if (typeof message.retreatHpRatio !== "number")
                        return "retreatHpRatio: number expected";
                if (message.retreatDepth != null && message.hasOwnProperty("retreatDepth"))
                    if (!$util.isInteger(message.retreatDepth))
                        return "retreatDepth: integer expected";
                return null;
            };

            /**
             * Creates an OfflineAutomationPolicy message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.OfflineAutomationPolicy} OfflineAutomationPolicy
             */
            OfflineAutomationPolicy.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.OfflineAutomationPolicy)
                    return object;
                let message = new $root.breacher.v2.OfflineAutomationPolicy();
                if (object.version != null)
                    message.version = object.version >>> 0;
                if (object.skills) {
                    if (!Array.isArray(object.skills))
                        throw TypeError(".breacher.v2.OfflineAutomationPolicy.skills: array expected");
                    message.skills = [];
                    for (let i = 0; i < object.skills.length; ++i) {
                        if (typeof object.skills[i] !== "object")
                            throw TypeError(".breacher.v2.OfflineAutomationPolicy.skills: object expected");
                        message.skills[i] = $root.breacher.v2.OfflineAutomationSkill.fromObject(object.skills[i]);
                    }
                }
                if (object.openChest != null)
                    message.openChest = Boolean(object.openChest);
                if (object.lockRows != null)
                    message.lockRows = Boolean(object.lockRows);
                if (object.retreatHpRatio != null)
                    message.retreatHpRatio = Number(object.retreatHpRatio);
                if (object.retreatDepth != null)
                    message.retreatDepth = object.retreatDepth >>> 0;
                return message;
            };

            /**
             * Creates a plain object from an OfflineAutomationPolicy message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @static
             * @param {breacher.v2.OfflineAutomationPolicy} message OfflineAutomationPolicy
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OfflineAutomationPolicy.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.skills = [];
                if (options.defaults) {
                    object.version = 0;
                    object.openChest = false;
                    object.lockRows = false;
                    object.retreatHpRatio = 0;
                    object.retreatDepth = 0;
                }
                if (message.version != null && message.hasOwnProperty("version"))
                    object.version = message.version;
                if (message.skills && message.skills.length) {
                    object.skills = [];
                    for (let j = 0; j < message.skills.length; ++j)
                        object.skills[j] = $root.breacher.v2.OfflineAutomationSkill.toObject(message.skills[j], options);
                }
                if (message.openChest != null && message.hasOwnProperty("openChest"))
                    object.openChest = message.openChest;
                if (message.lockRows != null && message.hasOwnProperty("lockRows"))
                    object.lockRows = message.lockRows;
                if (message.retreatHpRatio != null && message.hasOwnProperty("retreatHpRatio"))
                    object.retreatHpRatio = options.json && !isFinite(message.retreatHpRatio) ? String(message.retreatHpRatio) : message.retreatHpRatio;
                if (message.retreatDepth != null && message.hasOwnProperty("retreatDepth"))
                    object.retreatDepth = message.retreatDepth;
                return object;
            };

            /**
             * Converts this OfflineAutomationPolicy to JSON.
             * @function toJSON
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OfflineAutomationPolicy.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OfflineAutomationPolicy
             * @function getTypeUrl
             * @memberof breacher.v2.OfflineAutomationPolicy
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OfflineAutomationPolicy.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.OfflineAutomationPolicy";
            };

            return OfflineAutomationPolicy;
        })();

        v2.OfflineQuotaView = (function() {

            /**
             * Properties of an OfflineQuotaView.
             * @memberof breacher.v2
             * @interface IOfflineQuotaView
             * @property {number|Long|null} [freeSeconds] OfflineQuotaView freeSeconds
             * @property {number|Long|null} [paidSeconds] OfflineQuotaView paidSeconds
             * @property {string|null} [preferredSource] OfflineQuotaView preferredSource
             * @property {string|null} [claimPeriod] OfflineQuotaView claimPeriod
             * @property {boolean|null} [claimAvailable] OfflineQuotaView claimAvailable
             * @property {number|Long|null} [nextClaimAtMs] OfflineQuotaView nextClaimAtMs
             * @property {number|Long|null} [version] OfflineQuotaView version
             */

            /**
             * Constructs a new OfflineQuotaView.
             * @memberof breacher.v2
             * @classdesc Represents an OfflineQuotaView.
             * @implements IOfflineQuotaView
             * @constructor
             * @param {breacher.v2.IOfflineQuotaView=} [properties] Properties to set
             */
            function OfflineQuotaView(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OfflineQuotaView freeSeconds.
             * @member {number|Long} freeSeconds
             * @memberof breacher.v2.OfflineQuotaView
             * @instance
             */
            OfflineQuotaView.prototype.freeSeconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OfflineQuotaView paidSeconds.
             * @member {number|Long} paidSeconds
             * @memberof breacher.v2.OfflineQuotaView
             * @instance
             */
            OfflineQuotaView.prototype.paidSeconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OfflineQuotaView preferredSource.
             * @member {string} preferredSource
             * @memberof breacher.v2.OfflineQuotaView
             * @instance
             */
            OfflineQuotaView.prototype.preferredSource = "";

            /**
             * OfflineQuotaView claimPeriod.
             * @member {string} claimPeriod
             * @memberof breacher.v2.OfflineQuotaView
             * @instance
             */
            OfflineQuotaView.prototype.claimPeriod = "";

            /**
             * OfflineQuotaView claimAvailable.
             * @member {boolean} claimAvailable
             * @memberof breacher.v2.OfflineQuotaView
             * @instance
             */
            OfflineQuotaView.prototype.claimAvailable = false;

            /**
             * OfflineQuotaView nextClaimAtMs.
             * @member {number|Long} nextClaimAtMs
             * @memberof breacher.v2.OfflineQuotaView
             * @instance
             */
            OfflineQuotaView.prototype.nextClaimAtMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OfflineQuotaView version.
             * @member {number|Long} version
             * @memberof breacher.v2.OfflineQuotaView
             * @instance
             */
            OfflineQuotaView.prototype.version = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new OfflineQuotaView instance using the specified properties.
             * @function create
             * @memberof breacher.v2.OfflineQuotaView
             * @static
             * @param {breacher.v2.IOfflineQuotaView=} [properties] Properties to set
             * @returns {breacher.v2.OfflineQuotaView} OfflineQuotaView instance
             */
            OfflineQuotaView.create = function create(properties) {
                return new OfflineQuotaView(properties);
            };

            /**
             * Encodes the specified OfflineQuotaView message. Does not implicitly {@link breacher.v2.OfflineQuotaView.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.OfflineQuotaView
             * @static
             * @param {breacher.v2.IOfflineQuotaView} message OfflineQuotaView message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OfflineQuotaView.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.freeSeconds != null && Object.hasOwnProperty.call(message, "freeSeconds"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.freeSeconds);
                if (message.paidSeconds != null && Object.hasOwnProperty.call(message, "paidSeconds"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.paidSeconds);
                if (message.preferredSource != null && Object.hasOwnProperty.call(message, "preferredSource"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.preferredSource);
                if (message.claimPeriod != null && Object.hasOwnProperty.call(message, "claimPeriod"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.claimPeriod);
                if (message.claimAvailable != null && Object.hasOwnProperty.call(message, "claimAvailable"))
                    writer.uint32(/* id 5, wireType 0 =*/40).bool(message.claimAvailable);
                if (message.nextClaimAtMs != null && Object.hasOwnProperty.call(message, "nextClaimAtMs"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int64(message.nextClaimAtMs);
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.version);
                return writer;
            };

            /**
             * Encodes the specified OfflineQuotaView message, length delimited. Does not implicitly {@link breacher.v2.OfflineQuotaView.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.OfflineQuotaView
             * @static
             * @param {breacher.v2.IOfflineQuotaView} message OfflineQuotaView message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OfflineQuotaView.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OfflineQuotaView message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.OfflineQuotaView
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.OfflineQuotaView} OfflineQuotaView
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OfflineQuotaView.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.OfflineQuotaView();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.freeSeconds = reader.int64();
                            break;
                        }
                    case 2: {
                            message.paidSeconds = reader.int64();
                            break;
                        }
                    case 3: {
                            message.preferredSource = reader.string();
                            break;
                        }
                    case 4: {
                            message.claimPeriod = reader.string();
                            break;
                        }
                    case 5: {
                            message.claimAvailable = reader.bool();
                            break;
                        }
                    case 6: {
                            message.nextClaimAtMs = reader.int64();
                            break;
                        }
                    case 7: {
                            message.version = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OfflineQuotaView message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.OfflineQuotaView
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.OfflineQuotaView} OfflineQuotaView
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OfflineQuotaView.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OfflineQuotaView message.
             * @function verify
             * @memberof breacher.v2.OfflineQuotaView
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OfflineQuotaView.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.freeSeconds != null && message.hasOwnProperty("freeSeconds"))
                    if (!$util.isInteger(message.freeSeconds) && !(message.freeSeconds && $util.isInteger(message.freeSeconds.low) && $util.isInteger(message.freeSeconds.high)))
                        return "freeSeconds: integer|Long expected";
                if (message.paidSeconds != null && message.hasOwnProperty("paidSeconds"))
                    if (!$util.isInteger(message.paidSeconds) && !(message.paidSeconds && $util.isInteger(message.paidSeconds.low) && $util.isInteger(message.paidSeconds.high)))
                        return "paidSeconds: integer|Long expected";
                if (message.preferredSource != null && message.hasOwnProperty("preferredSource"))
                    if (!$util.isString(message.preferredSource))
                        return "preferredSource: string expected";
                if (message.claimPeriod != null && message.hasOwnProperty("claimPeriod"))
                    if (!$util.isString(message.claimPeriod))
                        return "claimPeriod: string expected";
                if (message.claimAvailable != null && message.hasOwnProperty("claimAvailable"))
                    if (typeof message.claimAvailable !== "boolean")
                        return "claimAvailable: boolean expected";
                if (message.nextClaimAtMs != null && message.hasOwnProperty("nextClaimAtMs"))
                    if (!$util.isInteger(message.nextClaimAtMs) && !(message.nextClaimAtMs && $util.isInteger(message.nextClaimAtMs.low) && $util.isInteger(message.nextClaimAtMs.high)))
                        return "nextClaimAtMs: integer|Long expected";
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isInteger(message.version) && !(message.version && $util.isInteger(message.version.low) && $util.isInteger(message.version.high)))
                        return "version: integer|Long expected";
                return null;
            };

            /**
             * Creates an OfflineQuotaView message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.OfflineQuotaView
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.OfflineQuotaView} OfflineQuotaView
             */
            OfflineQuotaView.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.OfflineQuotaView)
                    return object;
                let message = new $root.breacher.v2.OfflineQuotaView();
                if (object.freeSeconds != null)
                    if ($util.Long)
                        (message.freeSeconds = $util.Long.fromValue(object.freeSeconds)).unsigned = false;
                    else if (typeof object.freeSeconds === "string")
                        message.freeSeconds = parseInt(object.freeSeconds, 10);
                    else if (typeof object.freeSeconds === "number")
                        message.freeSeconds = object.freeSeconds;
                    else if (typeof object.freeSeconds === "object")
                        message.freeSeconds = new $util.LongBits(object.freeSeconds.low >>> 0, object.freeSeconds.high >>> 0).toNumber();
                if (object.paidSeconds != null)
                    if ($util.Long)
                        (message.paidSeconds = $util.Long.fromValue(object.paidSeconds)).unsigned = false;
                    else if (typeof object.paidSeconds === "string")
                        message.paidSeconds = parseInt(object.paidSeconds, 10);
                    else if (typeof object.paidSeconds === "number")
                        message.paidSeconds = object.paidSeconds;
                    else if (typeof object.paidSeconds === "object")
                        message.paidSeconds = new $util.LongBits(object.paidSeconds.low >>> 0, object.paidSeconds.high >>> 0).toNumber();
                if (object.preferredSource != null)
                    message.preferredSource = String(object.preferredSource);
                if (object.claimPeriod != null)
                    message.claimPeriod = String(object.claimPeriod);
                if (object.claimAvailable != null)
                    message.claimAvailable = Boolean(object.claimAvailable);
                if (object.nextClaimAtMs != null)
                    if ($util.Long)
                        (message.nextClaimAtMs = $util.Long.fromValue(object.nextClaimAtMs)).unsigned = false;
                    else if (typeof object.nextClaimAtMs === "string")
                        message.nextClaimAtMs = parseInt(object.nextClaimAtMs, 10);
                    else if (typeof object.nextClaimAtMs === "number")
                        message.nextClaimAtMs = object.nextClaimAtMs;
                    else if (typeof object.nextClaimAtMs === "object")
                        message.nextClaimAtMs = new $util.LongBits(object.nextClaimAtMs.low >>> 0, object.nextClaimAtMs.high >>> 0).toNumber();
                if (object.version != null)
                    if ($util.Long)
                        (message.version = $util.Long.fromValue(object.version)).unsigned = true;
                    else if (typeof object.version === "string")
                        message.version = parseInt(object.version, 10);
                    else if (typeof object.version === "number")
                        message.version = object.version;
                    else if (typeof object.version === "object")
                        message.version = new $util.LongBits(object.version.low >>> 0, object.version.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from an OfflineQuotaView message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.OfflineQuotaView
             * @static
             * @param {breacher.v2.OfflineQuotaView} message OfflineQuotaView
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OfflineQuotaView.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.freeSeconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.freeSeconds = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.paidSeconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.paidSeconds = options.longs === String ? "0" : 0;
                    object.preferredSource = "";
                    object.claimPeriod = "";
                    object.claimAvailable = false;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.nextClaimAtMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.nextClaimAtMs = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.version = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.version = options.longs === String ? "0" : 0;
                }
                if (message.freeSeconds != null && message.hasOwnProperty("freeSeconds"))
                    if (typeof message.freeSeconds === "number")
                        object.freeSeconds = options.longs === String ? String(message.freeSeconds) : message.freeSeconds;
                    else
                        object.freeSeconds = options.longs === String ? $util.Long.prototype.toString.call(message.freeSeconds) : options.longs === Number ? new $util.LongBits(message.freeSeconds.low >>> 0, message.freeSeconds.high >>> 0).toNumber() : message.freeSeconds;
                if (message.paidSeconds != null && message.hasOwnProperty("paidSeconds"))
                    if (typeof message.paidSeconds === "number")
                        object.paidSeconds = options.longs === String ? String(message.paidSeconds) : message.paidSeconds;
                    else
                        object.paidSeconds = options.longs === String ? $util.Long.prototype.toString.call(message.paidSeconds) : options.longs === Number ? new $util.LongBits(message.paidSeconds.low >>> 0, message.paidSeconds.high >>> 0).toNumber() : message.paidSeconds;
                if (message.preferredSource != null && message.hasOwnProperty("preferredSource"))
                    object.preferredSource = message.preferredSource;
                if (message.claimPeriod != null && message.hasOwnProperty("claimPeriod"))
                    object.claimPeriod = message.claimPeriod;
                if (message.claimAvailable != null && message.hasOwnProperty("claimAvailable"))
                    object.claimAvailable = message.claimAvailable;
                if (message.nextClaimAtMs != null && message.hasOwnProperty("nextClaimAtMs"))
                    if (typeof message.nextClaimAtMs === "number")
                        object.nextClaimAtMs = options.longs === String ? String(message.nextClaimAtMs) : message.nextClaimAtMs;
                    else
                        object.nextClaimAtMs = options.longs === String ? $util.Long.prototype.toString.call(message.nextClaimAtMs) : options.longs === Number ? new $util.LongBits(message.nextClaimAtMs.low >>> 0, message.nextClaimAtMs.high >>> 0).toNumber() : message.nextClaimAtMs;
                if (message.version != null && message.hasOwnProperty("version"))
                    if (typeof message.version === "number")
                        object.version = options.longs === String ? String(message.version) : message.version;
                    else
                        object.version = options.longs === String ? $util.Long.prototype.toString.call(message.version) : options.longs === Number ? new $util.LongBits(message.version.low >>> 0, message.version.high >>> 0).toNumber(true) : message.version;
                return object;
            };

            /**
             * Converts this OfflineQuotaView to JSON.
             * @function toJSON
             * @memberof breacher.v2.OfflineQuotaView
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OfflineQuotaView.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OfflineQuotaView
             * @function getTypeUrl
             * @memberof breacher.v2.OfflineQuotaView
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OfflineQuotaView.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.OfflineQuotaView";
            };

            return OfflineQuotaView;
        })();

        v2.OfflineSessionView = (function() {

            /**
             * Properties of an OfflineSessionView.
             * @memberof breacher.v2
             * @interface IOfflineSessionView
             * @property {string|null} [runId] OfflineSessionView runId
             * @property {string|null} [status] OfflineSessionView status
             * @property {string|null} [quotaSource] OfflineSessionView quotaSource
             * @property {number|Long|null} [reservedSeconds] OfflineSessionView reservedSeconds
             * @property {number|Long|null} [consumedSeconds] OfflineSessionView consumedSeconds
             * @property {number|Long|null} [simulatedAtMs] OfflineSessionView simulatedAtMs
             * @property {number|Long|null} [operationCursor] OfflineSessionView operationCursor
             * @property {string|null} [engineVersion] OfflineSessionView engineVersion
             * @property {string|null} [simulationProfileId] OfflineSessionView simulationProfileId
             * @property {number|null} [policyVersion] OfflineSessionView policyVersion
             */

            /**
             * Constructs a new OfflineSessionView.
             * @memberof breacher.v2
             * @classdesc Represents an OfflineSessionView.
             * @implements IOfflineSessionView
             * @constructor
             * @param {breacher.v2.IOfflineSessionView=} [properties] Properties to set
             */
            function OfflineSessionView(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OfflineSessionView runId.
             * @member {string} runId
             * @memberof breacher.v2.OfflineSessionView
             * @instance
             */
            OfflineSessionView.prototype.runId = "";

            /**
             * OfflineSessionView status.
             * @member {string} status
             * @memberof breacher.v2.OfflineSessionView
             * @instance
             */
            OfflineSessionView.prototype.status = "";

            /**
             * OfflineSessionView quotaSource.
             * @member {string} quotaSource
             * @memberof breacher.v2.OfflineSessionView
             * @instance
             */
            OfflineSessionView.prototype.quotaSource = "";

            /**
             * OfflineSessionView reservedSeconds.
             * @member {number|Long} reservedSeconds
             * @memberof breacher.v2.OfflineSessionView
             * @instance
             */
            OfflineSessionView.prototype.reservedSeconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OfflineSessionView consumedSeconds.
             * @member {number|Long} consumedSeconds
             * @memberof breacher.v2.OfflineSessionView
             * @instance
             */
            OfflineSessionView.prototype.consumedSeconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OfflineSessionView simulatedAtMs.
             * @member {number|Long} simulatedAtMs
             * @memberof breacher.v2.OfflineSessionView
             * @instance
             */
            OfflineSessionView.prototype.simulatedAtMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OfflineSessionView operationCursor.
             * @member {number|Long} operationCursor
             * @memberof breacher.v2.OfflineSessionView
             * @instance
             */
            OfflineSessionView.prototype.operationCursor = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * OfflineSessionView engineVersion.
             * @member {string} engineVersion
             * @memberof breacher.v2.OfflineSessionView
             * @instance
             */
            OfflineSessionView.prototype.engineVersion = "";

            /**
             * OfflineSessionView simulationProfileId.
             * @member {string} simulationProfileId
             * @memberof breacher.v2.OfflineSessionView
             * @instance
             */
            OfflineSessionView.prototype.simulationProfileId = "";

            /**
             * OfflineSessionView policyVersion.
             * @member {number} policyVersion
             * @memberof breacher.v2.OfflineSessionView
             * @instance
             */
            OfflineSessionView.prototype.policyVersion = 0;

            /**
             * Creates a new OfflineSessionView instance using the specified properties.
             * @function create
             * @memberof breacher.v2.OfflineSessionView
             * @static
             * @param {breacher.v2.IOfflineSessionView=} [properties] Properties to set
             * @returns {breacher.v2.OfflineSessionView} OfflineSessionView instance
             */
            OfflineSessionView.create = function create(properties) {
                return new OfflineSessionView(properties);
            };

            /**
             * Encodes the specified OfflineSessionView message. Does not implicitly {@link breacher.v2.OfflineSessionView.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.OfflineSessionView
             * @static
             * @param {breacher.v2.IOfflineSessionView} message OfflineSessionView message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OfflineSessionView.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.runId != null && Object.hasOwnProperty.call(message, "runId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.runId);
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.status);
                if (message.quotaSource != null && Object.hasOwnProperty.call(message, "quotaSource"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.quotaSource);
                if (message.reservedSeconds != null && Object.hasOwnProperty.call(message, "reservedSeconds"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.reservedSeconds);
                if (message.consumedSeconds != null && Object.hasOwnProperty.call(message, "consumedSeconds"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int64(message.consumedSeconds);
                if (message.simulatedAtMs != null && Object.hasOwnProperty.call(message, "simulatedAtMs"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int64(message.simulatedAtMs);
                if (message.operationCursor != null && Object.hasOwnProperty.call(message, "operationCursor"))
                    writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.operationCursor);
                if (message.engineVersion != null && Object.hasOwnProperty.call(message, "engineVersion"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.engineVersion);
                if (message.simulationProfileId != null && Object.hasOwnProperty.call(message, "simulationProfileId"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.simulationProfileId);
                if (message.policyVersion != null && Object.hasOwnProperty.call(message, "policyVersion"))
                    writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.policyVersion);
                return writer;
            };

            /**
             * Encodes the specified OfflineSessionView message, length delimited. Does not implicitly {@link breacher.v2.OfflineSessionView.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.OfflineSessionView
             * @static
             * @param {breacher.v2.IOfflineSessionView} message OfflineSessionView message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OfflineSessionView.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OfflineSessionView message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.OfflineSessionView
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.OfflineSessionView} OfflineSessionView
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OfflineSessionView.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.OfflineSessionView();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.runId = reader.string();
                            break;
                        }
                    case 2: {
                            message.status = reader.string();
                            break;
                        }
                    case 3: {
                            message.quotaSource = reader.string();
                            break;
                        }
                    case 4: {
                            message.reservedSeconds = reader.int64();
                            break;
                        }
                    case 5: {
                            message.consumedSeconds = reader.int64();
                            break;
                        }
                    case 6: {
                            message.simulatedAtMs = reader.int64();
                            break;
                        }
                    case 7: {
                            message.operationCursor = reader.uint64();
                            break;
                        }
                    case 8: {
                            message.engineVersion = reader.string();
                            break;
                        }
                    case 9: {
                            message.simulationProfileId = reader.string();
                            break;
                        }
                    case 10: {
                            message.policyVersion = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OfflineSessionView message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.OfflineSessionView
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.OfflineSessionView} OfflineSessionView
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OfflineSessionView.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OfflineSessionView message.
             * @function verify
             * @memberof breacher.v2.OfflineSessionView
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OfflineSessionView.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.runId != null && message.hasOwnProperty("runId"))
                    if (!$util.isString(message.runId))
                        return "runId: string expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    if (!$util.isString(message.status))
                        return "status: string expected";
                if (message.quotaSource != null && message.hasOwnProperty("quotaSource"))
                    if (!$util.isString(message.quotaSource))
                        return "quotaSource: string expected";
                if (message.reservedSeconds != null && message.hasOwnProperty("reservedSeconds"))
                    if (!$util.isInteger(message.reservedSeconds) && !(message.reservedSeconds && $util.isInteger(message.reservedSeconds.low) && $util.isInteger(message.reservedSeconds.high)))
                        return "reservedSeconds: integer|Long expected";
                if (message.consumedSeconds != null && message.hasOwnProperty("consumedSeconds"))
                    if (!$util.isInteger(message.consumedSeconds) && !(message.consumedSeconds && $util.isInteger(message.consumedSeconds.low) && $util.isInteger(message.consumedSeconds.high)))
                        return "consumedSeconds: integer|Long expected";
                if (message.simulatedAtMs != null && message.hasOwnProperty("simulatedAtMs"))
                    if (!$util.isInteger(message.simulatedAtMs) && !(message.simulatedAtMs && $util.isInteger(message.simulatedAtMs.low) && $util.isInteger(message.simulatedAtMs.high)))
                        return "simulatedAtMs: integer|Long expected";
                if (message.operationCursor != null && message.hasOwnProperty("operationCursor"))
                    if (!$util.isInteger(message.operationCursor) && !(message.operationCursor && $util.isInteger(message.operationCursor.low) && $util.isInteger(message.operationCursor.high)))
                        return "operationCursor: integer|Long expected";
                if (message.engineVersion != null && message.hasOwnProperty("engineVersion"))
                    if (!$util.isString(message.engineVersion))
                        return "engineVersion: string expected";
                if (message.simulationProfileId != null && message.hasOwnProperty("simulationProfileId"))
                    if (!$util.isString(message.simulationProfileId))
                        return "simulationProfileId: string expected";
                if (message.policyVersion != null && message.hasOwnProperty("policyVersion"))
                    if (!$util.isInteger(message.policyVersion))
                        return "policyVersion: integer expected";
                return null;
            };

            /**
             * Creates an OfflineSessionView message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.OfflineSessionView
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.OfflineSessionView} OfflineSessionView
             */
            OfflineSessionView.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.OfflineSessionView)
                    return object;
                let message = new $root.breacher.v2.OfflineSessionView();
                if (object.runId != null)
                    message.runId = String(object.runId);
                if (object.status != null)
                    message.status = String(object.status);
                if (object.quotaSource != null)
                    message.quotaSource = String(object.quotaSource);
                if (object.reservedSeconds != null)
                    if ($util.Long)
                        (message.reservedSeconds = $util.Long.fromValue(object.reservedSeconds)).unsigned = false;
                    else if (typeof object.reservedSeconds === "string")
                        message.reservedSeconds = parseInt(object.reservedSeconds, 10);
                    else if (typeof object.reservedSeconds === "number")
                        message.reservedSeconds = object.reservedSeconds;
                    else if (typeof object.reservedSeconds === "object")
                        message.reservedSeconds = new $util.LongBits(object.reservedSeconds.low >>> 0, object.reservedSeconds.high >>> 0).toNumber();
                if (object.consumedSeconds != null)
                    if ($util.Long)
                        (message.consumedSeconds = $util.Long.fromValue(object.consumedSeconds)).unsigned = false;
                    else if (typeof object.consumedSeconds === "string")
                        message.consumedSeconds = parseInt(object.consumedSeconds, 10);
                    else if (typeof object.consumedSeconds === "number")
                        message.consumedSeconds = object.consumedSeconds;
                    else if (typeof object.consumedSeconds === "object")
                        message.consumedSeconds = new $util.LongBits(object.consumedSeconds.low >>> 0, object.consumedSeconds.high >>> 0).toNumber();
                if (object.simulatedAtMs != null)
                    if ($util.Long)
                        (message.simulatedAtMs = $util.Long.fromValue(object.simulatedAtMs)).unsigned = false;
                    else if (typeof object.simulatedAtMs === "string")
                        message.simulatedAtMs = parseInt(object.simulatedAtMs, 10);
                    else if (typeof object.simulatedAtMs === "number")
                        message.simulatedAtMs = object.simulatedAtMs;
                    else if (typeof object.simulatedAtMs === "object")
                        message.simulatedAtMs = new $util.LongBits(object.simulatedAtMs.low >>> 0, object.simulatedAtMs.high >>> 0).toNumber();
                if (object.operationCursor != null)
                    if ($util.Long)
                        (message.operationCursor = $util.Long.fromValue(object.operationCursor)).unsigned = true;
                    else if (typeof object.operationCursor === "string")
                        message.operationCursor = parseInt(object.operationCursor, 10);
                    else if (typeof object.operationCursor === "number")
                        message.operationCursor = object.operationCursor;
                    else if (typeof object.operationCursor === "object")
                        message.operationCursor = new $util.LongBits(object.operationCursor.low >>> 0, object.operationCursor.high >>> 0).toNumber(true);
                if (object.engineVersion != null)
                    message.engineVersion = String(object.engineVersion);
                if (object.simulationProfileId != null)
                    message.simulationProfileId = String(object.simulationProfileId);
                if (object.policyVersion != null)
                    message.policyVersion = object.policyVersion >>> 0;
                return message;
            };

            /**
             * Creates a plain object from an OfflineSessionView message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.OfflineSessionView
             * @static
             * @param {breacher.v2.OfflineSessionView} message OfflineSessionView
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OfflineSessionView.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.runId = "";
                    object.status = "";
                    object.quotaSource = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.reservedSeconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.reservedSeconds = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.consumedSeconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.consumedSeconds = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.simulatedAtMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.simulatedAtMs = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.operationCursor = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.operationCursor = options.longs === String ? "0" : 0;
                    object.engineVersion = "";
                    object.simulationProfileId = "";
                    object.policyVersion = 0;
                }
                if (message.runId != null && message.hasOwnProperty("runId"))
                    object.runId = message.runId;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = message.status;
                if (message.quotaSource != null && message.hasOwnProperty("quotaSource"))
                    object.quotaSource = message.quotaSource;
                if (message.reservedSeconds != null && message.hasOwnProperty("reservedSeconds"))
                    if (typeof message.reservedSeconds === "number")
                        object.reservedSeconds = options.longs === String ? String(message.reservedSeconds) : message.reservedSeconds;
                    else
                        object.reservedSeconds = options.longs === String ? $util.Long.prototype.toString.call(message.reservedSeconds) : options.longs === Number ? new $util.LongBits(message.reservedSeconds.low >>> 0, message.reservedSeconds.high >>> 0).toNumber() : message.reservedSeconds;
                if (message.consumedSeconds != null && message.hasOwnProperty("consumedSeconds"))
                    if (typeof message.consumedSeconds === "number")
                        object.consumedSeconds = options.longs === String ? String(message.consumedSeconds) : message.consumedSeconds;
                    else
                        object.consumedSeconds = options.longs === String ? $util.Long.prototype.toString.call(message.consumedSeconds) : options.longs === Number ? new $util.LongBits(message.consumedSeconds.low >>> 0, message.consumedSeconds.high >>> 0).toNumber() : message.consumedSeconds;
                if (message.simulatedAtMs != null && message.hasOwnProperty("simulatedAtMs"))
                    if (typeof message.simulatedAtMs === "number")
                        object.simulatedAtMs = options.longs === String ? String(message.simulatedAtMs) : message.simulatedAtMs;
                    else
                        object.simulatedAtMs = options.longs === String ? $util.Long.prototype.toString.call(message.simulatedAtMs) : options.longs === Number ? new $util.LongBits(message.simulatedAtMs.low >>> 0, message.simulatedAtMs.high >>> 0).toNumber() : message.simulatedAtMs;
                if (message.operationCursor != null && message.hasOwnProperty("operationCursor"))
                    if (typeof message.operationCursor === "number")
                        object.operationCursor = options.longs === String ? String(message.operationCursor) : message.operationCursor;
                    else
                        object.operationCursor = options.longs === String ? $util.Long.prototype.toString.call(message.operationCursor) : options.longs === Number ? new $util.LongBits(message.operationCursor.low >>> 0, message.operationCursor.high >>> 0).toNumber(true) : message.operationCursor;
                if (message.engineVersion != null && message.hasOwnProperty("engineVersion"))
                    object.engineVersion = message.engineVersion;
                if (message.simulationProfileId != null && message.hasOwnProperty("simulationProfileId"))
                    object.simulationProfileId = message.simulationProfileId;
                if (message.policyVersion != null && message.hasOwnProperty("policyVersion"))
                    object.policyVersion = message.policyVersion;
                return object;
            };

            /**
             * Converts this OfflineSessionView to JSON.
             * @function toJSON
             * @memberof breacher.v2.OfflineSessionView
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OfflineSessionView.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OfflineSessionView
             * @function getTypeUrl
             * @memberof breacher.v2.OfflineSessionView
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OfflineSessionView.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.OfflineSessionView";
            };

            return OfflineSessionView;
        })();

        v2.ReplayVectorRequest = (function() {

            /**
             * Properties of a ReplayVectorRequest.
             * @memberof breacher.v2
             * @interface IReplayVectorRequest
             * @property {number|null} [operations] ReplayVectorRequest operations
             * @property {number|Long|null} [seed] ReplayVectorRequest seed
             */

            /**
             * Constructs a new ReplayVectorRequest.
             * @memberof breacher.v2
             * @classdesc Represents a ReplayVectorRequest.
             * @implements IReplayVectorRequest
             * @constructor
             * @param {breacher.v2.IReplayVectorRequest=} [properties] Properties to set
             */
            function ReplayVectorRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReplayVectorRequest operations.
             * @member {number} operations
             * @memberof breacher.v2.ReplayVectorRequest
             * @instance
             */
            ReplayVectorRequest.prototype.operations = 0;

            /**
             * ReplayVectorRequest seed.
             * @member {number|Long} seed
             * @memberof breacher.v2.ReplayVectorRequest
             * @instance
             */
            ReplayVectorRequest.prototype.seed = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new ReplayVectorRequest instance using the specified properties.
             * @function create
             * @memberof breacher.v2.ReplayVectorRequest
             * @static
             * @param {breacher.v2.IReplayVectorRequest=} [properties] Properties to set
             * @returns {breacher.v2.ReplayVectorRequest} ReplayVectorRequest instance
             */
            ReplayVectorRequest.create = function create(properties) {
                return new ReplayVectorRequest(properties);
            };

            /**
             * Encodes the specified ReplayVectorRequest message. Does not implicitly {@link breacher.v2.ReplayVectorRequest.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.ReplayVectorRequest
             * @static
             * @param {breacher.v2.IReplayVectorRequest} message ReplayVectorRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReplayVectorRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.operations != null && Object.hasOwnProperty.call(message, "operations"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.operations);
                if (message.seed != null && Object.hasOwnProperty.call(message, "seed"))
                    writer.uint32(/* id 2, wireType 1 =*/17).fixed64(message.seed);
                return writer;
            };

            /**
             * Encodes the specified ReplayVectorRequest message, length delimited. Does not implicitly {@link breacher.v2.ReplayVectorRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.ReplayVectorRequest
             * @static
             * @param {breacher.v2.IReplayVectorRequest} message ReplayVectorRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReplayVectorRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReplayVectorRequest message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.ReplayVectorRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.ReplayVectorRequest} ReplayVectorRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReplayVectorRequest.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.ReplayVectorRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.operations = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.seed = reader.fixed64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReplayVectorRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.ReplayVectorRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.ReplayVectorRequest} ReplayVectorRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReplayVectorRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReplayVectorRequest message.
             * @function verify
             * @memberof breacher.v2.ReplayVectorRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReplayVectorRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.operations != null && message.hasOwnProperty("operations"))
                    if (!$util.isInteger(message.operations))
                        return "operations: integer expected";
                if (message.seed != null && message.hasOwnProperty("seed"))
                    if (!$util.isInteger(message.seed) && !(message.seed && $util.isInteger(message.seed.low) && $util.isInteger(message.seed.high)))
                        return "seed: integer|Long expected";
                return null;
            };

            /**
             * Creates a ReplayVectorRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.ReplayVectorRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.ReplayVectorRequest} ReplayVectorRequest
             */
            ReplayVectorRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.ReplayVectorRequest)
                    return object;
                let message = new $root.breacher.v2.ReplayVectorRequest();
                if (object.operations != null)
                    message.operations = object.operations >>> 0;
                if (object.seed != null)
                    if ($util.Long)
                        (message.seed = $util.Long.fromValue(object.seed)).unsigned = false;
                    else if (typeof object.seed === "string")
                        message.seed = parseInt(object.seed, 10);
                    else if (typeof object.seed === "number")
                        message.seed = object.seed;
                    else if (typeof object.seed === "object")
                        message.seed = new $util.LongBits(object.seed.low >>> 0, object.seed.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a ReplayVectorRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.ReplayVectorRequest
             * @static
             * @param {breacher.v2.ReplayVectorRequest} message ReplayVectorRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReplayVectorRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.operations = 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.seed = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seed = options.longs === String ? "0" : 0;
                }
                if (message.operations != null && message.hasOwnProperty("operations"))
                    object.operations = message.operations;
                if (message.seed != null && message.hasOwnProperty("seed"))
                    if (typeof message.seed === "number")
                        object.seed = options.longs === String ? String(message.seed) : message.seed;
                    else
                        object.seed = options.longs === String ? $util.Long.prototype.toString.call(message.seed) : options.longs === Number ? new $util.LongBits(message.seed.low >>> 0, message.seed.high >>> 0).toNumber() : message.seed;
                return object;
            };

            /**
             * Converts this ReplayVectorRequest to JSON.
             * @function toJSON
             * @memberof breacher.v2.ReplayVectorRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReplayVectorRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ReplayVectorRequest
             * @function getTypeUrl
             * @memberof breacher.v2.ReplayVectorRequest
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ReplayVectorRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.ReplayVectorRequest";
            };

            return ReplayVectorRequest;
        })();

        v2.ReplayVectorResult = (function() {

            /**
             * Properties of a ReplayVectorResult.
             * @memberof breacher.v2
             * @interface IReplayVectorResult
             * @property {Array.<number>|null} [board] ReplayVectorResult board
             * @property {number|Long|null} [rngState] ReplayVectorResult rngState
             * @property {number|Long|null} [consumed] ReplayVectorResult consumed
             * @property {Uint8Array|null} [stateHash] ReplayVectorResult stateHash
             * @property {breacher.v2.IWireError|null} [error] ReplayVectorResult error
             */

            /**
             * Constructs a new ReplayVectorResult.
             * @memberof breacher.v2
             * @classdesc Represents a ReplayVectorResult.
             * @implements IReplayVectorResult
             * @constructor
             * @param {breacher.v2.IReplayVectorResult=} [properties] Properties to set
             */
            function ReplayVectorResult(properties) {
                this.board = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReplayVectorResult board.
             * @member {Array.<number>} board
             * @memberof breacher.v2.ReplayVectorResult
             * @instance
             */
            ReplayVectorResult.prototype.board = $util.emptyArray;

            /**
             * ReplayVectorResult rngState.
             * @member {number|Long} rngState
             * @memberof breacher.v2.ReplayVectorResult
             * @instance
             */
            ReplayVectorResult.prototype.rngState = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * ReplayVectorResult consumed.
             * @member {number|Long} consumed
             * @memberof breacher.v2.ReplayVectorResult
             * @instance
             */
            ReplayVectorResult.prototype.consumed = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * ReplayVectorResult stateHash.
             * @member {Uint8Array} stateHash
             * @memberof breacher.v2.ReplayVectorResult
             * @instance
             */
            ReplayVectorResult.prototype.stateHash = $util.newBuffer([]);

            /**
             * ReplayVectorResult error.
             * @member {breacher.v2.IWireError|null|undefined} error
             * @memberof breacher.v2.ReplayVectorResult
             * @instance
             */
            ReplayVectorResult.prototype.error = null;

            /**
             * Creates a new ReplayVectorResult instance using the specified properties.
             * @function create
             * @memberof breacher.v2.ReplayVectorResult
             * @static
             * @param {breacher.v2.IReplayVectorResult=} [properties] Properties to set
             * @returns {breacher.v2.ReplayVectorResult} ReplayVectorResult instance
             */
            ReplayVectorResult.create = function create(properties) {
                return new ReplayVectorResult(properties);
            };

            /**
             * Encodes the specified ReplayVectorResult message. Does not implicitly {@link breacher.v2.ReplayVectorResult.verify|verify} messages.
             * @function encode
             * @memberof breacher.v2.ReplayVectorResult
             * @static
             * @param {breacher.v2.IReplayVectorResult} message ReplayVectorResult message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReplayVectorResult.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.board != null && message.board.length) {
                    writer.uint32(/* id 1, wireType 2 =*/10).fork();
                    for (let i = 0; i < message.board.length; ++i)
                        writer.uint32(message.board[i]);
                    writer.ldelim();
                }
                if (message.rngState != null && Object.hasOwnProperty.call(message, "rngState"))
                    writer.uint32(/* id 2, wireType 1 =*/17).fixed64(message.rngState);
                if (message.consumed != null && Object.hasOwnProperty.call(message, "consumed"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.consumed);
                if (message.stateHash != null && Object.hasOwnProperty.call(message, "stateHash"))
                    writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.stateHash);
                if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                    $root.breacher.v2.WireError.encode(message.error, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ReplayVectorResult message, length delimited. Does not implicitly {@link breacher.v2.ReplayVectorResult.verify|verify} messages.
             * @function encodeDelimited
             * @memberof breacher.v2.ReplayVectorResult
             * @static
             * @param {breacher.v2.IReplayVectorResult} message ReplayVectorResult message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReplayVectorResult.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReplayVectorResult message from the specified reader or buffer.
             * @function decode
             * @memberof breacher.v2.ReplayVectorResult
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {breacher.v2.ReplayVectorResult} ReplayVectorResult
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReplayVectorResult.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.breacher.v2.ReplayVectorResult();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.board && message.board.length))
                                message.board = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.board.push(reader.uint32());
                            } else
                                message.board.push(reader.uint32());
                            break;
                        }
                    case 2: {
                            message.rngState = reader.fixed64();
                            break;
                        }
                    case 3: {
                            message.consumed = reader.uint64();
                            break;
                        }
                    case 4: {
                            message.stateHash = reader.bytes();
                            break;
                        }
                    case 5: {
                            message.error = $root.breacher.v2.WireError.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReplayVectorResult message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof breacher.v2.ReplayVectorResult
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {breacher.v2.ReplayVectorResult} ReplayVectorResult
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReplayVectorResult.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReplayVectorResult message.
             * @function verify
             * @memberof breacher.v2.ReplayVectorResult
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReplayVectorResult.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.board != null && message.hasOwnProperty("board")) {
                    if (!Array.isArray(message.board))
                        return "board: array expected";
                    for (let i = 0; i < message.board.length; ++i)
                        if (!$util.isInteger(message.board[i]))
                            return "board: integer[] expected";
                }
                if (message.rngState != null && message.hasOwnProperty("rngState"))
                    if (!$util.isInteger(message.rngState) && !(message.rngState && $util.isInteger(message.rngState.low) && $util.isInteger(message.rngState.high)))
                        return "rngState: integer|Long expected";
                if (message.consumed != null && message.hasOwnProperty("consumed"))
                    if (!$util.isInteger(message.consumed) && !(message.consumed && $util.isInteger(message.consumed.low) && $util.isInteger(message.consumed.high)))
                        return "consumed: integer|Long expected";
                if (message.stateHash != null && message.hasOwnProperty("stateHash"))
                    if (!(message.stateHash && typeof message.stateHash.length === "number" || $util.isString(message.stateHash)))
                        return "stateHash: buffer expected";
                if (message.error != null && message.hasOwnProperty("error")) {
                    let error = $root.breacher.v2.WireError.verify(message.error);
                    if (error)
                        return "error." + error;
                }
                return null;
            };

            /**
             * Creates a ReplayVectorResult message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof breacher.v2.ReplayVectorResult
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {breacher.v2.ReplayVectorResult} ReplayVectorResult
             */
            ReplayVectorResult.fromObject = function fromObject(object) {
                if (object instanceof $root.breacher.v2.ReplayVectorResult)
                    return object;
                let message = new $root.breacher.v2.ReplayVectorResult();
                if (object.board) {
                    if (!Array.isArray(object.board))
                        throw TypeError(".breacher.v2.ReplayVectorResult.board: array expected");
                    message.board = [];
                    for (let i = 0; i < object.board.length; ++i)
                        message.board[i] = object.board[i] >>> 0;
                }
                if (object.rngState != null)
                    if ($util.Long)
                        (message.rngState = $util.Long.fromValue(object.rngState)).unsigned = false;
                    else if (typeof object.rngState === "string")
                        message.rngState = parseInt(object.rngState, 10);
                    else if (typeof object.rngState === "number")
                        message.rngState = object.rngState;
                    else if (typeof object.rngState === "object")
                        message.rngState = new $util.LongBits(object.rngState.low >>> 0, object.rngState.high >>> 0).toNumber();
                if (object.consumed != null)
                    if ($util.Long)
                        (message.consumed = $util.Long.fromValue(object.consumed)).unsigned = true;
                    else if (typeof object.consumed === "string")
                        message.consumed = parseInt(object.consumed, 10);
                    else if (typeof object.consumed === "number")
                        message.consumed = object.consumed;
                    else if (typeof object.consumed === "object")
                        message.consumed = new $util.LongBits(object.consumed.low >>> 0, object.consumed.high >>> 0).toNumber(true);
                if (object.stateHash != null)
                    if (typeof object.stateHash === "string")
                        $util.base64.decode(object.stateHash, message.stateHash = $util.newBuffer($util.base64.length(object.stateHash)), 0);
                    else if (object.stateHash.length >= 0)
                        message.stateHash = object.stateHash;
                if (object.error != null) {
                    if (typeof object.error !== "object")
                        throw TypeError(".breacher.v2.ReplayVectorResult.error: object expected");
                    message.error = $root.breacher.v2.WireError.fromObject(object.error);
                }
                return message;
            };

            /**
             * Creates a plain object from a ReplayVectorResult message. Also converts values to other types if specified.
             * @function toObject
             * @memberof breacher.v2.ReplayVectorResult
             * @static
             * @param {breacher.v2.ReplayVectorResult} message ReplayVectorResult
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReplayVectorResult.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.board = [];
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.rngState = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.rngState = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.consumed = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.consumed = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.stateHash = "";
                    else {
                        object.stateHash = [];
                        if (options.bytes !== Array)
                            object.stateHash = $util.newBuffer(object.stateHash);
                    }
                    object.error = null;
                }
                if (message.board && message.board.length) {
                    object.board = [];
                    for (let j = 0; j < message.board.length; ++j)
                        object.board[j] = message.board[j];
                }
                if (message.rngState != null && message.hasOwnProperty("rngState"))
                    if (typeof message.rngState === "number")
                        object.rngState = options.longs === String ? String(message.rngState) : message.rngState;
                    else
                        object.rngState = options.longs === String ? $util.Long.prototype.toString.call(message.rngState) : options.longs === Number ? new $util.LongBits(message.rngState.low >>> 0, message.rngState.high >>> 0).toNumber() : message.rngState;
                if (message.consumed != null && message.hasOwnProperty("consumed"))
                    if (typeof message.consumed === "number")
                        object.consumed = options.longs === String ? String(message.consumed) : message.consumed;
                    else
                        object.consumed = options.longs === String ? $util.Long.prototype.toString.call(message.consumed) : options.longs === Number ? new $util.LongBits(message.consumed.low >>> 0, message.consumed.high >>> 0).toNumber(true) : message.consumed;
                if (message.stateHash != null && message.hasOwnProperty("stateHash"))
                    object.stateHash = options.bytes === String ? $util.base64.encode(message.stateHash, 0, message.stateHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.stateHash) : message.stateHash;
                if (message.error != null && message.hasOwnProperty("error"))
                    object.error = $root.breacher.v2.WireError.toObject(message.error, options);
                return object;
            };

            /**
             * Converts this ReplayVectorResult to JSON.
             * @function toJSON
             * @memberof breacher.v2.ReplayVectorResult
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReplayVectorResult.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ReplayVectorResult
             * @function getTypeUrl
             * @memberof breacher.v2.ReplayVectorResult
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ReplayVectorResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/breacher.v2.ReplayVectorResult";
            };

            return ReplayVectorResult;
        })();

        return v2;
    })();

    return breacher;
})();

export { $root as default };
